// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_comp_plan_cfg.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  StcsCalcItemStatusCode,
  stcsCalcItemStatusCodeFromJSON,
  stcsCalcItemStatusCodeToJSON,
  StcsDisplayValueTypeEnum,
  stcsDisplayValueTypeEnumFromJSON,
  stcsDisplayValueTypeEnumToJSON,
  StcsFpnaAggregationEnum,
  stcsFpnaAggregationEnumFromJSON,
  stcsFpnaAggregationEnumToJSON,
  StcsFpnaTypeEnum,
  stcsFpnaTypeEnumFromJSON,
  stcsFpnaTypeEnumToJSON,
  StcsFstmtEnum,
  stcsFstmtEnumFromJSON,
  stcsFstmtEnumToJSON,
} from "./stcs_enums.entity";
import { StcsI18nLabelMap } from "./stcs_i18n.entity";

export const protobufPackage = "stcs_cmw";

/** PlanItemLogicEnum represents the different types of item logic */
export enum PlanItemLogicEnum {
  PLAN_ITEM_LOGIC_ENUM_UNSPECIFIED = 0,
  PLAN_ITEM_LOGIC_ENUM_POS_INPUT_ADD = 1,
  PLAN_ITEM_LOGIC_ENUM_POS_INPUT_SUB_IN_CHANGE = 2,
  UNRECOGNIZED = -1,
}

export function planItemLogicEnumFromJSON(object: any): PlanItemLogicEnum {
  switch (object) {
    case 0:
    case "PLAN_ITEM_LOGIC_ENUM_UNSPECIFIED":
      return PlanItemLogicEnum.PLAN_ITEM_LOGIC_ENUM_UNSPECIFIED;
    case 1:
    case "PLAN_ITEM_LOGIC_ENUM_POS_INPUT_ADD":
      return PlanItemLogicEnum.PLAN_ITEM_LOGIC_ENUM_POS_INPUT_ADD;
    case 2:
    case "PLAN_ITEM_LOGIC_ENUM_POS_INPUT_SUB_IN_CHANGE":
      return PlanItemLogicEnum.PLAN_ITEM_LOGIC_ENUM_POS_INPUT_SUB_IN_CHANGE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PlanItemLogicEnum.UNRECOGNIZED;
  }
}

export function planItemLogicEnumToJSON(object: PlanItemLogicEnum): string {
  switch (object) {
    case PlanItemLogicEnum.PLAN_ITEM_LOGIC_ENUM_UNSPECIFIED:
      return "PLAN_ITEM_LOGIC_ENUM_UNSPECIFIED";
    case PlanItemLogicEnum.PLAN_ITEM_LOGIC_ENUM_POS_INPUT_ADD:
      return "PLAN_ITEM_LOGIC_ENUM_POS_INPUT_ADD";
    case PlanItemLogicEnum.PLAN_ITEM_LOGIC_ENUM_POS_INPUT_SUB_IN_CHANGE:
      return "PLAN_ITEM_LOGIC_ENUM_POS_INPUT_SUB_IN_CHANGE";
    case PlanItemLogicEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** MethodologyEnum represents the different types of position logic */
export enum MethodologyEnum {
  /** PLAN_POS_LOGIC_UNSPECIFIED - Default value required by proto3 */
  PLAN_POS_LOGIC_UNSPECIFIED = 0,
  /** ANNUALLY_GROWTH_RATE - ✅ -> Not implemented yet */
  ANNUALLY_GROWTH_RATE = 1,
  CAPEX_CFG = 2,
  CAPEX_RES = 3,
  /** CHANGE_IN_REF_YEARLY - ✅ -> ManualInChangeRefYearlyStrategy / CHANGE_IN_REF_YEARLY / manual_in_change_ref_yearly */
  CHANGE_IN_REF_YEARLY = 4,
  DIO_REVERSE_FORMULA = 5,
  DPO_REVERSE_FORMULA = 6,
  DSO_REVERSE_FORMULA = 7,
  /** FORMULA_BASED - ✅ -> FstmtExprStrategy / FORMULA_BASED / formula_based */
  FORMULA_BASED = 8,
  FTE_X_AVG_ALL_IN_COSTS = 9,
  INTEREST_BARING_LIABILITY_LOAN_CFG = 10,
  INTEREST_BARING_LIABILITY_LOAN_RES = 11,
  INTEREST_ON_CASH = 12,
  IN_PERC_OF_ACCOUNT = 13,
  /** MANUAL_DEC_INPUT - ✅ -> ManualDecInputStrategy / manual_dec_input / MANUAL_DEC_INPUT */
  MANUAL_DEC_INPUT = 14,
  /** MANUAL_DEC_INPUT_IN_CHANGE - ✅ -> ManualDecInputInChangeStrategy / MANUAL_DEC_INPUT_IN_CHANGE / manual_dec_input_in_change */
  MANUAL_DEC_INPUT_IN_CHANGE = 15,
  MANUAL_PERC_INPUT = 16,
  /** MONTHLY_GROWTH_RATE - ✅ -> MonthlyGrowthRateStrategy / MONTHLY_GROWTH_RATE / monthly_growth_rate */
  MONTHLY_GROWTH_RATE = 17,
  /** RETAINED_EARNINGS - ✅ -> PlanItemPosLogicRetainedEarningsStrategy / RETAINED_EARNINGS / retained_earnings */
  RETAINED_EARNINGS = 18,
  TAX_RATE_ON_FSTMT = 19,
  UNRECOGNIZED = -1,
}

export function methodologyEnumFromJSON(object: any): MethodologyEnum {
  switch (object) {
    case 0:
    case "PLAN_POS_LOGIC_UNSPECIFIED":
      return MethodologyEnum.PLAN_POS_LOGIC_UNSPECIFIED;
    case 1:
    case "ANNUALLY_GROWTH_RATE":
      return MethodologyEnum.ANNUALLY_GROWTH_RATE;
    case 2:
    case "CAPEX_CFG":
      return MethodologyEnum.CAPEX_CFG;
    case 3:
    case "CAPEX_RES":
      return MethodologyEnum.CAPEX_RES;
    case 4:
    case "CHANGE_IN_REF_YEARLY":
      return MethodologyEnum.CHANGE_IN_REF_YEARLY;
    case 5:
    case "DIO_REVERSE_FORMULA":
      return MethodologyEnum.DIO_REVERSE_FORMULA;
    case 6:
    case "DPO_REVERSE_FORMULA":
      return MethodologyEnum.DPO_REVERSE_FORMULA;
    case 7:
    case "DSO_REVERSE_FORMULA":
      return MethodologyEnum.DSO_REVERSE_FORMULA;
    case 8:
    case "FORMULA_BASED":
      return MethodologyEnum.FORMULA_BASED;
    case 9:
    case "FTE_X_AVG_ALL_IN_COSTS":
      return MethodologyEnum.FTE_X_AVG_ALL_IN_COSTS;
    case 10:
    case "INTEREST_BARING_LIABILITY_LOAN_CFG":
      return MethodologyEnum.INTEREST_BARING_LIABILITY_LOAN_CFG;
    case 11:
    case "INTEREST_BARING_LIABILITY_LOAN_RES":
      return MethodologyEnum.INTEREST_BARING_LIABILITY_LOAN_RES;
    case 12:
    case "INTEREST_ON_CASH":
      return MethodologyEnum.INTEREST_ON_CASH;
    case 13:
    case "IN_PERC_OF_ACCOUNT":
      return MethodologyEnum.IN_PERC_OF_ACCOUNT;
    case 14:
    case "MANUAL_DEC_INPUT":
      return MethodologyEnum.MANUAL_DEC_INPUT;
    case 15:
    case "MANUAL_DEC_INPUT_IN_CHANGE":
      return MethodologyEnum.MANUAL_DEC_INPUT_IN_CHANGE;
    case 16:
    case "MANUAL_PERC_INPUT":
      return MethodologyEnum.MANUAL_PERC_INPUT;
    case 17:
    case "MONTHLY_GROWTH_RATE":
      return MethodologyEnum.MONTHLY_GROWTH_RATE;
    case 18:
    case "RETAINED_EARNINGS":
      return MethodologyEnum.RETAINED_EARNINGS;
    case 19:
    case "TAX_RATE_ON_FSTMT":
      return MethodologyEnum.TAX_RATE_ON_FSTMT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MethodologyEnum.UNRECOGNIZED;
  }
}

export function methodologyEnumToJSON(object: MethodologyEnum): string {
  switch (object) {
    case MethodologyEnum.PLAN_POS_LOGIC_UNSPECIFIED:
      return "PLAN_POS_LOGIC_UNSPECIFIED";
    case MethodologyEnum.ANNUALLY_GROWTH_RATE:
      return "ANNUALLY_GROWTH_RATE";
    case MethodologyEnum.CAPEX_CFG:
      return "CAPEX_CFG";
    case MethodologyEnum.CAPEX_RES:
      return "CAPEX_RES";
    case MethodologyEnum.CHANGE_IN_REF_YEARLY:
      return "CHANGE_IN_REF_YEARLY";
    case MethodologyEnum.DIO_REVERSE_FORMULA:
      return "DIO_REVERSE_FORMULA";
    case MethodologyEnum.DPO_REVERSE_FORMULA:
      return "DPO_REVERSE_FORMULA";
    case MethodologyEnum.DSO_REVERSE_FORMULA:
      return "DSO_REVERSE_FORMULA";
    case MethodologyEnum.FORMULA_BASED:
      return "FORMULA_BASED";
    case MethodologyEnum.FTE_X_AVG_ALL_IN_COSTS:
      return "FTE_X_AVG_ALL_IN_COSTS";
    case MethodologyEnum.INTEREST_BARING_LIABILITY_LOAN_CFG:
      return "INTEREST_BARING_LIABILITY_LOAN_CFG";
    case MethodologyEnum.INTEREST_BARING_LIABILITY_LOAN_RES:
      return "INTEREST_BARING_LIABILITY_LOAN_RES";
    case MethodologyEnum.INTEREST_ON_CASH:
      return "INTEREST_ON_CASH";
    case MethodologyEnum.IN_PERC_OF_ACCOUNT:
      return "IN_PERC_OF_ACCOUNT";
    case MethodologyEnum.MANUAL_DEC_INPUT:
      return "MANUAL_DEC_INPUT";
    case MethodologyEnum.MANUAL_DEC_INPUT_IN_CHANGE:
      return "MANUAL_DEC_INPUT_IN_CHANGE";
    case MethodologyEnum.MANUAL_PERC_INPUT:
      return "MANUAL_PERC_INPUT";
    case MethodologyEnum.MONTHLY_GROWTH_RATE:
      return "MONTHLY_GROWTH_RATE";
    case MethodologyEnum.RETAINED_EARNINGS:
      return "RETAINED_EARNINGS";
    case MethodologyEnum.TAX_RATE_ON_FSTMT:
      return "TAX_RATE_ON_FSTMT";
    case MethodologyEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum KpiPosActivationEnum {
  /** KPA_UNSPECIFIED - Default: position always active (backward compatible) */
  KPA_UNSPECIFIED = 0,
  /** KPA_ACTUALS_ONLY - Active only when no plan data is available */
  KPA_ACTUALS_ONLY = 1,
  /** KPA_PLAN_ONLY - Active only when plan data is available */
  KPA_PLAN_ONLY = 2,
  /** KPA_BOTH - Active regardless of plan availability */
  KPA_BOTH = 3,
  UNRECOGNIZED = -1,
}

export function kpiPosActivationEnumFromJSON(object: any): KpiPosActivationEnum {
  switch (object) {
    case 0:
    case "KPA_UNSPECIFIED":
      return KpiPosActivationEnum.KPA_UNSPECIFIED;
    case 1:
    case "KPA_ACTUALS_ONLY":
      return KpiPosActivationEnum.KPA_ACTUALS_ONLY;
    case 2:
    case "KPA_PLAN_ONLY":
      return KpiPosActivationEnum.KPA_PLAN_ONLY;
    case 3:
    case "KPA_BOTH":
      return KpiPosActivationEnum.KPA_BOTH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return KpiPosActivationEnum.UNRECOGNIZED;
  }
}

export function kpiPosActivationEnumToJSON(object: KpiPosActivationEnum): string {
  switch (object) {
    case KpiPosActivationEnum.KPA_UNSPECIFIED:
      return "KPA_UNSPECIFIED";
    case KpiPosActivationEnum.KPA_ACTUALS_ONLY:
      return "KPA_ACTUALS_ONLY";
    case KpiPosActivationEnum.KPA_PLAN_ONLY:
      return "KPA_PLAN_ONLY";
    case KpiPosActivationEnum.KPA_BOTH:
      return "KPA_BOTH";
    case KpiPosActivationEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface StcsCompPlanCfg {
  /** Unique identifier for the plan configuration */
  id: string;
  /** Version string for the plan configuration */
  version: string;
  /** Metadata about the plan (creator, org, dates, etc.) */
  meta:
    | StcsCompPlanCfgMetaData
    | undefined;
  /** RowID to SeasonalityMap, defines seasonality for positions */
  seas_map: { [key: string]: SeasonalityMap };
  /** P&L items, keyed by row ID */
  pnl_map: { [key: string]: StcsCompPlanCfgItem };
  /** Balance sheet items, keyed by row ID */
  bs_map: { [key: string]: StcsCompPlanCfgItem };
  /** Custom i18n key for this plan */
  i18n_custom_key: string;
  /** i18n label mappings for UI display */
  i18n_map: { [key: string]: StcsI18nLabelMap };
  /** True if this is a draft plan */
  is_draft: boolean;
}

export interface StcsCompPlanCfg_SeasMapEntry {
  key: string;
  value: SeasonalityMap | undefined;
}

export interface StcsCompPlanCfg_PnlMapEntry {
  key: string;
  value: StcsCompPlanCfgItem | undefined;
}

export interface StcsCompPlanCfg_BsMapEntry {
  key: string;
  value: StcsCompPlanCfgItem | undefined;
}

export interface StcsCompPlanCfg_I18nMapEntry {
  key: string;
  value: StcsI18nLabelMap | undefined;
}

/** Metadata for a compensation plan configuration */
export interface StcsCompPlanCfgMetaData {
  /** User who created the plan */
  ref_id_user: string;
  /** Organization ID */
  ref_id_org: string;
  /** Company ID */
  ref_id_comp: string;
  /** Start date of the plan (ISO string) */
  fpna_begin_date_string: string;
  /** End date of the plan (ISO string) */
  fpna_end_date_string: string;
  /**
   * TODO
   * string plan_data_begin_date_string = 4; // Start date of the plan (ISO string)
   * string plan_data_end_date_string = 5; // End date of the plan (ISO string)
   */
  obj_created_iso_utc: string;
  /** Last update timestamp (UTC, ISO format) */
  obj_updated_iso_utc: string;
  /** Reference to a plan template, if any */
  ref_id_comp_plan_cfg_template?: string | undefined;
}

/** Seasonality mapping for a plan position */
export interface SeasonalityMap {
  /** Input seasonality values (e.g., month -> value) */
  seas_input_map: { [key: string]: number };
  /** Resulting seasonality values after processing */
  seas_res_map: { [key: string]: number };
}

export interface SeasonalityMap_SeasInputMapEntry {
  key: string;
  value: number;
}

export interface SeasonalityMap_SeasResMapEntry {
  key: string;
  value: number;
}

/** Configuration for a single plan item (row) */
export interface StcsCompPlanCfgItem {
  /** Financial Statement ID or match case to FSD */
  fstmt_id: string;
  /** Top-level grouping ID (e.g., P&L, BS) */
  level_1_id: string;
  /** Second-level grouping ID (e.g., account or category) */
  level_2_id: string;
  /** List of row IDs this item depends on */
  depends_on: string[];
  /** Financial statement type (enum) */
  fstmt_type: StcsFstmtEnum;
  /** True if the plan item has been calculated (internal) */
  is_calculated: boolean;
  /** Position map: key is position ID, value is PlanPosItem */
  pos_map: { [key: string]: PlanPosItem };
  /** Result values for this item (e.g., period -> value) */
  res_map: { [key: string]: number };
  /** If true, this item is calculated after others */
  run_last: boolean;
  /** Status of the plan item manually set to done (by user) */
  is_done: boolean;
  /** True if this is a structural item (not a data row) */
  is_struct_item: boolean;
  /** Logic type for this item (enum) */
  plan_item_logic_type: PlanItemLogicEnum;
  /** Status object for this position (code, message, overrides) */
  status?: StcsCalcItemStatus | undefined;
}

export interface StcsCompPlanCfgItem_PosMapEntry {
  key: string;
  value: PlanPosItem | undefined;
}

export interface StcsCompPlanCfgItem_ResMapEntry {
  key: string;
  value: number;
}

/** Represents a single plan position (main position) */
export interface PlanPosItem {
  pos_logic_type: MethodologyEnum;
  /** Financial statement type for this position */
  fstmt_type: StcsFstmtEnum;
  /** Index of this position in the plan */
  pos_index: number;
  /** True if this is a structural position */
  is_struct_item: boolean;
  /** Status object for this position (code, message, overrides) */
  status?:
    | StcsCalcItemStatus
    | undefined;
  /** Display value type for UI representation, not 1:1 related to logic type */
  display_value_type: StcsDisplayValueTypeEnum;
  /** Retained earnings strategy */
  retained_earnings?:
    | PlanItemStructPosRetainedEarnings
    | undefined;
  /** Manual decimal input strategy */
  manual_dec_input?:
    | PlanItemPosManualDecInput
    | undefined;
  /** Monthly growth rate strategy */
  monthly_growth_rate?:
    | PlanItemPosMonthlyGrowthRate
    | undefined;
  /** Manual decimal input in-change strategy */
  manual_dec_input_in_change?:
    | PlanItemPosManualDecInputInChange
    | undefined;
  /** Formula-based calculation strategy */
  formula_based?:
    | PlanItemPosFormulaBased
    | undefined;
  /** Annually growth rate strategy */
  annually_growth_rate?:
    | PlanItemPosLogicAnnuallyGrowthRate
    | undefined;
  /** Manual percent input strategy */
  manual_perc_input?:
    | PlanItemPosManualPercInput
    | undefined;
  /** Capex configuration */
  capex_cfg?:
    | PlanItemPosCapexCfg
    | undefined;
  /** Manual in-change (ref yearly) strategy */
  manual_in_change_ref_yearly?:
    | PlanItemPosManualInChangeRefYearly
    | undefined;
  /** Capex schedule result */
  capex_res?:
    | PlanItemPosCapexRes
    | undefined;
  /** DIO reverse formula */
  dio_reverse_formula?:
    | PlanItemPosDioReverseFormula
    | undefined;
  /** DPO reverse formula */
  dpo_reverse_formula?:
    | PlanItemPosDpoReverseFormula
    | undefined;
  /** DSO reverse formula */
  dso_reverse_formula?:
    | PlanItemPosDsoReverseFormula
    | undefined;
  /** FTE x avg all-in costs */
  fte_x_avg_all_in_costs?:
    | PlanItemPosLogicFTExAVGaLLInCosts
    | undefined;
  /** Interest-bearing loan config */
  interest_baring_liability_loan_cfg?:
    | PlanItemPosLogicInterestBaringLiabilityLoanCfg
    | undefined;
  /** Interest-bearing loan result */
  interest_baring_liability_loan_res?:
    | PlanItemPosLogicInterestBaringLiabilityLoanRes
    | undefined;
  /** Interest on cash */
  interest_on_cash?:
    | PlanItemPosLogicInterestOnCash
    | undefined;
  /** In % of account */
  in_perc_of_account?:
    | PlanItemPosLogicInPercOfAcc
    | undefined;
  /** Tax rate on fstmt */
  tax_rate_on_fstmt?: PlanItemPosLogicTaxRateOnFstmt | undefined;
}

/** Represents a sub-position within a plan pos (used for nested/child positions) */
export interface PlanSubPosItem {
  pos_logic_type: MethodologyEnum;
  /** Financial statement type for this sub-position */
  fstmt_type: StcsFstmtEnum;
  /** Index of this sub-position */
  pos_index: number;
  /** True if this is a structural sub-position */
  is_struct_item: boolean;
  /** Status object for this sub-position */
  status?:
    | StcsCalcItemStatus
    | undefined;
  /** Display value type for UI representation, not 1:1 related to logic type */
  display_value_type: StcsDisplayValueTypeEnum;
  /** Manual decimal input strategy */
  manual_dec_input?:
    | PlanItemPosManualDecInput
    | undefined;
  /** Formula-based calculation strategy */
  formula_based?:
    | PlanItemPosFormulaBased
    | undefined;
  /** Monthly growth rate strategy */
  monthly_growth_rate?:
    | PlanItemPosMonthlyGrowthRate
    | undefined;
  /** Manual percent input strategy */
  manual_perc_input?: PlanItemPosManualPercInput | undefined;
}

/** Status object for a plan position or sub-position */
export interface StcsCalcItemStatus {
  /** Status code */
  status_code: StcsCalcItemStatusCode;
  /** Optional status message or error details */
  message: string;
  /** Map of manual overrides (e.g., period -> value) */
  manual_override_map: { [key: string]: number };
  /** List of cycle path keys for tracking calculation cycles */
  cycle_path_key_list: string[];
}

export interface StcsCalcItemStatus_ManualOverrideMapEntry {
  key: string;
  value: number;
}

/** Internal Structural Position of Retained Earnings */
export interface PlanItemStructPosRetainedEarnings {
  pos_input_fstmt_id: string;
  /** result of the plan */
  pos_res_plan_map: { [key: string]: number };
}

export interface PlanItemStructPosRetainedEarnings_PosResPlanMapEntry {
  key: string;
  value: number;
}

/** Position type for manual input with change in reference yearly, e.g. "Profit/loss carryforward" */
export interface PlanItemPosManualInChangeRefYearly {
  pos_ref_id_level_1: string;
  pos_ref_id_level_2: string;
  /**  */
  pos_ref_fstmt_type: StcsFstmtEnum;
  pos_input_map: { [key: string]: InputManualMap };
  /** result of the reference year */
  pos_ref_result_map: { [key: string]: number };
  /** result of the plan */
  pos_res_plan_map: { [key: string]: number };
}

export interface PlanItemPosManualInChangeRefYearly_PosInputMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry {
  key: string;
  value: number;
}

/** ✅ -> ManualDecInputStrategy / MANUAL_DEC_INPUT / manual_dec_input */
export interface PlanItemPosManualDecInput {
  pos_input_map: { [key: string]: InputManualMap };
  pos_res_plan_map: { [key: string]: number };
}

export interface PlanItemPosManualDecInput_PosInputMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosManualDecInput_PosResPlanMapEntry {
  key: string;
  value: number;
}

/** ✅ -> MonthlyGrowthRateStrategy / MONTHLY_GROWTH_RATE / monthly_growth_rate */
export interface PlanItemPosMonthlyGrowthRate {
  pos_input_base_amount: number;
  pos_input_map: { [key: string]: InputManualMap };
  pos_res_plan_map: { [key: string]: number };
}

export interface PlanItemPosMonthlyGrowthRate_PosInputMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry {
  key: string;
  value: number;
}

/** ✅ -> ManualDecInputInChangeStrategy / MANUAL_DEC_INPUT_IN_CHANGE / manual_dec_input_in_change */
export interface PlanItemPosManualDecInputInChange {
  pos_input_map: { [key: string]: InputManualMap };
  pos_input_base_amount: number;
  pos_res_plan_map: { [key: string]: number };
}

export interface PlanItemPosManualDecInputInChange_PosInputMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosManualDecInputInChange_PosResPlanMapEntry {
  key: string;
  value: number;
}

/** ✅️ -> AnnuallyGrowthRateStrategy / ANNUALLY_GROWTH_RATE / annually_growth_rate */
export interface PlanItemPosLogicAnnuallyGrowthRate {
  pos_input_base_amount: number;
  pos_input_seas_key: string;
  pos_input_ytg_map: { [key: string]: InputManualMap };
  pos_input_growth_map: { [key: string]: number };
  pos_res_growth_map: { [key: string]: PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap };
  pos_res_plan_map: { [key: string]: number };
}

export interface PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry {
  key: string;
  value: PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap | undefined;
}

export interface PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap {
  growth_base: number;
  growth_res: number;
}

/** PlanItemPosManualPercInput message */
export interface PlanItemPosManualPercInput {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to PlanItemPosManualPercInput */
  pos_input_map: { [key: string]: InputManualMap };
}

export interface PlanItemPosManualPercInput_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosManualPercInput_PosInputMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

/** PlanItemPosCapexCfg message extending PlanPos */
export interface PlanItemPosCapexCfg {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to PlanItemPosCapexCfg */
  pos_input_capex_year: number;
  pos_input_capex_map: { [key: string]: InputManualMap };
  pos_res_capex_map: { [key: string]: number };
  pos_res_target: string;
  pos_res_target_plan_item_pos_id: string;
}

export interface PlanItemPosCapexCfg_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosCapexCfg_PosInputCapexMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosCapexCfg_PosResCapexMapEntry {
  key: string;
  value: number;
}

/** PlanItemPosDioReverseFormula message */
export interface PlanItemPosDioReverseFormula {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to PlanItemPosDioReverseFormula */
  pos_formula_based: PlanItemPosFormulaBased | undefined;
  pos_res_dio_map: { [key: string]: number };
  pos_input_map: { [key: string]: InputManualMap };
}

export interface PlanItemPosDioReverseFormula_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosDioReverseFormula_PosResDioMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosDioReverseFormula_PosInputMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

/** PlanItemPosDpoReverseFormula message */
export interface PlanItemPosDpoReverseFormula {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to PlanItemPosDpoReverseFormula */
  pos_formula_based: PlanItemPosFormulaBased | undefined;
  pos_res_dpo_map: { [key: string]: number };
  pos_input_map: { [key: string]: InputManualMap };
}

export interface PlanItemPosDpoReverseFormula_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosDpoReverseFormula_PosResDpoMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosDpoReverseFormula_PosInputMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

/** PlanItemPosDsoReverseFormula message */
export interface PlanItemPosDsoReverseFormula {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to PlanItemPosDsoReverseFormula */
  pos_formula_based: PlanItemPosFormulaBased | undefined;
  pos_res_dso_map: { [key: string]: number };
  pos_input_map: { [key: string]: InputManualMap };
}

export interface PlanItemPosDsoReverseFormula_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosDsoReverseFormula_PosResDsoMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosDsoReverseFormula_PosInputMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

/** InputManualMap message referenced by PlanItemPosCapexCfg */
export interface InputManualMap {
  manual_number_input: number;
}

export interface PlanItemPosFormulaBased {
  pos_input_base_amount: number;
  formula_based_input_list: FormulaBasedInput[];
  pos_res_plan_map: { [key: string]: number };
  sub_pos_map: { [key: string]: PlanSubPosItem };
  /** Status object for this position (code, message, overrides) */
  status?: StcsCalcItemStatus | undefined;
}

export interface PlanItemPosFormulaBased_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosFormulaBased_SubPosMapEntry {
  key: string;
  value: PlanSubPosItem | undefined;
}

/** PlanItemPosCapexRes message */
export interface PlanItemPosCapexRes {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to PlanItemPosCapexRes */
  pos_res_capex_pos_map: { [key: string]: PlanItemPosCapexRes_StringToFloatMapValue };
}

export interface PlanItemPosCapexRes_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosCapexRes_PosResCapexPosMapEntry {
  key: string;
  value: PlanItemPosCapexRes_StringToFloatMapValue | undefined;
}

/** For nested map in PlanItemPosCapexRes, we need to create a special value message */
export interface PlanItemPosCapexRes_StringToFloatMapValue {
  value: { [key: string]: number };
}

export interface PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry {
  key: string;
  value: number;
}

/** PlanItemPosLogicInterestBaringLiabilityLoanCfg message */
export interface PlanItemPosLogicInterestBaringLiabilityLoanCfg {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to Interest-bearing loan cfg */
  pos_input_res_target_plan_item_pos_id: string;
  pos_input_loan_period_type: string;
  pos_input_loan_period_begin_month: number;
  pos_input_loan_base: InputManualMap | undefined;
  pos_input_loan_change_map: { [key: string]: InputManualMap };
  pos_input_loan_interest_rate_map: { [key: string]: InputManualMap };
  pos_input_loan_interest_expense_map: { [key: string]: InputManualMap };
  pos_res_loan_interest_expense_monthly: { [key: string]: number };
  pos_res_loan_interest_expense: { [key: string]: number };
}

export interface PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry {
  key: string;
  value: number;
}

/** PlanItemPosLogicInterestBaringLiabilityLoanRes message */
export interface PlanItemPosLogicInterestBaringLiabilityLoanRes {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
}

export interface PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry {
  key: string;
  value: number;
}

/** PlanItemPosLogicInterestOnCash message */
export interface PlanItemPosLogicInterestOnCash {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to interest on cash */
  pos_input_map: { [key: string]: InputManualMap };
  pos_input_bs_cce_fstmt_id: string;
}

export interface PlanItemPosLogicInterestOnCash_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicInterestOnCash_PosInputMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

/** PlanItemPosLogicTaxRateOnFstmt message */
export interface PlanItemPosLogicTaxRateOnFstmt {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to tax rate on fstmt */
  pos_formula_based: PlanItemPosFormulaBased | undefined;
  pos_input_base: InputManualMap | undefined;
  pos_input_period_begin_month: number;
  pos_input_period_type: string;
  pos_input_tax_base_adj_map: { [key: string]: InputManualMap };
  pos_input_tax_rate_map: { [key: string]: InputManualMap };
  pos_res_tax_base: { [key: string]: number };
  pos_res_tax_res_monthly: { [key: string]: number };
}

export interface PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry {
  key: string;
  value: number;
}

/** PlanItemPosLogicInPercOfAcc message */
export interface PlanItemPosLogicInPercOfAcc {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to in-percentage-of-account */
  pos_formula_based: PlanItemPosFormulaBased | undefined;
  pos_input_map: { [key: string]: InputManualMap };
}

export interface PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicInPercOfAcc_PosInputMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

/** PlanItemPosLogicFTExAVGaLLInCosts message */
export interface PlanItemPosLogicFTExAVGaLLInCosts {
  /** Fields from parent PlanPos */
  is_struct_pos: boolean;
  pos_res_plan_map: { [key: string]: number };
  /** Fields specific to FTE x avg all-in costs */
  pos_input_fte_costs_base: InputManualMap | undefined;
  pos_input_fte_count_base: InputManualMap | undefined;
  pos_input_fte_avg_costs_pm_map: { [key: string]: InputManualMap };
  pos_input_fte_change_map: { [key: string]: InputManualMap };
  pos_res_fte_avg_costs_pm: number;
  pos_res_fte_count_map: { [key: string]: number };
  pos_res_fte_avg_costs_pm_map: { [key: string]: number };
  pos_res_fte_change_map: { [key: string]: number };
}

export interface PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry {
  key: string;
  value: InputManualMap | undefined;
}

export interface PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry {
  key: string;
  value: number;
}

export interface PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry {
  key: string;
  value: number;
}

export interface FormulaBasedInput {
  /** e.g., "+", "-", "*", "/" */
  math_op?:
    | string
    | undefined;
  /** Reference to another plan item or any other level outside of the current plan item */
  plan_ref_fstmt?:
    | FstmtRef
    | undefined;
  /** Reference to another level_2 and it's plan position */
  plan_ref_level_2_position?:
    | FormulaBasedInput_PlanRefLevel2Position
    | undefined;
  /** Ref to the same position (self-reference) within the same plan item */
  plan_ref_self_position?:
    | FormulaBasedInput_PlanRefSelfPosition
    | undefined;
  /** Ref to a position within the same plan item */
  plan_ref_position?:
    | FormulaBasedInput_PlanRefPosition
    | undefined;
  /** Ref to a sub position within the same plan item */
  plan_ref_sub_position?: FormulaBasedInput_PlanRefSubPosition | undefined;
}

export interface FormulaBasedInput_PlanRefLevel2Position {
  fstmt_type: StcsFstmtEnum;
  ref_id_level: string;
  ref_id_plan_position: string;
  offset_in_months: number;
  /** Status object for this position (code, message, overrides) */
  status?: StcsCalcItemStatus | undefined;
  fpna_period?: StcsFpnaPeriod | undefined;
}

export interface FormulaBasedInput_PlanRefPosition {
  fstmt_type: StcsFstmtEnum;
  ref_id_plan_position: string;
  offset_in_months: number;
  /** Status object for this position (code, message, overrides) */
  status?: StcsCalcItemStatus | undefined;
  fpna_period?: StcsFpnaPeriod | undefined;
}

export interface FormulaBasedInput_PlanRefSubPosition {
  fstmt_type: StcsFstmtEnum;
  ref_id_plan_sub_position: string;
  offset_in_months: number;
  /** Status object for this position (code, message, overrides) */
  status?: StcsCalcItemStatus | undefined;
  fpna_period?: StcsFpnaPeriod | undefined;
}

export interface FormulaBasedInput_PlanRefSelfPosition {
  offset_in_months: number;
  /** Status object for this position (code, message, overrides) */
  status?: StcsCalcItemStatus | undefined;
  fpna_period?: StcsFpnaPeriod | undefined;
}

export interface FstmtRef {
  fstmt_type: StcsFstmtEnum;
  ref_id_level: string;
  offset_in_months: number;
  fpna_type: StcsFpnaTypeEnum;
  fpna_period?:
    | StcsFpnaPeriod
    | undefined;
  /** Status for plan-level references */
  status?: StcsCalcItemStatus | undefined;
}

export interface FstmtRefAgg {
  fstmt_type: StcsFstmtEnum;
  ref_id_level: string;
  offset_in_months: number;
  fpna_type: StcsFpnaTypeEnum;
  fpna_period?:
    | StcsFpnaPeriod
    | undefined;
  /** Status for plan-level references */
  status?: StcsCalcItemStatus | undefined;
}

export interface StcsFpnaPeriod {
  in_months: number;
  agg_method: StcsFpnaAggregationEnum;
}

export interface StcsCompPlanCfgList {
  list: StcsCompPlanCfgList_StcsCompPlanCfgListItem[];
}

export interface StcsCompPlanCfgList_StcsCompPlanCfgListItem {
  display_name: string;
  fpna_begin_date_string: string;
  fpna_end_date_string: string;
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
  ref_id_comp_plan_cfg: string;
  ref_id_comp_plan_cfg_template: string;
  is_draft: boolean;
  version: string;
}

function createBaseStcsCompPlanCfg(): StcsCompPlanCfg {
  return {
    id: "",
    version: "",
    meta: undefined,
    seas_map: {},
    pnl_map: {},
    bs_map: {},
    i18n_custom_key: "",
    i18n_map: {},
    is_draft: false,
  };
}

export const StcsCompPlanCfg: MessageFns<StcsCompPlanCfg> = {
  encode(message: StcsCompPlanCfg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsCompPlanCfgMetaData.encode(message.meta, writer.uint32(26).fork()).join();
    }
    Object.entries(message.seas_map).forEach(([key, value]) => {
      StcsCompPlanCfg_SeasMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    Object.entries(message.pnl_map).forEach(([key, value]) => {
      StcsCompPlanCfg_PnlMapEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    Object.entries(message.bs_map).forEach(([key, value]) => {
      StcsCompPlanCfg_BsMapEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    if (message.i18n_custom_key !== "") {
      writer.uint32(58).string(message.i18n_custom_key);
    }
    Object.entries(message.i18n_map).forEach(([key, value]) => {
      StcsCompPlanCfg_I18nMapEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
    });
    if (message.is_draft !== false) {
      writer.uint32(72).bool(message.is_draft);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsCompPlanCfgMetaData.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = StcsCompPlanCfg_SeasMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.seas_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = StcsCompPlanCfg_PnlMapEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.pnl_map[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = StcsCompPlanCfg_BsMapEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.bs_map[entry6.key] = entry6.value;
          }
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.i18n_custom_key = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = StcsCompPlanCfg_I18nMapEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.i18n_map[entry8.key] = entry8.value;
          }
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.is_draft = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfg {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsCompPlanCfgMetaData.fromJSON(object.meta) : undefined,
      seas_map: isObject(object.seas_map)
        ? Object.entries(object.seas_map).reduce<{ [key: string]: SeasonalityMap }>((acc, [key, value]) => {
          acc[key] = SeasonalityMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      pnl_map: isObject(object.pnl_map)
        ? Object.entries(object.pnl_map).reduce<{ [key: string]: StcsCompPlanCfgItem }>((acc, [key, value]) => {
          acc[key] = StcsCompPlanCfgItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      bs_map: isObject(object.bs_map)
        ? Object.entries(object.bs_map).reduce<{ [key: string]: StcsCompPlanCfgItem }>((acc, [key, value]) => {
          acc[key] = StcsCompPlanCfgItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      i18n_custom_key: isSet(object.i18n_custom_key) ? globalThis.String(object.i18n_custom_key) : "",
      i18n_map: isObject(object.i18n_map)
        ? Object.entries(object.i18n_map).reduce<{ [key: string]: StcsI18nLabelMap }>((acc, [key, value]) => {
          acc[key] = StcsI18nLabelMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      is_draft: isSet(object.is_draft) ? globalThis.Boolean(object.is_draft) : false,
    };
  },

  toJSON(message: StcsCompPlanCfg): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsCompPlanCfgMetaData.toJSON(message.meta);
    }
    if (message.seas_map) {
      const entries = Object.entries(message.seas_map);
      if (entries.length > 0) {
        obj.seas_map = {};
        entries.forEach(([k, v]) => {
          obj.seas_map[k] = SeasonalityMap.toJSON(v);
        });
      }
    }
    if (message.pnl_map) {
      const entries = Object.entries(message.pnl_map);
      if (entries.length > 0) {
        obj.pnl_map = {};
        entries.forEach(([k, v]) => {
          obj.pnl_map[k] = StcsCompPlanCfgItem.toJSON(v);
        });
      }
    }
    if (message.bs_map) {
      const entries = Object.entries(message.bs_map);
      if (entries.length > 0) {
        obj.bs_map = {};
        entries.forEach(([k, v]) => {
          obj.bs_map[k] = StcsCompPlanCfgItem.toJSON(v);
        });
      }
    }
    if (message.i18n_custom_key !== "") {
      obj.i18n_custom_key = message.i18n_custom_key;
    }
    if (message.i18n_map) {
      const entries = Object.entries(message.i18n_map);
      if (entries.length > 0) {
        obj.i18n_map = {};
        entries.forEach(([k, v]) => {
          obj.i18n_map[k] = StcsI18nLabelMap.toJSON(v);
        });
      }
    }
    if (message.is_draft !== false) {
      obj.is_draft = message.is_draft;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfg>, I>>(base?: I): StcsCompPlanCfg {
    return StcsCompPlanCfg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfg>, I>>(object: I): StcsCompPlanCfg {
    const message = createBaseStcsCompPlanCfg();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsCompPlanCfgMetaData.fromPartial(object.meta)
      : undefined;
    message.seas_map = Object.entries(object.seas_map ?? {}).reduce<{ [key: string]: SeasonalityMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = SeasonalityMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.pnl_map = Object.entries(object.pnl_map ?? {}).reduce<{ [key: string]: StcsCompPlanCfgItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompPlanCfgItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.bs_map = Object.entries(object.bs_map ?? {}).reduce<{ [key: string]: StcsCompPlanCfgItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompPlanCfgItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.i18n_custom_key = object.i18n_custom_key ?? "";
    message.i18n_map = Object.entries(object.i18n_map ?? {}).reduce<{ [key: string]: StcsI18nLabelMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsI18nLabelMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.is_draft = object.is_draft ?? false;
    return message;
  },
};

function createBaseStcsCompPlanCfg_SeasMapEntry(): StcsCompPlanCfg_SeasMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompPlanCfg_SeasMapEntry: MessageFns<StcsCompPlanCfg_SeasMapEntry> = {
  encode(message: StcsCompPlanCfg_SeasMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      SeasonalityMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfg_SeasMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfg_SeasMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = SeasonalityMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfg_SeasMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? SeasonalityMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompPlanCfg_SeasMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = SeasonalityMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfg_SeasMapEntry>, I>>(base?: I): StcsCompPlanCfg_SeasMapEntry {
    return StcsCompPlanCfg_SeasMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfg_SeasMapEntry>, I>>(object: I): StcsCompPlanCfg_SeasMapEntry {
    const message = createBaseStcsCompPlanCfg_SeasMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? SeasonalityMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompPlanCfg_PnlMapEntry(): StcsCompPlanCfg_PnlMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompPlanCfg_PnlMapEntry: MessageFns<StcsCompPlanCfg_PnlMapEntry> = {
  encode(message: StcsCompPlanCfg_PnlMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompPlanCfgItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfg_PnlMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfg_PnlMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompPlanCfgItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfg_PnlMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompPlanCfgItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompPlanCfg_PnlMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompPlanCfgItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfg_PnlMapEntry>, I>>(base?: I): StcsCompPlanCfg_PnlMapEntry {
    return StcsCompPlanCfg_PnlMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfg_PnlMapEntry>, I>>(object: I): StcsCompPlanCfg_PnlMapEntry {
    const message = createBaseStcsCompPlanCfg_PnlMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompPlanCfgItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompPlanCfg_BsMapEntry(): StcsCompPlanCfg_BsMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompPlanCfg_BsMapEntry: MessageFns<StcsCompPlanCfg_BsMapEntry> = {
  encode(message: StcsCompPlanCfg_BsMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompPlanCfgItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfg_BsMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfg_BsMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompPlanCfgItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfg_BsMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompPlanCfgItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompPlanCfg_BsMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompPlanCfgItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfg_BsMapEntry>, I>>(base?: I): StcsCompPlanCfg_BsMapEntry {
    return StcsCompPlanCfg_BsMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfg_BsMapEntry>, I>>(object: I): StcsCompPlanCfg_BsMapEntry {
    const message = createBaseStcsCompPlanCfg_BsMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompPlanCfgItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompPlanCfg_I18nMapEntry(): StcsCompPlanCfg_I18nMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompPlanCfg_I18nMapEntry: MessageFns<StcsCompPlanCfg_I18nMapEntry> = {
  encode(message: StcsCompPlanCfg_I18nMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsI18nLabelMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfg_I18nMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfg_I18nMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsI18nLabelMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfg_I18nMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsI18nLabelMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompPlanCfg_I18nMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsI18nLabelMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfg_I18nMapEntry>, I>>(base?: I): StcsCompPlanCfg_I18nMapEntry {
    return StcsCompPlanCfg_I18nMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfg_I18nMapEntry>, I>>(object: I): StcsCompPlanCfg_I18nMapEntry {
    const message = createBaseStcsCompPlanCfg_I18nMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsI18nLabelMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompPlanCfgMetaData(): StcsCompPlanCfgMetaData {
  return {
    ref_id_user: "",
    ref_id_org: "",
    ref_id_comp: "",
    fpna_begin_date_string: "",
    fpna_end_date_string: "",
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
    ref_id_comp_plan_cfg_template: undefined,
  };
}

export const StcsCompPlanCfgMetaData: MessageFns<StcsCompPlanCfgMetaData> = {
  encode(message: StcsCompPlanCfgMetaData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.fpna_begin_date_string !== "") {
      writer.uint32(34).string(message.fpna_begin_date_string);
    }
    if (message.fpna_end_date_string !== "") {
      writer.uint32(42).string(message.fpna_end_date_string);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(50).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(58).string(message.obj_updated_iso_utc);
    }
    if (message.ref_id_comp_plan_cfg_template !== undefined) {
      writer.uint32(82).string(message.ref_id_comp_plan_cfg_template);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfgMetaData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfgMetaData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fpna_begin_date_string = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_end_date_string = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ref_id_comp_plan_cfg_template = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfgMetaData {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      fpna_begin_date_string: isSet(object.fpna_begin_date_string)
        ? globalThis.String(object.fpna_begin_date_string)
        : "",
      fpna_end_date_string: isSet(object.fpna_end_date_string) ? globalThis.String(object.fpna_end_date_string) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      ref_id_comp_plan_cfg_template: isSet(object.ref_id_comp_plan_cfg_template)
        ? globalThis.String(object.ref_id_comp_plan_cfg_template)
        : undefined,
    };
  },

  toJSON(message: StcsCompPlanCfgMetaData): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.fpna_begin_date_string !== "") {
      obj.fpna_begin_date_string = message.fpna_begin_date_string;
    }
    if (message.fpna_end_date_string !== "") {
      obj.fpna_end_date_string = message.fpna_end_date_string;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.ref_id_comp_plan_cfg_template !== undefined) {
      obj.ref_id_comp_plan_cfg_template = message.ref_id_comp_plan_cfg_template;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfgMetaData>, I>>(base?: I): StcsCompPlanCfgMetaData {
    return StcsCompPlanCfgMetaData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfgMetaData>, I>>(object: I): StcsCompPlanCfgMetaData {
    const message = createBaseStcsCompPlanCfgMetaData();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.fpna_begin_date_string = object.fpna_begin_date_string ?? "";
    message.fpna_end_date_string = object.fpna_end_date_string ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.ref_id_comp_plan_cfg_template = object.ref_id_comp_plan_cfg_template ?? undefined;
    return message;
  },
};

function createBaseSeasonalityMap(): SeasonalityMap {
  return { seas_input_map: {}, seas_res_map: {} };
}

export const SeasonalityMap: MessageFns<SeasonalityMap> = {
  encode(message: SeasonalityMap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.seas_input_map).forEach(([key, value]) => {
      SeasonalityMap_SeasInputMapEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    Object.entries(message.seas_res_map).forEach(([key, value]) => {
      SeasonalityMap_SeasResMapEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeasonalityMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeasonalityMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = SeasonalityMap_SeasInputMapEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.seas_input_map[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = SeasonalityMap_SeasResMapEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.seas_res_map[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SeasonalityMap {
    return {
      seas_input_map: isObject(object.seas_input_map)
        ? Object.entries(object.seas_input_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      seas_res_map: isObject(object.seas_res_map)
        ? Object.entries(object.seas_res_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: SeasonalityMap): unknown {
    const obj: any = {};
    if (message.seas_input_map) {
      const entries = Object.entries(message.seas_input_map);
      if (entries.length > 0) {
        obj.seas_input_map = {};
        entries.forEach(([k, v]) => {
          obj.seas_input_map[k] = v;
        });
      }
    }
    if (message.seas_res_map) {
      const entries = Object.entries(message.seas_res_map);
      if (entries.length > 0) {
        obj.seas_res_map = {};
        entries.forEach(([k, v]) => {
          obj.seas_res_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SeasonalityMap>, I>>(base?: I): SeasonalityMap {
    return SeasonalityMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeasonalityMap>, I>>(object: I): SeasonalityMap {
    const message = createBaseSeasonalityMap();
    message.seas_input_map = Object.entries(object.seas_input_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.seas_res_map = Object.entries(object.seas_res_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseSeasonalityMap_SeasInputMapEntry(): SeasonalityMap_SeasInputMapEntry {
  return { key: "", value: 0 };
}

export const SeasonalityMap_SeasInputMapEntry: MessageFns<SeasonalityMap_SeasInputMapEntry> = {
  encode(message: SeasonalityMap_SeasInputMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeasonalityMap_SeasInputMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeasonalityMap_SeasInputMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SeasonalityMap_SeasInputMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: SeasonalityMap_SeasInputMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SeasonalityMap_SeasInputMapEntry>, I>>(
    base?: I,
  ): SeasonalityMap_SeasInputMapEntry {
    return SeasonalityMap_SeasInputMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeasonalityMap_SeasInputMapEntry>, I>>(
    object: I,
  ): SeasonalityMap_SeasInputMapEntry {
    const message = createBaseSeasonalityMap_SeasInputMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseSeasonalityMap_SeasResMapEntry(): SeasonalityMap_SeasResMapEntry {
  return { key: "", value: 0 };
}

export const SeasonalityMap_SeasResMapEntry: MessageFns<SeasonalityMap_SeasResMapEntry> = {
  encode(message: SeasonalityMap_SeasResMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeasonalityMap_SeasResMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeasonalityMap_SeasResMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SeasonalityMap_SeasResMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: SeasonalityMap_SeasResMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SeasonalityMap_SeasResMapEntry>, I>>(base?: I): SeasonalityMap_SeasResMapEntry {
    return SeasonalityMap_SeasResMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeasonalityMap_SeasResMapEntry>, I>>(
    object: I,
  ): SeasonalityMap_SeasResMapEntry {
    const message = createBaseSeasonalityMap_SeasResMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseStcsCompPlanCfgItem(): StcsCompPlanCfgItem {
  return {
    fstmt_id: "",
    level_1_id: "",
    level_2_id: "",
    depends_on: [],
    fstmt_type: 0,
    is_calculated: false,
    pos_map: {},
    res_map: {},
    run_last: false,
    is_done: false,
    is_struct_item: false,
    plan_item_logic_type: 0,
    status: undefined,
  };
}

export const StcsCompPlanCfgItem: MessageFns<StcsCompPlanCfgItem> = {
  encode(message: StcsCompPlanCfgItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fstmt_id !== "") {
      writer.uint32(10).string(message.fstmt_id);
    }
    if (message.level_1_id !== "") {
      writer.uint32(18).string(message.level_1_id);
    }
    if (message.level_2_id !== "") {
      writer.uint32(26).string(message.level_2_id);
    }
    for (const v of message.depends_on) {
      writer.uint32(34).string(v!);
    }
    if (message.fstmt_type !== 0) {
      writer.uint32(40).int32(message.fstmt_type);
    }
    if (message.is_calculated !== false) {
      writer.uint32(48).bool(message.is_calculated);
    }
    Object.entries(message.pos_map).forEach(([key, value]) => {
      StcsCompPlanCfgItem_PosMapEntry.encode({ key: key as any, value }, writer.uint32(58).fork()).join();
    });
    Object.entries(message.res_map).forEach(([key, value]) => {
      StcsCompPlanCfgItem_ResMapEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
    });
    if (message.run_last !== false) {
      writer.uint32(72).bool(message.run_last);
    }
    if (message.is_done !== false) {
      writer.uint32(80).bool(message.is_done);
    }
    if (message.is_struct_item !== false) {
      writer.uint32(96).bool(message.is_struct_item);
    }
    if (message.plan_item_logic_type !== 0) {
      writer.uint32(112).int32(message.plan_item_logic_type);
    }
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfgItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfgItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fstmt_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.level_1_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.level_2_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.depends_on.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.fstmt_type = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.is_calculated = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = StcsCompPlanCfgItem_PosMapEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.pos_map[entry7.key] = entry7.value;
          }
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = StcsCompPlanCfgItem_ResMapEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.res_map[entry8.key] = entry8.value;
          }
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.run_last = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.is_done = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.is_struct_item = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.plan_item_logic_type = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfgItem {
    return {
      fstmt_id: isSet(object.fstmt_id) ? globalThis.String(object.fstmt_id) : "",
      level_1_id: isSet(object.level_1_id) ? globalThis.String(object.level_1_id) : "",
      level_2_id: isSet(object.level_2_id) ? globalThis.String(object.level_2_id) : "",
      depends_on: globalThis.Array.isArray(object?.depends_on)
        ? object.depends_on.map((e: any) => globalThis.String(e))
        : [],
      fstmt_type: isSet(object.fstmt_type) ? stcsFstmtEnumFromJSON(object.fstmt_type) : 0,
      is_calculated: isSet(object.is_calculated) ? globalThis.Boolean(object.is_calculated) : false,
      pos_map: isObject(object.pos_map)
        ? Object.entries(object.pos_map).reduce<{ [key: string]: PlanPosItem }>((acc, [key, value]) => {
          acc[key] = PlanPosItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      res_map: isObject(object.res_map)
        ? Object.entries(object.res_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      run_last: isSet(object.run_last) ? globalThis.Boolean(object.run_last) : false,
      is_done: isSet(object.is_done) ? globalThis.Boolean(object.is_done) : false,
      is_struct_item: isSet(object.is_struct_item) ? globalThis.Boolean(object.is_struct_item) : false,
      plan_item_logic_type: isSet(object.plan_item_logic_type)
        ? planItemLogicEnumFromJSON(object.plan_item_logic_type)
        : 0,
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
    };
  },

  toJSON(message: StcsCompPlanCfgItem): unknown {
    const obj: any = {};
    if (message.fstmt_id !== "") {
      obj.fstmt_id = message.fstmt_id;
    }
    if (message.level_1_id !== "") {
      obj.level_1_id = message.level_1_id;
    }
    if (message.level_2_id !== "") {
      obj.level_2_id = message.level_2_id;
    }
    if (message.depends_on?.length) {
      obj.depends_on = message.depends_on;
    }
    if (message.fstmt_type !== 0) {
      obj.fstmt_type = stcsFstmtEnumToJSON(message.fstmt_type);
    }
    if (message.is_calculated !== false) {
      obj.is_calculated = message.is_calculated;
    }
    if (message.pos_map) {
      const entries = Object.entries(message.pos_map);
      if (entries.length > 0) {
        obj.pos_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_map[k] = PlanPosItem.toJSON(v);
        });
      }
    }
    if (message.res_map) {
      const entries = Object.entries(message.res_map);
      if (entries.length > 0) {
        obj.res_map = {};
        entries.forEach(([k, v]) => {
          obj.res_map[k] = v;
        });
      }
    }
    if (message.run_last !== false) {
      obj.run_last = message.run_last;
    }
    if (message.is_done !== false) {
      obj.is_done = message.is_done;
    }
    if (message.is_struct_item !== false) {
      obj.is_struct_item = message.is_struct_item;
    }
    if (message.plan_item_logic_type !== 0) {
      obj.plan_item_logic_type = planItemLogicEnumToJSON(message.plan_item_logic_type);
    }
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfgItem>, I>>(base?: I): StcsCompPlanCfgItem {
    return StcsCompPlanCfgItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfgItem>, I>>(object: I): StcsCompPlanCfgItem {
    const message = createBaseStcsCompPlanCfgItem();
    message.fstmt_id = object.fstmt_id ?? "";
    message.level_1_id = object.level_1_id ?? "";
    message.level_2_id = object.level_2_id ?? "";
    message.depends_on = object.depends_on?.map((e) => e) || [];
    message.fstmt_type = object.fstmt_type ?? 0;
    message.is_calculated = object.is_calculated ?? false;
    message.pos_map = Object.entries(object.pos_map ?? {}).reduce<{ [key: string]: PlanPosItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = PlanPosItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.res_map = Object.entries(object.res_map ?? {}).reduce<{ [key: string]: number }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value);
      }
      return acc;
    }, {});
    message.run_last = object.run_last ?? false;
    message.is_done = object.is_done ?? false;
    message.is_struct_item = object.is_struct_item ?? false;
    message.plan_item_logic_type = object.plan_item_logic_type ?? 0;
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    return message;
  },
};

function createBaseStcsCompPlanCfgItem_PosMapEntry(): StcsCompPlanCfgItem_PosMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompPlanCfgItem_PosMapEntry: MessageFns<StcsCompPlanCfgItem_PosMapEntry> = {
  encode(message: StcsCompPlanCfgItem_PosMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      PlanPosItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfgItem_PosMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfgItem_PosMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = PlanPosItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfgItem_PosMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? PlanPosItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompPlanCfgItem_PosMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = PlanPosItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfgItem_PosMapEntry>, I>>(base?: I): StcsCompPlanCfgItem_PosMapEntry {
    return StcsCompPlanCfgItem_PosMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfgItem_PosMapEntry>, I>>(
    object: I,
  ): StcsCompPlanCfgItem_PosMapEntry {
    const message = createBaseStcsCompPlanCfgItem_PosMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? PlanPosItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompPlanCfgItem_ResMapEntry(): StcsCompPlanCfgItem_ResMapEntry {
  return { key: "", value: 0 };
}

export const StcsCompPlanCfgItem_ResMapEntry: MessageFns<StcsCompPlanCfgItem_ResMapEntry> = {
  encode(message: StcsCompPlanCfgItem_ResMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfgItem_ResMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfgItem_ResMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfgItem_ResMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: StcsCompPlanCfgItem_ResMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfgItem_ResMapEntry>, I>>(base?: I): StcsCompPlanCfgItem_ResMapEntry {
    return StcsCompPlanCfgItem_ResMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfgItem_ResMapEntry>, I>>(
    object: I,
  ): StcsCompPlanCfgItem_ResMapEntry {
    const message = createBaseStcsCompPlanCfgItem_ResMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanPosItem(): PlanPosItem {
  return {
    pos_logic_type: 0,
    fstmt_type: 0,
    pos_index: 0,
    is_struct_item: false,
    status: undefined,
    display_value_type: 0,
    retained_earnings: undefined,
    manual_dec_input: undefined,
    monthly_growth_rate: undefined,
    manual_dec_input_in_change: undefined,
    formula_based: undefined,
    annually_growth_rate: undefined,
    manual_perc_input: undefined,
    capex_cfg: undefined,
    manual_in_change_ref_yearly: undefined,
    capex_res: undefined,
    dio_reverse_formula: undefined,
    dpo_reverse_formula: undefined,
    dso_reverse_formula: undefined,
    fte_x_avg_all_in_costs: undefined,
    interest_baring_liability_loan_cfg: undefined,
    interest_baring_liability_loan_res: undefined,
    interest_on_cash: undefined,
    in_perc_of_account: undefined,
    tax_rate_on_fstmt: undefined,
  };
}

export const PlanPosItem: MessageFns<PlanPosItem> = {
  encode(message: PlanPosItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pos_logic_type !== 0) {
      writer.uint32(8).int32(message.pos_logic_type);
    }
    if (message.fstmt_type !== 0) {
      writer.uint32(16).int32(message.fstmt_type);
    }
    if (message.pos_index !== 0) {
      writer.uint32(24).uint32(message.pos_index);
    }
    if (message.is_struct_item !== false) {
      writer.uint32(32).bool(message.is_struct_item);
    }
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(42).fork()).join();
    }
    if (message.display_value_type !== 0) {
      writer.uint32(88).int32(message.display_value_type);
    }
    if (message.retained_earnings !== undefined) {
      PlanItemStructPosRetainedEarnings.encode(message.retained_earnings, writer.uint32(834).fork()).join();
    }
    if (message.manual_dec_input !== undefined) {
      PlanItemPosManualDecInput.encode(message.manual_dec_input, writer.uint32(842).fork()).join();
    }
    if (message.monthly_growth_rate !== undefined) {
      PlanItemPosMonthlyGrowthRate.encode(message.monthly_growth_rate, writer.uint32(850).fork()).join();
    }
    if (message.manual_dec_input_in_change !== undefined) {
      PlanItemPosManualDecInputInChange.encode(message.manual_dec_input_in_change, writer.uint32(858).fork()).join();
    }
    if (message.formula_based !== undefined) {
      PlanItemPosFormulaBased.encode(message.formula_based, writer.uint32(866).fork()).join();
    }
    if (message.annually_growth_rate !== undefined) {
      PlanItemPosLogicAnnuallyGrowthRate.encode(message.annually_growth_rate, writer.uint32(874).fork()).join();
    }
    if (message.manual_perc_input !== undefined) {
      PlanItemPosManualPercInput.encode(message.manual_perc_input, writer.uint32(882).fork()).join();
    }
    if (message.capex_cfg !== undefined) {
      PlanItemPosCapexCfg.encode(message.capex_cfg, writer.uint32(890).fork()).join();
    }
    if (message.manual_in_change_ref_yearly !== undefined) {
      PlanItemPosManualInChangeRefYearly.encode(message.manual_in_change_ref_yearly, writer.uint32(898).fork()).join();
    }
    if (message.capex_res !== undefined) {
      PlanItemPosCapexRes.encode(message.capex_res, writer.uint32(906).fork()).join();
    }
    if (message.dio_reverse_formula !== undefined) {
      PlanItemPosDioReverseFormula.encode(message.dio_reverse_formula, writer.uint32(914).fork()).join();
    }
    if (message.dpo_reverse_formula !== undefined) {
      PlanItemPosDpoReverseFormula.encode(message.dpo_reverse_formula, writer.uint32(922).fork()).join();
    }
    if (message.dso_reverse_formula !== undefined) {
      PlanItemPosDsoReverseFormula.encode(message.dso_reverse_formula, writer.uint32(930).fork()).join();
    }
    if (message.fte_x_avg_all_in_costs !== undefined) {
      PlanItemPosLogicFTExAVGaLLInCosts.encode(message.fte_x_avg_all_in_costs, writer.uint32(938).fork()).join();
    }
    if (message.interest_baring_liability_loan_cfg !== undefined) {
      PlanItemPosLogicInterestBaringLiabilityLoanCfg.encode(
        message.interest_baring_liability_loan_cfg,
        writer.uint32(946).fork(),
      ).join();
    }
    if (message.interest_baring_liability_loan_res !== undefined) {
      PlanItemPosLogicInterestBaringLiabilityLoanRes.encode(
        message.interest_baring_liability_loan_res,
        writer.uint32(954).fork(),
      ).join();
    }
    if (message.interest_on_cash !== undefined) {
      PlanItemPosLogicInterestOnCash.encode(message.interest_on_cash, writer.uint32(962).fork()).join();
    }
    if (message.in_perc_of_account !== undefined) {
      PlanItemPosLogicInPercOfAcc.encode(message.in_perc_of_account, writer.uint32(970).fork()).join();
    }
    if (message.tax_rate_on_fstmt !== undefined) {
      PlanItemPosLogicTaxRateOnFstmt.encode(message.tax_rate_on_fstmt, writer.uint32(978).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanPosItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanPosItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pos_logic_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.fstmt_type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pos_index = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_struct_item = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.display_value_type = reader.int32() as any;
          continue;
        }
        case 104: {
          if (tag !== 834) {
            break;
          }

          message.retained_earnings = PlanItemStructPosRetainedEarnings.decode(reader, reader.uint32());
          continue;
        }
        case 105: {
          if (tag !== 842) {
            break;
          }

          message.manual_dec_input = PlanItemPosManualDecInput.decode(reader, reader.uint32());
          continue;
        }
        case 106: {
          if (tag !== 850) {
            break;
          }

          message.monthly_growth_rate = PlanItemPosMonthlyGrowthRate.decode(reader, reader.uint32());
          continue;
        }
        case 107: {
          if (tag !== 858) {
            break;
          }

          message.manual_dec_input_in_change = PlanItemPosManualDecInputInChange.decode(reader, reader.uint32());
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.formula_based = PlanItemPosFormulaBased.decode(reader, reader.uint32());
          continue;
        }
        case 109: {
          if (tag !== 874) {
            break;
          }

          message.annually_growth_rate = PlanItemPosLogicAnnuallyGrowthRate.decode(reader, reader.uint32());
          continue;
        }
        case 110: {
          if (tag !== 882) {
            break;
          }

          message.manual_perc_input = PlanItemPosManualPercInput.decode(reader, reader.uint32());
          continue;
        }
        case 111: {
          if (tag !== 890) {
            break;
          }

          message.capex_cfg = PlanItemPosCapexCfg.decode(reader, reader.uint32());
          continue;
        }
        case 112: {
          if (tag !== 898) {
            break;
          }

          message.manual_in_change_ref_yearly = PlanItemPosManualInChangeRefYearly.decode(reader, reader.uint32());
          continue;
        }
        case 113: {
          if (tag !== 906) {
            break;
          }

          message.capex_res = PlanItemPosCapexRes.decode(reader, reader.uint32());
          continue;
        }
        case 114: {
          if (tag !== 914) {
            break;
          }

          message.dio_reverse_formula = PlanItemPosDioReverseFormula.decode(reader, reader.uint32());
          continue;
        }
        case 115: {
          if (tag !== 922) {
            break;
          }

          message.dpo_reverse_formula = PlanItemPosDpoReverseFormula.decode(reader, reader.uint32());
          continue;
        }
        case 116: {
          if (tag !== 930) {
            break;
          }

          message.dso_reverse_formula = PlanItemPosDsoReverseFormula.decode(reader, reader.uint32());
          continue;
        }
        case 117: {
          if (tag !== 938) {
            break;
          }

          message.fte_x_avg_all_in_costs = PlanItemPosLogicFTExAVGaLLInCosts.decode(reader, reader.uint32());
          continue;
        }
        case 118: {
          if (tag !== 946) {
            break;
          }

          message.interest_baring_liability_loan_cfg = PlanItemPosLogicInterestBaringLiabilityLoanCfg.decode(
            reader,
            reader.uint32(),
          );
          continue;
        }
        case 119: {
          if (tag !== 954) {
            break;
          }

          message.interest_baring_liability_loan_res = PlanItemPosLogicInterestBaringLiabilityLoanRes.decode(
            reader,
            reader.uint32(),
          );
          continue;
        }
        case 120: {
          if (tag !== 962) {
            break;
          }

          message.interest_on_cash = PlanItemPosLogicInterestOnCash.decode(reader, reader.uint32());
          continue;
        }
        case 121: {
          if (tag !== 970) {
            break;
          }

          message.in_perc_of_account = PlanItemPosLogicInPercOfAcc.decode(reader, reader.uint32());
          continue;
        }
        case 122: {
          if (tag !== 978) {
            break;
          }

          message.tax_rate_on_fstmt = PlanItemPosLogicTaxRateOnFstmt.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanPosItem {
    return {
      pos_logic_type: isSet(object.pos_logic_type) ? methodologyEnumFromJSON(object.pos_logic_type) : 0,
      fstmt_type: isSet(object.fstmt_type) ? stcsFstmtEnumFromJSON(object.fstmt_type) : 0,
      pos_index: isSet(object.pos_index) ? globalThis.Number(object.pos_index) : 0,
      is_struct_item: isSet(object.is_struct_item) ? globalThis.Boolean(object.is_struct_item) : false,
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
      display_value_type: isSet(object.display_value_type)
        ? stcsDisplayValueTypeEnumFromJSON(object.display_value_type)
        : 0,
      retained_earnings: isSet(object.retained_earnings)
        ? PlanItemStructPosRetainedEarnings.fromJSON(object.retained_earnings)
        : undefined,
      manual_dec_input: isSet(object.manual_dec_input)
        ? PlanItemPosManualDecInput.fromJSON(object.manual_dec_input)
        : undefined,
      monthly_growth_rate: isSet(object.monthly_growth_rate)
        ? PlanItemPosMonthlyGrowthRate.fromJSON(object.monthly_growth_rate)
        : undefined,
      manual_dec_input_in_change: isSet(object.manual_dec_input_in_change)
        ? PlanItemPosManualDecInputInChange.fromJSON(object.manual_dec_input_in_change)
        : undefined,
      formula_based: isSet(object.formula_based) ? PlanItemPosFormulaBased.fromJSON(object.formula_based) : undefined,
      annually_growth_rate: isSet(object.annually_growth_rate)
        ? PlanItemPosLogicAnnuallyGrowthRate.fromJSON(object.annually_growth_rate)
        : undefined,
      manual_perc_input: isSet(object.manual_perc_input)
        ? PlanItemPosManualPercInput.fromJSON(object.manual_perc_input)
        : undefined,
      capex_cfg: isSet(object.capex_cfg) ? PlanItemPosCapexCfg.fromJSON(object.capex_cfg) : undefined,
      manual_in_change_ref_yearly: isSet(object.manual_in_change_ref_yearly)
        ? PlanItemPosManualInChangeRefYearly.fromJSON(object.manual_in_change_ref_yearly)
        : undefined,
      capex_res: isSet(object.capex_res) ? PlanItemPosCapexRes.fromJSON(object.capex_res) : undefined,
      dio_reverse_formula: isSet(object.dio_reverse_formula)
        ? PlanItemPosDioReverseFormula.fromJSON(object.dio_reverse_formula)
        : undefined,
      dpo_reverse_formula: isSet(object.dpo_reverse_formula)
        ? PlanItemPosDpoReverseFormula.fromJSON(object.dpo_reverse_formula)
        : undefined,
      dso_reverse_formula: isSet(object.dso_reverse_formula)
        ? PlanItemPosDsoReverseFormula.fromJSON(object.dso_reverse_formula)
        : undefined,
      fte_x_avg_all_in_costs: isSet(object.fte_x_avg_all_in_costs)
        ? PlanItemPosLogicFTExAVGaLLInCosts.fromJSON(object.fte_x_avg_all_in_costs)
        : undefined,
      interest_baring_liability_loan_cfg: isSet(object.interest_baring_liability_loan_cfg)
        ? PlanItemPosLogicInterestBaringLiabilityLoanCfg.fromJSON(object.interest_baring_liability_loan_cfg)
        : undefined,
      interest_baring_liability_loan_res: isSet(object.interest_baring_liability_loan_res)
        ? PlanItemPosLogicInterestBaringLiabilityLoanRes.fromJSON(object.interest_baring_liability_loan_res)
        : undefined,
      interest_on_cash: isSet(object.interest_on_cash)
        ? PlanItemPosLogicInterestOnCash.fromJSON(object.interest_on_cash)
        : undefined,
      in_perc_of_account: isSet(object.in_perc_of_account)
        ? PlanItemPosLogicInPercOfAcc.fromJSON(object.in_perc_of_account)
        : undefined,
      tax_rate_on_fstmt: isSet(object.tax_rate_on_fstmt)
        ? PlanItemPosLogicTaxRateOnFstmt.fromJSON(object.tax_rate_on_fstmt)
        : undefined,
    };
  },

  toJSON(message: PlanPosItem): unknown {
    const obj: any = {};
    if (message.pos_logic_type !== 0) {
      obj.pos_logic_type = methodologyEnumToJSON(message.pos_logic_type);
    }
    if (message.fstmt_type !== 0) {
      obj.fstmt_type = stcsFstmtEnumToJSON(message.fstmt_type);
    }
    if (message.pos_index !== 0) {
      obj.pos_index = Math.round(message.pos_index);
    }
    if (message.is_struct_item !== false) {
      obj.is_struct_item = message.is_struct_item;
    }
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    if (message.display_value_type !== 0) {
      obj.display_value_type = stcsDisplayValueTypeEnumToJSON(message.display_value_type);
    }
    if (message.retained_earnings !== undefined) {
      obj.retained_earnings = PlanItemStructPosRetainedEarnings.toJSON(message.retained_earnings);
    }
    if (message.manual_dec_input !== undefined) {
      obj.manual_dec_input = PlanItemPosManualDecInput.toJSON(message.manual_dec_input);
    }
    if (message.monthly_growth_rate !== undefined) {
      obj.monthly_growth_rate = PlanItemPosMonthlyGrowthRate.toJSON(message.monthly_growth_rate);
    }
    if (message.manual_dec_input_in_change !== undefined) {
      obj.manual_dec_input_in_change = PlanItemPosManualDecInputInChange.toJSON(message.manual_dec_input_in_change);
    }
    if (message.formula_based !== undefined) {
      obj.formula_based = PlanItemPosFormulaBased.toJSON(message.formula_based);
    }
    if (message.annually_growth_rate !== undefined) {
      obj.annually_growth_rate = PlanItemPosLogicAnnuallyGrowthRate.toJSON(message.annually_growth_rate);
    }
    if (message.manual_perc_input !== undefined) {
      obj.manual_perc_input = PlanItemPosManualPercInput.toJSON(message.manual_perc_input);
    }
    if (message.capex_cfg !== undefined) {
      obj.capex_cfg = PlanItemPosCapexCfg.toJSON(message.capex_cfg);
    }
    if (message.manual_in_change_ref_yearly !== undefined) {
      obj.manual_in_change_ref_yearly = PlanItemPosManualInChangeRefYearly.toJSON(message.manual_in_change_ref_yearly);
    }
    if (message.capex_res !== undefined) {
      obj.capex_res = PlanItemPosCapexRes.toJSON(message.capex_res);
    }
    if (message.dio_reverse_formula !== undefined) {
      obj.dio_reverse_formula = PlanItemPosDioReverseFormula.toJSON(message.dio_reverse_formula);
    }
    if (message.dpo_reverse_formula !== undefined) {
      obj.dpo_reverse_formula = PlanItemPosDpoReverseFormula.toJSON(message.dpo_reverse_formula);
    }
    if (message.dso_reverse_formula !== undefined) {
      obj.dso_reverse_formula = PlanItemPosDsoReverseFormula.toJSON(message.dso_reverse_formula);
    }
    if (message.fte_x_avg_all_in_costs !== undefined) {
      obj.fte_x_avg_all_in_costs = PlanItemPosLogicFTExAVGaLLInCosts.toJSON(message.fte_x_avg_all_in_costs);
    }
    if (message.interest_baring_liability_loan_cfg !== undefined) {
      obj.interest_baring_liability_loan_cfg = PlanItemPosLogicInterestBaringLiabilityLoanCfg.toJSON(
        message.interest_baring_liability_loan_cfg,
      );
    }
    if (message.interest_baring_liability_loan_res !== undefined) {
      obj.interest_baring_liability_loan_res = PlanItemPosLogicInterestBaringLiabilityLoanRes.toJSON(
        message.interest_baring_liability_loan_res,
      );
    }
    if (message.interest_on_cash !== undefined) {
      obj.interest_on_cash = PlanItemPosLogicInterestOnCash.toJSON(message.interest_on_cash);
    }
    if (message.in_perc_of_account !== undefined) {
      obj.in_perc_of_account = PlanItemPosLogicInPercOfAcc.toJSON(message.in_perc_of_account);
    }
    if (message.tax_rate_on_fstmt !== undefined) {
      obj.tax_rate_on_fstmt = PlanItemPosLogicTaxRateOnFstmt.toJSON(message.tax_rate_on_fstmt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanPosItem>, I>>(base?: I): PlanPosItem {
    return PlanPosItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanPosItem>, I>>(object: I): PlanPosItem {
    const message = createBasePlanPosItem();
    message.pos_logic_type = object.pos_logic_type ?? 0;
    message.fstmt_type = object.fstmt_type ?? 0;
    message.pos_index = object.pos_index ?? 0;
    message.is_struct_item = object.is_struct_item ?? false;
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    message.display_value_type = object.display_value_type ?? 0;
    message.retained_earnings = (object.retained_earnings !== undefined && object.retained_earnings !== null)
      ? PlanItemStructPosRetainedEarnings.fromPartial(object.retained_earnings)
      : undefined;
    message.manual_dec_input = (object.manual_dec_input !== undefined && object.manual_dec_input !== null)
      ? PlanItemPosManualDecInput.fromPartial(object.manual_dec_input)
      : undefined;
    message.monthly_growth_rate = (object.monthly_growth_rate !== undefined && object.monthly_growth_rate !== null)
      ? PlanItemPosMonthlyGrowthRate.fromPartial(object.monthly_growth_rate)
      : undefined;
    message.manual_dec_input_in_change =
      (object.manual_dec_input_in_change !== undefined && object.manual_dec_input_in_change !== null)
        ? PlanItemPosManualDecInputInChange.fromPartial(object.manual_dec_input_in_change)
        : undefined;
    message.formula_based = (object.formula_based !== undefined && object.formula_based !== null)
      ? PlanItemPosFormulaBased.fromPartial(object.formula_based)
      : undefined;
    message.annually_growth_rate = (object.annually_growth_rate !== undefined && object.annually_growth_rate !== null)
      ? PlanItemPosLogicAnnuallyGrowthRate.fromPartial(object.annually_growth_rate)
      : undefined;
    message.manual_perc_input = (object.manual_perc_input !== undefined && object.manual_perc_input !== null)
      ? PlanItemPosManualPercInput.fromPartial(object.manual_perc_input)
      : undefined;
    message.capex_cfg = (object.capex_cfg !== undefined && object.capex_cfg !== null)
      ? PlanItemPosCapexCfg.fromPartial(object.capex_cfg)
      : undefined;
    message.manual_in_change_ref_yearly =
      (object.manual_in_change_ref_yearly !== undefined && object.manual_in_change_ref_yearly !== null)
        ? PlanItemPosManualInChangeRefYearly.fromPartial(object.manual_in_change_ref_yearly)
        : undefined;
    message.capex_res = (object.capex_res !== undefined && object.capex_res !== null)
      ? PlanItemPosCapexRes.fromPartial(object.capex_res)
      : undefined;
    message.dio_reverse_formula = (object.dio_reverse_formula !== undefined && object.dio_reverse_formula !== null)
      ? PlanItemPosDioReverseFormula.fromPartial(object.dio_reverse_formula)
      : undefined;
    message.dpo_reverse_formula = (object.dpo_reverse_formula !== undefined && object.dpo_reverse_formula !== null)
      ? PlanItemPosDpoReverseFormula.fromPartial(object.dpo_reverse_formula)
      : undefined;
    message.dso_reverse_formula = (object.dso_reverse_formula !== undefined && object.dso_reverse_formula !== null)
      ? PlanItemPosDsoReverseFormula.fromPartial(object.dso_reverse_formula)
      : undefined;
    message.fte_x_avg_all_in_costs =
      (object.fte_x_avg_all_in_costs !== undefined && object.fte_x_avg_all_in_costs !== null)
        ? PlanItemPosLogicFTExAVGaLLInCosts.fromPartial(object.fte_x_avg_all_in_costs)
        : undefined;
    message.interest_baring_liability_loan_cfg =
      (object.interest_baring_liability_loan_cfg !== undefined && object.interest_baring_liability_loan_cfg !== null)
        ? PlanItemPosLogicInterestBaringLiabilityLoanCfg.fromPartial(object.interest_baring_liability_loan_cfg)
        : undefined;
    message.interest_baring_liability_loan_res =
      (object.interest_baring_liability_loan_res !== undefined && object.interest_baring_liability_loan_res !== null)
        ? PlanItemPosLogicInterestBaringLiabilityLoanRes.fromPartial(object.interest_baring_liability_loan_res)
        : undefined;
    message.interest_on_cash = (object.interest_on_cash !== undefined && object.interest_on_cash !== null)
      ? PlanItemPosLogicInterestOnCash.fromPartial(object.interest_on_cash)
      : undefined;
    message.in_perc_of_account = (object.in_perc_of_account !== undefined && object.in_perc_of_account !== null)
      ? PlanItemPosLogicInPercOfAcc.fromPartial(object.in_perc_of_account)
      : undefined;
    message.tax_rate_on_fstmt = (object.tax_rate_on_fstmt !== undefined && object.tax_rate_on_fstmt !== null)
      ? PlanItemPosLogicTaxRateOnFstmt.fromPartial(object.tax_rate_on_fstmt)
      : undefined;
    return message;
  },
};

function createBasePlanSubPosItem(): PlanSubPosItem {
  return {
    pos_logic_type: 0,
    fstmt_type: 0,
    pos_index: 0,
    is_struct_item: false,
    status: undefined,
    display_value_type: 0,
    manual_dec_input: undefined,
    formula_based: undefined,
    monthly_growth_rate: undefined,
    manual_perc_input: undefined,
  };
}

export const PlanSubPosItem: MessageFns<PlanSubPosItem> = {
  encode(message: PlanSubPosItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pos_logic_type !== 0) {
      writer.uint32(8).int32(message.pos_logic_type);
    }
    if (message.fstmt_type !== 0) {
      writer.uint32(16).int32(message.fstmt_type);
    }
    if (message.pos_index !== 0) {
      writer.uint32(24).uint32(message.pos_index);
    }
    if (message.is_struct_item !== false) {
      writer.uint32(32).bool(message.is_struct_item);
    }
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(42).fork()).join();
    }
    if (message.display_value_type !== 0) {
      writer.uint32(88).int32(message.display_value_type);
    }
    if (message.manual_dec_input !== undefined) {
      PlanItemPosManualDecInput.encode(message.manual_dec_input, writer.uint32(842).fork()).join();
    }
    if (message.formula_based !== undefined) {
      PlanItemPosFormulaBased.encode(message.formula_based, writer.uint32(866).fork()).join();
    }
    if (message.monthly_growth_rate !== undefined) {
      PlanItemPosMonthlyGrowthRate.encode(message.monthly_growth_rate, writer.uint32(850).fork()).join();
    }
    if (message.manual_perc_input !== undefined) {
      PlanItemPosManualPercInput.encode(message.manual_perc_input, writer.uint32(882).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanSubPosItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanSubPosItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pos_logic_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.fstmt_type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pos_index = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_struct_item = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.display_value_type = reader.int32() as any;
          continue;
        }
        case 105: {
          if (tag !== 842) {
            break;
          }

          message.manual_dec_input = PlanItemPosManualDecInput.decode(reader, reader.uint32());
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.formula_based = PlanItemPosFormulaBased.decode(reader, reader.uint32());
          continue;
        }
        case 106: {
          if (tag !== 850) {
            break;
          }

          message.monthly_growth_rate = PlanItemPosMonthlyGrowthRate.decode(reader, reader.uint32());
          continue;
        }
        case 110: {
          if (tag !== 882) {
            break;
          }

          message.manual_perc_input = PlanItemPosManualPercInput.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanSubPosItem {
    return {
      pos_logic_type: isSet(object.pos_logic_type) ? methodologyEnumFromJSON(object.pos_logic_type) : 0,
      fstmt_type: isSet(object.fstmt_type) ? stcsFstmtEnumFromJSON(object.fstmt_type) : 0,
      pos_index: isSet(object.pos_index) ? globalThis.Number(object.pos_index) : 0,
      is_struct_item: isSet(object.is_struct_item) ? globalThis.Boolean(object.is_struct_item) : false,
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
      display_value_type: isSet(object.display_value_type)
        ? stcsDisplayValueTypeEnumFromJSON(object.display_value_type)
        : 0,
      manual_dec_input: isSet(object.manual_dec_input)
        ? PlanItemPosManualDecInput.fromJSON(object.manual_dec_input)
        : undefined,
      formula_based: isSet(object.formula_based) ? PlanItemPosFormulaBased.fromJSON(object.formula_based) : undefined,
      monthly_growth_rate: isSet(object.monthly_growth_rate)
        ? PlanItemPosMonthlyGrowthRate.fromJSON(object.monthly_growth_rate)
        : undefined,
      manual_perc_input: isSet(object.manual_perc_input)
        ? PlanItemPosManualPercInput.fromJSON(object.manual_perc_input)
        : undefined,
    };
  },

  toJSON(message: PlanSubPosItem): unknown {
    const obj: any = {};
    if (message.pos_logic_type !== 0) {
      obj.pos_logic_type = methodologyEnumToJSON(message.pos_logic_type);
    }
    if (message.fstmt_type !== 0) {
      obj.fstmt_type = stcsFstmtEnumToJSON(message.fstmt_type);
    }
    if (message.pos_index !== 0) {
      obj.pos_index = Math.round(message.pos_index);
    }
    if (message.is_struct_item !== false) {
      obj.is_struct_item = message.is_struct_item;
    }
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    if (message.display_value_type !== 0) {
      obj.display_value_type = stcsDisplayValueTypeEnumToJSON(message.display_value_type);
    }
    if (message.manual_dec_input !== undefined) {
      obj.manual_dec_input = PlanItemPosManualDecInput.toJSON(message.manual_dec_input);
    }
    if (message.formula_based !== undefined) {
      obj.formula_based = PlanItemPosFormulaBased.toJSON(message.formula_based);
    }
    if (message.monthly_growth_rate !== undefined) {
      obj.monthly_growth_rate = PlanItemPosMonthlyGrowthRate.toJSON(message.monthly_growth_rate);
    }
    if (message.manual_perc_input !== undefined) {
      obj.manual_perc_input = PlanItemPosManualPercInput.toJSON(message.manual_perc_input);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanSubPosItem>, I>>(base?: I): PlanSubPosItem {
    return PlanSubPosItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanSubPosItem>, I>>(object: I): PlanSubPosItem {
    const message = createBasePlanSubPosItem();
    message.pos_logic_type = object.pos_logic_type ?? 0;
    message.fstmt_type = object.fstmt_type ?? 0;
    message.pos_index = object.pos_index ?? 0;
    message.is_struct_item = object.is_struct_item ?? false;
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    message.display_value_type = object.display_value_type ?? 0;
    message.manual_dec_input = (object.manual_dec_input !== undefined && object.manual_dec_input !== null)
      ? PlanItemPosManualDecInput.fromPartial(object.manual_dec_input)
      : undefined;
    message.formula_based = (object.formula_based !== undefined && object.formula_based !== null)
      ? PlanItemPosFormulaBased.fromPartial(object.formula_based)
      : undefined;
    message.monthly_growth_rate = (object.monthly_growth_rate !== undefined && object.monthly_growth_rate !== null)
      ? PlanItemPosMonthlyGrowthRate.fromPartial(object.monthly_growth_rate)
      : undefined;
    message.manual_perc_input = (object.manual_perc_input !== undefined && object.manual_perc_input !== null)
      ? PlanItemPosManualPercInput.fromPartial(object.manual_perc_input)
      : undefined;
    return message;
  },
};

function createBaseStcsCalcItemStatus(): StcsCalcItemStatus {
  return { status_code: 0, message: "", manual_override_map: {}, cycle_path_key_list: [] };
}

export const StcsCalcItemStatus: MessageFns<StcsCalcItemStatus> = {
  encode(message: StcsCalcItemStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status_code !== 0) {
      writer.uint32(8).int32(message.status_code);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    Object.entries(message.manual_override_map).forEach(([key, value]) => {
      StcsCalcItemStatus_ManualOverrideMapEntry.encode({ key: key as any, value }, writer.uint32(74).fork()).join();
    });
    for (const v of message.cycle_path_key_list) {
      writer.uint32(82).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCalcItemStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCalcItemStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status_code = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          const entry9 = StcsCalcItemStatus_ManualOverrideMapEntry.decode(reader, reader.uint32());
          if (entry9.value !== undefined) {
            message.manual_override_map[entry9.key] = entry9.value;
          }
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.cycle_path_key_list.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCalcItemStatus {
    return {
      status_code: isSet(object.status_code) ? stcsCalcItemStatusCodeFromJSON(object.status_code) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      manual_override_map: isObject(object.manual_override_map)
        ? Object.entries(object.manual_override_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      cycle_path_key_list: globalThis.Array.isArray(object?.cycle_path_key_list)
        ? object.cycle_path_key_list.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: StcsCalcItemStatus): unknown {
    const obj: any = {};
    if (message.status_code !== 0) {
      obj.status_code = stcsCalcItemStatusCodeToJSON(message.status_code);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.manual_override_map) {
      const entries = Object.entries(message.manual_override_map);
      if (entries.length > 0) {
        obj.manual_override_map = {};
        entries.forEach(([k, v]) => {
          obj.manual_override_map[k] = v;
        });
      }
    }
    if (message.cycle_path_key_list?.length) {
      obj.cycle_path_key_list = message.cycle_path_key_list;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCalcItemStatus>, I>>(base?: I): StcsCalcItemStatus {
    return StcsCalcItemStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCalcItemStatus>, I>>(object: I): StcsCalcItemStatus {
    const message = createBaseStcsCalcItemStatus();
    message.status_code = object.status_code ?? 0;
    message.message = object.message ?? "";
    message.manual_override_map = Object.entries(object.manual_override_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.cycle_path_key_list = object.cycle_path_key_list?.map((e) => e) || [];
    return message;
  },
};

function createBaseStcsCalcItemStatus_ManualOverrideMapEntry(): StcsCalcItemStatus_ManualOverrideMapEntry {
  return { key: "", value: 0 };
}

export const StcsCalcItemStatus_ManualOverrideMapEntry: MessageFns<StcsCalcItemStatus_ManualOverrideMapEntry> = {
  encode(message: StcsCalcItemStatus_ManualOverrideMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCalcItemStatus_ManualOverrideMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCalcItemStatus_ManualOverrideMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCalcItemStatus_ManualOverrideMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: StcsCalcItemStatus_ManualOverrideMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCalcItemStatus_ManualOverrideMapEntry>, I>>(
    base?: I,
  ): StcsCalcItemStatus_ManualOverrideMapEntry {
    return StcsCalcItemStatus_ManualOverrideMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCalcItemStatus_ManualOverrideMapEntry>, I>>(
    object: I,
  ): StcsCalcItemStatus_ManualOverrideMapEntry {
    const message = createBaseStcsCalcItemStatus_ManualOverrideMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemStructPosRetainedEarnings(): PlanItemStructPosRetainedEarnings {
  return { pos_input_fstmt_id: "", pos_res_plan_map: {} };
}

export const PlanItemStructPosRetainedEarnings: MessageFns<PlanItemStructPosRetainedEarnings> = {
  encode(message: PlanItemStructPosRetainedEarnings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pos_input_fstmt_id !== "") {
      writer.uint32(18).string(message.pos_input_fstmt_id);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemStructPosRetainedEarnings_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(50).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemStructPosRetainedEarnings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemStructPosRetainedEarnings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pos_input_fstmt_id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = PlanItemStructPosRetainedEarnings_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.pos_res_plan_map[entry6.key] = entry6.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemStructPosRetainedEarnings {
    return {
      pos_input_fstmt_id: isSet(object.pos_input_fstmt_id) ? globalThis.String(object.pos_input_fstmt_id) : "",
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemStructPosRetainedEarnings): unknown {
    const obj: any = {};
    if (message.pos_input_fstmt_id !== "") {
      obj.pos_input_fstmt_id = message.pos_input_fstmt_id;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemStructPosRetainedEarnings>, I>>(
    base?: I,
  ): PlanItemStructPosRetainedEarnings {
    return PlanItemStructPosRetainedEarnings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemStructPosRetainedEarnings>, I>>(
    object: I,
  ): PlanItemStructPosRetainedEarnings {
    const message = createBasePlanItemStructPosRetainedEarnings();
    message.pos_input_fstmt_id = object.pos_input_fstmt_id ?? "";
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemStructPosRetainedEarnings_PosResPlanMapEntry(): PlanItemStructPosRetainedEarnings_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemStructPosRetainedEarnings_PosResPlanMapEntry: MessageFns<
  PlanItemStructPosRetainedEarnings_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemStructPosRetainedEarnings_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemStructPosRetainedEarnings_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemStructPosRetainedEarnings_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemStructPosRetainedEarnings_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemStructPosRetainedEarnings_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemStructPosRetainedEarnings_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemStructPosRetainedEarnings_PosResPlanMapEntry {
    return PlanItemStructPosRetainedEarnings_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemStructPosRetainedEarnings_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemStructPosRetainedEarnings_PosResPlanMapEntry {
    const message = createBasePlanItemStructPosRetainedEarnings_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosManualInChangeRefYearly(): PlanItemPosManualInChangeRefYearly {
  return {
    pos_ref_id_level_1: "",
    pos_ref_id_level_2: "",
    pos_ref_fstmt_type: 0,
    pos_input_map: {},
    pos_ref_result_map: {},
    pos_res_plan_map: {},
  };
}

export const PlanItemPosManualInChangeRefYearly: MessageFns<PlanItemPosManualInChangeRefYearly> = {
  encode(message: PlanItemPosManualInChangeRefYearly, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pos_ref_id_level_1 !== "") {
      writer.uint32(10).string(message.pos_ref_id_level_1);
    }
    if (message.pos_ref_id_level_2 !== "") {
      writer.uint32(18).string(message.pos_ref_id_level_2);
    }
    if (message.pos_ref_fstmt_type !== 0) {
      writer.uint32(56).int32(message.pos_ref_fstmt_type);
    }
    Object.entries(message.pos_input_map).forEach(([key, value]) => {
      PlanItemPosManualInChangeRefYearly_PosInputMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    Object.entries(message.pos_ref_result_map).forEach(([key, value]) => {
      PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry.encode(
        { key: key as any, value },
        writer.uint32(42).fork(),
      ).join();
    });
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(50).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualInChangeRefYearly {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualInChangeRefYearly();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pos_ref_id_level_1 = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pos_ref_id_level_2 = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.pos_ref_fstmt_type = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosManualInChangeRefYearly_PosInputMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_input_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.pos_ref_result_map[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.pos_res_plan_map[entry6.key] = entry6.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualInChangeRefYearly {
    return {
      pos_ref_id_level_1: isSet(object.pos_ref_id_level_1) ? globalThis.String(object.pos_ref_id_level_1) : "",
      pos_ref_id_level_2: isSet(object.pos_ref_id_level_2) ? globalThis.String(object.pos_ref_id_level_2) : "",
      pos_ref_fstmt_type: isSet(object.pos_ref_fstmt_type) ? stcsFstmtEnumFromJSON(object.pos_ref_fstmt_type) : 0,
      pos_input_map: isObject(object.pos_input_map)
        ? Object.entries(object.pos_input_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      pos_ref_result_map: isObject(object.pos_ref_result_map)
        ? Object.entries(object.pos_ref_result_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosManualInChangeRefYearly): unknown {
    const obj: any = {};
    if (message.pos_ref_id_level_1 !== "") {
      obj.pos_ref_id_level_1 = message.pos_ref_id_level_1;
    }
    if (message.pos_ref_id_level_2 !== "") {
      obj.pos_ref_id_level_2 = message.pos_ref_id_level_2;
    }
    if (message.pos_ref_fstmt_type !== 0) {
      obj.pos_ref_fstmt_type = stcsFstmtEnumToJSON(message.pos_ref_fstmt_type);
    }
    if (message.pos_input_map) {
      const entries = Object.entries(message.pos_input_map);
      if (entries.length > 0) {
        obj.pos_input_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_ref_result_map) {
      const entries = Object.entries(message.pos_ref_result_map);
      if (entries.length > 0) {
        obj.pos_ref_result_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_ref_result_map[k] = v;
        });
      }
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualInChangeRefYearly>, I>>(
    base?: I,
  ): PlanItemPosManualInChangeRefYearly {
    return PlanItemPosManualInChangeRefYearly.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualInChangeRefYearly>, I>>(
    object: I,
  ): PlanItemPosManualInChangeRefYearly {
    const message = createBasePlanItemPosManualInChangeRefYearly();
    message.pos_ref_id_level_1 = object.pos_ref_id_level_1 ?? "";
    message.pos_ref_id_level_2 = object.pos_ref_id_level_2 ?? "";
    message.pos_ref_fstmt_type = object.pos_ref_fstmt_type ?? 0;
    message.pos_input_map = Object.entries(object.pos_input_map ?? {}).reduce<{ [key: string]: InputManualMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.pos_ref_result_map = Object.entries(object.pos_ref_result_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosManualInChangeRefYearly_PosInputMapEntry(): PlanItemPosManualInChangeRefYearly_PosInputMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosManualInChangeRefYearly_PosInputMapEntry: MessageFns<
  PlanItemPosManualInChangeRefYearly_PosInputMapEntry
> = {
  encode(
    message: PlanItemPosManualInChangeRefYearly_PosInputMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualInChangeRefYearly_PosInputMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualInChangeRefYearly_PosInputMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualInChangeRefYearly_PosInputMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosManualInChangeRefYearly_PosInputMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualInChangeRefYearly_PosInputMapEntry>, I>>(
    base?: I,
  ): PlanItemPosManualInChangeRefYearly_PosInputMapEntry {
    return PlanItemPosManualInChangeRefYearly_PosInputMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualInChangeRefYearly_PosInputMapEntry>, I>>(
    object: I,
  ): PlanItemPosManualInChangeRefYearly_PosInputMapEntry {
    const message = createBasePlanItemPosManualInChangeRefYearly_PosInputMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosManualInChangeRefYearly_PosRefResultMapEntry(): PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry: MessageFns<
  PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry
> = {
  encode(
    message: PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualInChangeRefYearly_PosRefResultMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry>, I>>(
    base?: I,
  ): PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry {
    return PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry>, I>>(
    object: I,
  ): PlanItemPosManualInChangeRefYearly_PosRefResultMapEntry {
    const message = createBasePlanItemPosManualInChangeRefYearly_PosRefResultMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosManualInChangeRefYearly_PosResPlanMapEntry(): PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry: MessageFns<
  PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualInChangeRefYearly_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry {
    return PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosManualInChangeRefYearly_PosResPlanMapEntry {
    const message = createBasePlanItemPosManualInChangeRefYearly_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosManualDecInput(): PlanItemPosManualDecInput {
  return { pos_input_map: {}, pos_res_plan_map: {} };
}

export const PlanItemPosManualDecInput: MessageFns<PlanItemPosManualDecInput> = {
  encode(message: PlanItemPosManualDecInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.pos_input_map).forEach(([key, value]) => {
      PlanItemPosManualDecInput_PosInputMapEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosManualDecInput_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualDecInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualDecInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = PlanItemPosManualDecInput_PosInputMapEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.pos_input_map[entry2.key] = entry2.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosManualDecInput_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualDecInput {
    return {
      pos_input_map: isObject(object.pos_input_map)
        ? Object.entries(object.pos_input_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosManualDecInput): unknown {
    const obj: any = {};
    if (message.pos_input_map) {
      const entries = Object.entries(message.pos_input_map);
      if (entries.length > 0) {
        obj.pos_input_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualDecInput>, I>>(base?: I): PlanItemPosManualDecInput {
    return PlanItemPosManualDecInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualDecInput>, I>>(object: I): PlanItemPosManualDecInput {
    const message = createBasePlanItemPosManualDecInput();
    message.pos_input_map = Object.entries(object.pos_input_map ?? {}).reduce<{ [key: string]: InputManualMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosManualDecInput_PosInputMapEntry(): PlanItemPosManualDecInput_PosInputMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosManualDecInput_PosInputMapEntry: MessageFns<PlanItemPosManualDecInput_PosInputMapEntry> = {
  encode(message: PlanItemPosManualDecInput_PosInputMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualDecInput_PosInputMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualDecInput_PosInputMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualDecInput_PosInputMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosManualDecInput_PosInputMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualDecInput_PosInputMapEntry>, I>>(
    base?: I,
  ): PlanItemPosManualDecInput_PosInputMapEntry {
    return PlanItemPosManualDecInput_PosInputMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualDecInput_PosInputMapEntry>, I>>(
    object: I,
  ): PlanItemPosManualDecInput_PosInputMapEntry {
    const message = createBasePlanItemPosManualDecInput_PosInputMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosManualDecInput_PosResPlanMapEntry(): PlanItemPosManualDecInput_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosManualDecInput_PosResPlanMapEntry: MessageFns<PlanItemPosManualDecInput_PosResPlanMapEntry> = {
  encode(
    message: PlanItemPosManualDecInput_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualDecInput_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualDecInput_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualDecInput_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosManualDecInput_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualDecInput_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosManualDecInput_PosResPlanMapEntry {
    return PlanItemPosManualDecInput_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualDecInput_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosManualDecInput_PosResPlanMapEntry {
    const message = createBasePlanItemPosManualDecInput_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosMonthlyGrowthRate(): PlanItemPosMonthlyGrowthRate {
  return { pos_input_base_amount: 0, pos_input_map: {}, pos_res_plan_map: {} };
}

export const PlanItemPosMonthlyGrowthRate: MessageFns<PlanItemPosMonthlyGrowthRate> = {
  encode(message: PlanItemPosMonthlyGrowthRate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pos_input_base_amount !== 0) {
      writer.uint32(17).double(message.pos_input_base_amount);
    }
    Object.entries(message.pos_input_map).forEach(([key, value]) => {
      PlanItemPosMonthlyGrowthRate_PosInputMapEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(42).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosMonthlyGrowthRate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosMonthlyGrowthRate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.pos_input_base_amount = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = PlanItemPosMonthlyGrowthRate_PosInputMapEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.pos_input_map[entry3.key] = entry3.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.pos_res_plan_map[entry5.key] = entry5.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosMonthlyGrowthRate {
    return {
      pos_input_base_amount: isSet(object.pos_input_base_amount) ? globalThis.Number(object.pos_input_base_amount) : 0,
      pos_input_map: isObject(object.pos_input_map)
        ? Object.entries(object.pos_input_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosMonthlyGrowthRate): unknown {
    const obj: any = {};
    if (message.pos_input_base_amount !== 0) {
      obj.pos_input_base_amount = message.pos_input_base_amount;
    }
    if (message.pos_input_map) {
      const entries = Object.entries(message.pos_input_map);
      if (entries.length > 0) {
        obj.pos_input_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosMonthlyGrowthRate>, I>>(base?: I): PlanItemPosMonthlyGrowthRate {
    return PlanItemPosMonthlyGrowthRate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosMonthlyGrowthRate>, I>>(object: I): PlanItemPosMonthlyGrowthRate {
    const message = createBasePlanItemPosMonthlyGrowthRate();
    message.pos_input_base_amount = object.pos_input_base_amount ?? 0;
    message.pos_input_map = Object.entries(object.pos_input_map ?? {}).reduce<{ [key: string]: InputManualMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosMonthlyGrowthRate_PosInputMapEntry(): PlanItemPosMonthlyGrowthRate_PosInputMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosMonthlyGrowthRate_PosInputMapEntry: MessageFns<PlanItemPosMonthlyGrowthRate_PosInputMapEntry> =
  {
    encode(
      message: PlanItemPosMonthlyGrowthRate_PosInputMapEntry,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.key !== "") {
        writer.uint32(10).string(message.key);
      }
      if (message.value !== undefined) {
        InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosMonthlyGrowthRate_PosInputMapEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      let end = length === undefined ? reader.len : reader.pos + length;
      const message = createBasePlanItemPosMonthlyGrowthRate_PosInputMapEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = InputManualMap.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): PlanItemPosMonthlyGrowthRate_PosInputMapEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : "",
        value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
      };
    },

    toJSON(message: PlanItemPosMonthlyGrowthRate_PosInputMapEntry): unknown {
      const obj: any = {};
      if (message.key !== "") {
        obj.key = message.key;
      }
      if (message.value !== undefined) {
        obj.value = InputManualMap.toJSON(message.value);
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<PlanItemPosMonthlyGrowthRate_PosInputMapEntry>, I>>(
      base?: I,
    ): PlanItemPosMonthlyGrowthRate_PosInputMapEntry {
      return PlanItemPosMonthlyGrowthRate_PosInputMapEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PlanItemPosMonthlyGrowthRate_PosInputMapEntry>, I>>(
      object: I,
    ): PlanItemPosMonthlyGrowthRate_PosInputMapEntry {
      const message = createBasePlanItemPosMonthlyGrowthRate_PosInputMapEntry();
      message.key = object.key ?? "";
      message.value = (object.value !== undefined && object.value !== null)
        ? InputManualMap.fromPartial(object.value)
        : undefined;
      return message;
    },
  };

function createBasePlanItemPosMonthlyGrowthRate_PosResPlanMapEntry(): PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry: MessageFns<
  PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosMonthlyGrowthRate_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry {
    return PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosMonthlyGrowthRate_PosResPlanMapEntry {
    const message = createBasePlanItemPosMonthlyGrowthRate_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosManualDecInputInChange(): PlanItemPosManualDecInputInChange {
  return { pos_input_map: {}, pos_input_base_amount: 0, pos_res_plan_map: {} };
}

export const PlanItemPosManualDecInputInChange: MessageFns<PlanItemPosManualDecInputInChange> = {
  encode(message: PlanItemPosManualDecInputInChange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.pos_input_map).forEach(([key, value]) => {
      PlanItemPosManualDecInputInChange_PosInputMapEntry.encode({ key: key as any, value }, writer.uint32(18).fork())
        .join();
    });
    if (message.pos_input_base_amount !== 0) {
      writer.uint32(25).double(message.pos_input_base_amount);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosManualDecInputInChange_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualDecInputInChange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualDecInputInChange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = PlanItemPosManualDecInputInChange_PosInputMapEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.pos_input_map[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.pos_input_base_amount = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosManualDecInputInChange_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualDecInputInChange {
    return {
      pos_input_map: isObject(object.pos_input_map)
        ? Object.entries(object.pos_input_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      pos_input_base_amount: isSet(object.pos_input_base_amount) ? globalThis.Number(object.pos_input_base_amount) : 0,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosManualDecInputInChange): unknown {
    const obj: any = {};
    if (message.pos_input_map) {
      const entries = Object.entries(message.pos_input_map);
      if (entries.length > 0) {
        obj.pos_input_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_input_base_amount !== 0) {
      obj.pos_input_base_amount = message.pos_input_base_amount;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualDecInputInChange>, I>>(
    base?: I,
  ): PlanItemPosManualDecInputInChange {
    return PlanItemPosManualDecInputInChange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualDecInputInChange>, I>>(
    object: I,
  ): PlanItemPosManualDecInputInChange {
    const message = createBasePlanItemPosManualDecInputInChange();
    message.pos_input_map = Object.entries(object.pos_input_map ?? {}).reduce<{ [key: string]: InputManualMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.pos_input_base_amount = object.pos_input_base_amount ?? 0;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosManualDecInputInChange_PosInputMapEntry(): PlanItemPosManualDecInputInChange_PosInputMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosManualDecInputInChange_PosInputMapEntry: MessageFns<
  PlanItemPosManualDecInputInChange_PosInputMapEntry
> = {
  encode(
    message: PlanItemPosManualDecInputInChange_PosInputMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualDecInputInChange_PosInputMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualDecInputInChange_PosInputMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualDecInputInChange_PosInputMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosManualDecInputInChange_PosInputMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualDecInputInChange_PosInputMapEntry>, I>>(
    base?: I,
  ): PlanItemPosManualDecInputInChange_PosInputMapEntry {
    return PlanItemPosManualDecInputInChange_PosInputMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualDecInputInChange_PosInputMapEntry>, I>>(
    object: I,
  ): PlanItemPosManualDecInputInChange_PosInputMapEntry {
    const message = createBasePlanItemPosManualDecInputInChange_PosInputMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosManualDecInputInChange_PosResPlanMapEntry(): PlanItemPosManualDecInputInChange_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosManualDecInputInChange_PosResPlanMapEntry: MessageFns<
  PlanItemPosManualDecInputInChange_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosManualDecInputInChange_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualDecInputInChange_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualDecInputInChange_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualDecInputInChange_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosManualDecInputInChange_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualDecInputInChange_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosManualDecInputInChange_PosResPlanMapEntry {
    return PlanItemPosManualDecInputInChange_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualDecInputInChange_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosManualDecInputInChange_PosResPlanMapEntry {
    const message = createBasePlanItemPosManualDecInputInChange_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicAnnuallyGrowthRate(): PlanItemPosLogicAnnuallyGrowthRate {
  return {
    pos_input_base_amount: 0,
    pos_input_seas_key: "",
    pos_input_ytg_map: {},
    pos_input_growth_map: {},
    pos_res_growth_map: {},
    pos_res_plan_map: {},
  };
}

export const PlanItemPosLogicAnnuallyGrowthRate: MessageFns<PlanItemPosLogicAnnuallyGrowthRate> = {
  encode(message: PlanItemPosLogicAnnuallyGrowthRate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pos_input_base_amount !== 0) {
      writer.uint32(17).double(message.pos_input_base_amount);
    }
    if (message.pos_input_seas_key !== "") {
      writer.uint32(26).string(message.pos_input_seas_key);
    }
    Object.entries(message.pos_input_ytg_map).forEach(([key, value]) => {
      PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry.encode(
        { key: key as any, value },
        writer.uint32(34).fork(),
      ).join();
    });
    Object.entries(message.pos_input_growth_map).forEach(([key, value]) => {
      PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry.encode(
        { key: key as any, value },
        writer.uint32(42).fork(),
      ).join();
    });
    Object.entries(message.pos_res_growth_map).forEach(([key, value]) => {
      PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry.encode(
        { key: key as any, value },
        writer.uint32(50).fork(),
      ).join();
    });
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(58).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicAnnuallyGrowthRate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.pos_input_base_amount = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pos_input_seas_key = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_input_ytg_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.pos_input_growth_map[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.pos_res_growth_map[entry6.key] = entry6.value;
          }
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.pos_res_plan_map[entry7.key] = entry7.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicAnnuallyGrowthRate {
    return {
      pos_input_base_amount: isSet(object.pos_input_base_amount) ? globalThis.Number(object.pos_input_base_amount) : 0,
      pos_input_seas_key: isSet(object.pos_input_seas_key) ? globalThis.String(object.pos_input_seas_key) : "",
      pos_input_ytg_map: isObject(object.pos_input_ytg_map)
        ? Object.entries(object.pos_input_ytg_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      pos_input_growth_map: isObject(object.pos_input_growth_map)
        ? Object.entries(object.pos_input_growth_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_res_growth_map: isObject(object.pos_res_growth_map)
        ? Object.entries(object.pos_res_growth_map).reduce<
          { [key: string]: PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap }
        >((acc, [key, value]) => {
          acc[key] = PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosLogicAnnuallyGrowthRate): unknown {
    const obj: any = {};
    if (message.pos_input_base_amount !== 0) {
      obj.pos_input_base_amount = message.pos_input_base_amount;
    }
    if (message.pos_input_seas_key !== "") {
      obj.pos_input_seas_key = message.pos_input_seas_key;
    }
    if (message.pos_input_ytg_map) {
      const entries = Object.entries(message.pos_input_ytg_map);
      if (entries.length > 0) {
        obj.pos_input_ytg_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_ytg_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_input_growth_map) {
      const entries = Object.entries(message.pos_input_growth_map);
      if (entries.length > 0) {
        obj.pos_input_growth_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_growth_map[k] = v;
        });
      }
    }
    if (message.pos_res_growth_map) {
      const entries = Object.entries(message.pos_res_growth_map);
      if (entries.length > 0) {
        obj.pos_res_growth_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_growth_map[k] = PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap.toJSON(v);
        });
      }
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate>, I>>(
    base?: I,
  ): PlanItemPosLogicAnnuallyGrowthRate {
    return PlanItemPosLogicAnnuallyGrowthRate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate>, I>>(
    object: I,
  ): PlanItemPosLogicAnnuallyGrowthRate {
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate();
    message.pos_input_base_amount = object.pos_input_base_amount ?? 0;
    message.pos_input_seas_key = object.pos_input_seas_key ?? "";
    message.pos_input_ytg_map = Object.entries(object.pos_input_ytg_map ?? {}).reduce<
      { [key: string]: InputManualMap }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = InputManualMap.fromPartial(value);
      }
      return acc;
    }, {});
    message.pos_input_growth_map = Object.entries(object.pos_input_growth_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_res_growth_map = Object.entries(object.pos_res_growth_map ?? {}).reduce<
      { [key: string]: PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap.fromPartial(value);
      }
      return acc;
    }, {});
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry(): PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry: MessageFns<
  PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry
> = {
  encode(
    message: PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry {
    return PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry {
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate_PosInputYtgMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry(): PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry: MessageFns<
  PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry
> = {
  encode(
    message: PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry {
    return PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry {
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate_PosInputGrowthMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry(): PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry: MessageFns<
  PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry
> = {
  encode(
    message: PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value)
        ? PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry {
    return PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry {
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate_PosResGrowthMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry(): PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry: MessageFns<
  PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry {
    return PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry {
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap(): PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap {
  return { growth_base: 0, growth_res: 0 };
}

export const PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap: MessageFns<
  PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap
> = {
  encode(
    message: PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.growth_base !== 0) {
      writer.uint32(9).double(message.growth_base);
    }
    if (message.growth_res !== 0) {
      writer.uint32(17).double(message.growth_res);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.growth_base = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.growth_res = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap {
    return {
      growth_base: isSet(object.growth_base) ? globalThis.Number(object.growth_base) : 0,
      growth_res: isSet(object.growth_res) ? globalThis.Number(object.growth_res) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap): unknown {
    const obj: any = {};
    if (message.growth_base !== 0) {
      obj.growth_base = message.growth_base;
    }
    if (message.growth_res !== 0) {
      obj.growth_res = message.growth_res;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap>, I>>(
    base?: I,
  ): PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap {
    return PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap>, I>>(
    object: I,
  ): PlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap {
    const message = createBasePlanItemPosLogicAnnuallyGrowthRate_AnnuallyGrowthMap();
    message.growth_base = object.growth_base ?? 0;
    message.growth_res = object.growth_res ?? 0;
    return message;
  },
};

function createBasePlanItemPosManualPercInput(): PlanItemPosManualPercInput {
  return { is_struct_pos: false, pos_res_plan_map: {}, pos_input_map: {} };
}

export const PlanItemPosManualPercInput: MessageFns<PlanItemPosManualPercInput> = {
  encode(message: PlanItemPosManualPercInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosManualPercInput_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    Object.entries(message.pos_input_map).forEach(([key, value]) => {
      PlanItemPosManualPercInput_PosInputMapEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualPercInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualPercInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosManualPercInput_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = PlanItemPosManualPercInput_PosInputMapEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.pos_input_map[entry6.key] = entry6.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualPercInput {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_input_map: isObject(object.pos_input_map)
        ? Object.entries(object.pos_input_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosManualPercInput): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_input_map) {
      const entries = Object.entries(message.pos_input_map);
      if (entries.length > 0) {
        obj.pos_input_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualPercInput>, I>>(base?: I): PlanItemPosManualPercInput {
    return PlanItemPosManualPercInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualPercInput>, I>>(object: I): PlanItemPosManualPercInput {
    const message = createBasePlanItemPosManualPercInput();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_input_map = Object.entries(object.pos_input_map ?? {}).reduce<{ [key: string]: InputManualMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosManualPercInput_PosResPlanMapEntry(): PlanItemPosManualPercInput_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosManualPercInput_PosResPlanMapEntry: MessageFns<PlanItemPosManualPercInput_PosResPlanMapEntry> =
  {
    encode(
      message: PlanItemPosManualPercInput_PosResPlanMapEntry,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.key !== "") {
        writer.uint32(10).string(message.key);
      }
      if (message.value !== 0) {
        writer.uint32(17).double(message.value);
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualPercInput_PosResPlanMapEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      let end = length === undefined ? reader.len : reader.pos + length;
      const message = createBasePlanItemPosManualPercInput_PosResPlanMapEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 17) {
              break;
            }

            message.value = reader.double();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): PlanItemPosManualPercInput_PosResPlanMapEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : "",
        value: isSet(object.value) ? globalThis.Number(object.value) : 0,
      };
    },

    toJSON(message: PlanItemPosManualPercInput_PosResPlanMapEntry): unknown {
      const obj: any = {};
      if (message.key !== "") {
        obj.key = message.key;
      }
      if (message.value !== 0) {
        obj.value = message.value;
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<PlanItemPosManualPercInput_PosResPlanMapEntry>, I>>(
      base?: I,
    ): PlanItemPosManualPercInput_PosResPlanMapEntry {
      return PlanItemPosManualPercInput_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PlanItemPosManualPercInput_PosResPlanMapEntry>, I>>(
      object: I,
    ): PlanItemPosManualPercInput_PosResPlanMapEntry {
      const message = createBasePlanItemPosManualPercInput_PosResPlanMapEntry();
      message.key = object.key ?? "";
      message.value = object.value ?? 0;
      return message;
    },
  };

function createBasePlanItemPosManualPercInput_PosInputMapEntry(): PlanItemPosManualPercInput_PosInputMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosManualPercInput_PosInputMapEntry: MessageFns<PlanItemPosManualPercInput_PosInputMapEntry> = {
  encode(
    message: PlanItemPosManualPercInput_PosInputMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosManualPercInput_PosInputMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosManualPercInput_PosInputMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosManualPercInput_PosInputMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosManualPercInput_PosInputMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosManualPercInput_PosInputMapEntry>, I>>(
    base?: I,
  ): PlanItemPosManualPercInput_PosInputMapEntry {
    return PlanItemPosManualPercInput_PosInputMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosManualPercInput_PosInputMapEntry>, I>>(
    object: I,
  ): PlanItemPosManualPercInput_PosInputMapEntry {
    const message = createBasePlanItemPosManualPercInput_PosInputMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosCapexCfg(): PlanItemPosCapexCfg {
  return {
    is_struct_pos: false,
    pos_res_plan_map: {},
    pos_input_capex_year: 0,
    pos_input_capex_map: {},
    pos_res_capex_map: {},
    pos_res_target: "",
    pos_res_target_plan_item_pos_id: "",
  };
}

export const PlanItemPosCapexCfg: MessageFns<PlanItemPosCapexCfg> = {
  encode(message: PlanItemPosCapexCfg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosCapexCfg_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    if (message.pos_input_capex_year !== 0) {
      writer.uint32(48).int32(message.pos_input_capex_year);
    }
    Object.entries(message.pos_input_capex_map).forEach(([key, value]) => {
      PlanItemPosCapexCfg_PosInputCapexMapEntry.encode({ key: key as any, value }, writer.uint32(58).fork()).join();
    });
    Object.entries(message.pos_res_capex_map).forEach(([key, value]) => {
      PlanItemPosCapexCfg_PosResCapexMapEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
    });
    if (message.pos_res_target !== "") {
      writer.uint32(74).string(message.pos_res_target);
    }
    if (message.pos_res_target_plan_item_pos_id !== "") {
      writer.uint32(82).string(message.pos_res_target_plan_item_pos_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosCapexCfg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosCapexCfg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosCapexCfg_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.pos_input_capex_year = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = PlanItemPosCapexCfg_PosInputCapexMapEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.pos_input_capex_map[entry7.key] = entry7.value;
          }
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = PlanItemPosCapexCfg_PosResCapexMapEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.pos_res_capex_map[entry8.key] = entry8.value;
          }
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.pos_res_target = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pos_res_target_plan_item_pos_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosCapexCfg {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_input_capex_year: isSet(object.pos_input_capex_year) ? globalThis.Number(object.pos_input_capex_year) : 0,
      pos_input_capex_map: isObject(object.pos_input_capex_map)
        ? Object.entries(object.pos_input_capex_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      pos_res_capex_map: isObject(object.pos_res_capex_map)
        ? Object.entries(object.pos_res_capex_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_res_target: isSet(object.pos_res_target) ? globalThis.String(object.pos_res_target) : "",
      pos_res_target_plan_item_pos_id: isSet(object.pos_res_target_plan_item_pos_id)
        ? globalThis.String(object.pos_res_target_plan_item_pos_id)
        : "",
    };
  },

  toJSON(message: PlanItemPosCapexCfg): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_input_capex_year !== 0) {
      obj.pos_input_capex_year = Math.round(message.pos_input_capex_year);
    }
    if (message.pos_input_capex_map) {
      const entries = Object.entries(message.pos_input_capex_map);
      if (entries.length > 0) {
        obj.pos_input_capex_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_capex_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_res_capex_map) {
      const entries = Object.entries(message.pos_res_capex_map);
      if (entries.length > 0) {
        obj.pos_res_capex_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_capex_map[k] = v;
        });
      }
    }
    if (message.pos_res_target !== "") {
      obj.pos_res_target = message.pos_res_target;
    }
    if (message.pos_res_target_plan_item_pos_id !== "") {
      obj.pos_res_target_plan_item_pos_id = message.pos_res_target_plan_item_pos_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosCapexCfg>, I>>(base?: I): PlanItemPosCapexCfg {
    return PlanItemPosCapexCfg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosCapexCfg>, I>>(object: I): PlanItemPosCapexCfg {
    const message = createBasePlanItemPosCapexCfg();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_input_capex_year = object.pos_input_capex_year ?? 0;
    message.pos_input_capex_map = Object.entries(object.pos_input_capex_map ?? {}).reduce<
      { [key: string]: InputManualMap }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = InputManualMap.fromPartial(value);
      }
      return acc;
    }, {});
    message.pos_res_capex_map = Object.entries(object.pos_res_capex_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_res_target = object.pos_res_target ?? "";
    message.pos_res_target_plan_item_pos_id = object.pos_res_target_plan_item_pos_id ?? "";
    return message;
  },
};

function createBasePlanItemPosCapexCfg_PosResPlanMapEntry(): PlanItemPosCapexCfg_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosCapexCfg_PosResPlanMapEntry: MessageFns<PlanItemPosCapexCfg_PosResPlanMapEntry> = {
  encode(message: PlanItemPosCapexCfg_PosResPlanMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosCapexCfg_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosCapexCfg_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosCapexCfg_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosCapexCfg_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosCapexCfg_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosCapexCfg_PosResPlanMapEntry {
    return PlanItemPosCapexCfg_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosCapexCfg_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosCapexCfg_PosResPlanMapEntry {
    const message = createBasePlanItemPosCapexCfg_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosCapexCfg_PosInputCapexMapEntry(): PlanItemPosCapexCfg_PosInputCapexMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosCapexCfg_PosInputCapexMapEntry: MessageFns<PlanItemPosCapexCfg_PosInputCapexMapEntry> = {
  encode(message: PlanItemPosCapexCfg_PosInputCapexMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosCapexCfg_PosInputCapexMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosCapexCfg_PosInputCapexMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosCapexCfg_PosInputCapexMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosCapexCfg_PosInputCapexMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosCapexCfg_PosInputCapexMapEntry>, I>>(
    base?: I,
  ): PlanItemPosCapexCfg_PosInputCapexMapEntry {
    return PlanItemPosCapexCfg_PosInputCapexMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosCapexCfg_PosInputCapexMapEntry>, I>>(
    object: I,
  ): PlanItemPosCapexCfg_PosInputCapexMapEntry {
    const message = createBasePlanItemPosCapexCfg_PosInputCapexMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosCapexCfg_PosResCapexMapEntry(): PlanItemPosCapexCfg_PosResCapexMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosCapexCfg_PosResCapexMapEntry: MessageFns<PlanItemPosCapexCfg_PosResCapexMapEntry> = {
  encode(message: PlanItemPosCapexCfg_PosResCapexMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosCapexCfg_PosResCapexMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosCapexCfg_PosResCapexMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosCapexCfg_PosResCapexMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosCapexCfg_PosResCapexMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosCapexCfg_PosResCapexMapEntry>, I>>(
    base?: I,
  ): PlanItemPosCapexCfg_PosResCapexMapEntry {
    return PlanItemPosCapexCfg_PosResCapexMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosCapexCfg_PosResCapexMapEntry>, I>>(
    object: I,
  ): PlanItemPosCapexCfg_PosResCapexMapEntry {
    const message = createBasePlanItemPosCapexCfg_PosResCapexMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosDioReverseFormula(): PlanItemPosDioReverseFormula {
  return {
    is_struct_pos: false,
    pos_res_plan_map: {},
    pos_formula_based: undefined,
    pos_res_dio_map: {},
    pos_input_map: {},
  };
}

export const PlanItemPosDioReverseFormula: MessageFns<PlanItemPosDioReverseFormula> = {
  encode(message: PlanItemPosDioReverseFormula, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosDioReverseFormula_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    if (message.pos_formula_based !== undefined) {
      PlanItemPosFormulaBased.encode(message.pos_formula_based, writer.uint32(866).fork()).join();
    }
    Object.entries(message.pos_res_dio_map).forEach(([key, value]) => {
      PlanItemPosDioReverseFormula_PosResDioMapEntry.encode({ key: key as any, value }, writer.uint32(58).fork())
        .join();
    });
    Object.entries(message.pos_input_map).forEach(([key, value]) => {
      PlanItemPosDioReverseFormula_PosInputMapEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDioReverseFormula {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosDioReverseFormula();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosDioReverseFormula_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.pos_formula_based = PlanItemPosFormulaBased.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = PlanItemPosDioReverseFormula_PosResDioMapEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.pos_res_dio_map[entry7.key] = entry7.value;
          }
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = PlanItemPosDioReverseFormula_PosInputMapEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.pos_input_map[entry8.key] = entry8.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosDioReverseFormula {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_formula_based: isSet(object.pos_formula_based)
        ? PlanItemPosFormulaBased.fromJSON(object.pos_formula_based)
        : undefined,
      pos_res_dio_map: isObject(object.pos_res_dio_map)
        ? Object.entries(object.pos_res_dio_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_input_map: isObject(object.pos_input_map)
        ? Object.entries(object.pos_input_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosDioReverseFormula): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_formula_based !== undefined) {
      obj.pos_formula_based = PlanItemPosFormulaBased.toJSON(message.pos_formula_based);
    }
    if (message.pos_res_dio_map) {
      const entries = Object.entries(message.pos_res_dio_map);
      if (entries.length > 0) {
        obj.pos_res_dio_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_dio_map[k] = v;
        });
      }
    }
    if (message.pos_input_map) {
      const entries = Object.entries(message.pos_input_map);
      if (entries.length > 0) {
        obj.pos_input_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosDioReverseFormula>, I>>(base?: I): PlanItemPosDioReverseFormula {
    return PlanItemPosDioReverseFormula.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosDioReverseFormula>, I>>(object: I): PlanItemPosDioReverseFormula {
    const message = createBasePlanItemPosDioReverseFormula();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_formula_based = (object.pos_formula_based !== undefined && object.pos_formula_based !== null)
      ? PlanItemPosFormulaBased.fromPartial(object.pos_formula_based)
      : undefined;
    message.pos_res_dio_map = Object.entries(object.pos_res_dio_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_input_map = Object.entries(object.pos_input_map ?? {}).reduce<{ [key: string]: InputManualMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosDioReverseFormula_PosResPlanMapEntry(): PlanItemPosDioReverseFormula_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosDioReverseFormula_PosResPlanMapEntry: MessageFns<
  PlanItemPosDioReverseFormula_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosDioReverseFormula_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDioReverseFormula_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosDioReverseFormula_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosDioReverseFormula_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosDioReverseFormula_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosDioReverseFormula_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosDioReverseFormula_PosResPlanMapEntry {
    return PlanItemPosDioReverseFormula_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosDioReverseFormula_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosDioReverseFormula_PosResPlanMapEntry {
    const message = createBasePlanItemPosDioReverseFormula_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosDioReverseFormula_PosResDioMapEntry(): PlanItemPosDioReverseFormula_PosResDioMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosDioReverseFormula_PosResDioMapEntry: MessageFns<
  PlanItemPosDioReverseFormula_PosResDioMapEntry
> = {
  encode(
    message: PlanItemPosDioReverseFormula_PosResDioMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDioReverseFormula_PosResDioMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosDioReverseFormula_PosResDioMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosDioReverseFormula_PosResDioMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosDioReverseFormula_PosResDioMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosDioReverseFormula_PosResDioMapEntry>, I>>(
    base?: I,
  ): PlanItemPosDioReverseFormula_PosResDioMapEntry {
    return PlanItemPosDioReverseFormula_PosResDioMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosDioReverseFormula_PosResDioMapEntry>, I>>(
    object: I,
  ): PlanItemPosDioReverseFormula_PosResDioMapEntry {
    const message = createBasePlanItemPosDioReverseFormula_PosResDioMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosDioReverseFormula_PosInputMapEntry(): PlanItemPosDioReverseFormula_PosInputMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosDioReverseFormula_PosInputMapEntry: MessageFns<PlanItemPosDioReverseFormula_PosInputMapEntry> =
  {
    encode(
      message: PlanItemPosDioReverseFormula_PosInputMapEntry,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.key !== "") {
        writer.uint32(10).string(message.key);
      }
      if (message.value !== undefined) {
        InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDioReverseFormula_PosInputMapEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      let end = length === undefined ? reader.len : reader.pos + length;
      const message = createBasePlanItemPosDioReverseFormula_PosInputMapEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = InputManualMap.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): PlanItemPosDioReverseFormula_PosInputMapEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : "",
        value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
      };
    },

    toJSON(message: PlanItemPosDioReverseFormula_PosInputMapEntry): unknown {
      const obj: any = {};
      if (message.key !== "") {
        obj.key = message.key;
      }
      if (message.value !== undefined) {
        obj.value = InputManualMap.toJSON(message.value);
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<PlanItemPosDioReverseFormula_PosInputMapEntry>, I>>(
      base?: I,
    ): PlanItemPosDioReverseFormula_PosInputMapEntry {
      return PlanItemPosDioReverseFormula_PosInputMapEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PlanItemPosDioReverseFormula_PosInputMapEntry>, I>>(
      object: I,
    ): PlanItemPosDioReverseFormula_PosInputMapEntry {
      const message = createBasePlanItemPosDioReverseFormula_PosInputMapEntry();
      message.key = object.key ?? "";
      message.value = (object.value !== undefined && object.value !== null)
        ? InputManualMap.fromPartial(object.value)
        : undefined;
      return message;
    },
  };

function createBasePlanItemPosDpoReverseFormula(): PlanItemPosDpoReverseFormula {
  return {
    is_struct_pos: false,
    pos_res_plan_map: {},
    pos_formula_based: undefined,
    pos_res_dpo_map: {},
    pos_input_map: {},
  };
}

export const PlanItemPosDpoReverseFormula: MessageFns<PlanItemPosDpoReverseFormula> = {
  encode(message: PlanItemPosDpoReverseFormula, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosDpoReverseFormula_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    if (message.pos_formula_based !== undefined) {
      PlanItemPosFormulaBased.encode(message.pos_formula_based, writer.uint32(866).fork()).join();
    }
    Object.entries(message.pos_res_dpo_map).forEach(([key, value]) => {
      PlanItemPosDpoReverseFormula_PosResDpoMapEntry.encode({ key: key as any, value }, writer.uint32(58).fork())
        .join();
    });
    Object.entries(message.pos_input_map).forEach(([key, value]) => {
      PlanItemPosDpoReverseFormula_PosInputMapEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDpoReverseFormula {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosDpoReverseFormula();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosDpoReverseFormula_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.pos_formula_based = PlanItemPosFormulaBased.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = PlanItemPosDpoReverseFormula_PosResDpoMapEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.pos_res_dpo_map[entry7.key] = entry7.value;
          }
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = PlanItemPosDpoReverseFormula_PosInputMapEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.pos_input_map[entry8.key] = entry8.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosDpoReverseFormula {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_formula_based: isSet(object.pos_formula_based)
        ? PlanItemPosFormulaBased.fromJSON(object.pos_formula_based)
        : undefined,
      pos_res_dpo_map: isObject(object.pos_res_dpo_map)
        ? Object.entries(object.pos_res_dpo_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_input_map: isObject(object.pos_input_map)
        ? Object.entries(object.pos_input_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosDpoReverseFormula): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_formula_based !== undefined) {
      obj.pos_formula_based = PlanItemPosFormulaBased.toJSON(message.pos_formula_based);
    }
    if (message.pos_res_dpo_map) {
      const entries = Object.entries(message.pos_res_dpo_map);
      if (entries.length > 0) {
        obj.pos_res_dpo_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_dpo_map[k] = v;
        });
      }
    }
    if (message.pos_input_map) {
      const entries = Object.entries(message.pos_input_map);
      if (entries.length > 0) {
        obj.pos_input_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosDpoReverseFormula>, I>>(base?: I): PlanItemPosDpoReverseFormula {
    return PlanItemPosDpoReverseFormula.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosDpoReverseFormula>, I>>(object: I): PlanItemPosDpoReverseFormula {
    const message = createBasePlanItemPosDpoReverseFormula();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_formula_based = (object.pos_formula_based !== undefined && object.pos_formula_based !== null)
      ? PlanItemPosFormulaBased.fromPartial(object.pos_formula_based)
      : undefined;
    message.pos_res_dpo_map = Object.entries(object.pos_res_dpo_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_input_map = Object.entries(object.pos_input_map ?? {}).reduce<{ [key: string]: InputManualMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosDpoReverseFormula_PosResPlanMapEntry(): PlanItemPosDpoReverseFormula_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosDpoReverseFormula_PosResPlanMapEntry: MessageFns<
  PlanItemPosDpoReverseFormula_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosDpoReverseFormula_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDpoReverseFormula_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosDpoReverseFormula_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosDpoReverseFormula_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosDpoReverseFormula_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosDpoReverseFormula_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosDpoReverseFormula_PosResPlanMapEntry {
    return PlanItemPosDpoReverseFormula_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosDpoReverseFormula_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosDpoReverseFormula_PosResPlanMapEntry {
    const message = createBasePlanItemPosDpoReverseFormula_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosDpoReverseFormula_PosResDpoMapEntry(): PlanItemPosDpoReverseFormula_PosResDpoMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosDpoReverseFormula_PosResDpoMapEntry: MessageFns<
  PlanItemPosDpoReverseFormula_PosResDpoMapEntry
> = {
  encode(
    message: PlanItemPosDpoReverseFormula_PosResDpoMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDpoReverseFormula_PosResDpoMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosDpoReverseFormula_PosResDpoMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosDpoReverseFormula_PosResDpoMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosDpoReverseFormula_PosResDpoMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosDpoReverseFormula_PosResDpoMapEntry>, I>>(
    base?: I,
  ): PlanItemPosDpoReverseFormula_PosResDpoMapEntry {
    return PlanItemPosDpoReverseFormula_PosResDpoMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosDpoReverseFormula_PosResDpoMapEntry>, I>>(
    object: I,
  ): PlanItemPosDpoReverseFormula_PosResDpoMapEntry {
    const message = createBasePlanItemPosDpoReverseFormula_PosResDpoMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosDpoReverseFormula_PosInputMapEntry(): PlanItemPosDpoReverseFormula_PosInputMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosDpoReverseFormula_PosInputMapEntry: MessageFns<PlanItemPosDpoReverseFormula_PosInputMapEntry> =
  {
    encode(
      message: PlanItemPosDpoReverseFormula_PosInputMapEntry,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.key !== "") {
        writer.uint32(10).string(message.key);
      }
      if (message.value !== undefined) {
        InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDpoReverseFormula_PosInputMapEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      let end = length === undefined ? reader.len : reader.pos + length;
      const message = createBasePlanItemPosDpoReverseFormula_PosInputMapEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = InputManualMap.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): PlanItemPosDpoReverseFormula_PosInputMapEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : "",
        value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
      };
    },

    toJSON(message: PlanItemPosDpoReverseFormula_PosInputMapEntry): unknown {
      const obj: any = {};
      if (message.key !== "") {
        obj.key = message.key;
      }
      if (message.value !== undefined) {
        obj.value = InputManualMap.toJSON(message.value);
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<PlanItemPosDpoReverseFormula_PosInputMapEntry>, I>>(
      base?: I,
    ): PlanItemPosDpoReverseFormula_PosInputMapEntry {
      return PlanItemPosDpoReverseFormula_PosInputMapEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PlanItemPosDpoReverseFormula_PosInputMapEntry>, I>>(
      object: I,
    ): PlanItemPosDpoReverseFormula_PosInputMapEntry {
      const message = createBasePlanItemPosDpoReverseFormula_PosInputMapEntry();
      message.key = object.key ?? "";
      message.value = (object.value !== undefined && object.value !== null)
        ? InputManualMap.fromPartial(object.value)
        : undefined;
      return message;
    },
  };

function createBasePlanItemPosDsoReverseFormula(): PlanItemPosDsoReverseFormula {
  return {
    is_struct_pos: false,
    pos_res_plan_map: {},
    pos_formula_based: undefined,
    pos_res_dso_map: {},
    pos_input_map: {},
  };
}

export const PlanItemPosDsoReverseFormula: MessageFns<PlanItemPosDsoReverseFormula> = {
  encode(message: PlanItemPosDsoReverseFormula, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosDsoReverseFormula_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    if (message.pos_formula_based !== undefined) {
      PlanItemPosFormulaBased.encode(message.pos_formula_based, writer.uint32(866).fork()).join();
    }
    Object.entries(message.pos_res_dso_map).forEach(([key, value]) => {
      PlanItemPosDsoReverseFormula_PosResDsoMapEntry.encode({ key: key as any, value }, writer.uint32(58).fork())
        .join();
    });
    Object.entries(message.pos_input_map).forEach(([key, value]) => {
      PlanItemPosDsoReverseFormula_PosInputMapEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDsoReverseFormula {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosDsoReverseFormula();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosDsoReverseFormula_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.pos_formula_based = PlanItemPosFormulaBased.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = PlanItemPosDsoReverseFormula_PosResDsoMapEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.pos_res_dso_map[entry7.key] = entry7.value;
          }
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = PlanItemPosDsoReverseFormula_PosInputMapEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.pos_input_map[entry8.key] = entry8.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosDsoReverseFormula {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_formula_based: isSet(object.pos_formula_based)
        ? PlanItemPosFormulaBased.fromJSON(object.pos_formula_based)
        : undefined,
      pos_res_dso_map: isObject(object.pos_res_dso_map)
        ? Object.entries(object.pos_res_dso_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_input_map: isObject(object.pos_input_map)
        ? Object.entries(object.pos_input_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosDsoReverseFormula): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_formula_based !== undefined) {
      obj.pos_formula_based = PlanItemPosFormulaBased.toJSON(message.pos_formula_based);
    }
    if (message.pos_res_dso_map) {
      const entries = Object.entries(message.pos_res_dso_map);
      if (entries.length > 0) {
        obj.pos_res_dso_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_dso_map[k] = v;
        });
      }
    }
    if (message.pos_input_map) {
      const entries = Object.entries(message.pos_input_map);
      if (entries.length > 0) {
        obj.pos_input_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosDsoReverseFormula>, I>>(base?: I): PlanItemPosDsoReverseFormula {
    return PlanItemPosDsoReverseFormula.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosDsoReverseFormula>, I>>(object: I): PlanItemPosDsoReverseFormula {
    const message = createBasePlanItemPosDsoReverseFormula();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_formula_based = (object.pos_formula_based !== undefined && object.pos_formula_based !== null)
      ? PlanItemPosFormulaBased.fromPartial(object.pos_formula_based)
      : undefined;
    message.pos_res_dso_map = Object.entries(object.pos_res_dso_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_input_map = Object.entries(object.pos_input_map ?? {}).reduce<{ [key: string]: InputManualMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosDsoReverseFormula_PosResPlanMapEntry(): PlanItemPosDsoReverseFormula_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosDsoReverseFormula_PosResPlanMapEntry: MessageFns<
  PlanItemPosDsoReverseFormula_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosDsoReverseFormula_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDsoReverseFormula_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosDsoReverseFormula_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosDsoReverseFormula_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosDsoReverseFormula_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosDsoReverseFormula_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosDsoReverseFormula_PosResPlanMapEntry {
    return PlanItemPosDsoReverseFormula_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosDsoReverseFormula_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosDsoReverseFormula_PosResPlanMapEntry {
    const message = createBasePlanItemPosDsoReverseFormula_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosDsoReverseFormula_PosResDsoMapEntry(): PlanItemPosDsoReverseFormula_PosResDsoMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosDsoReverseFormula_PosResDsoMapEntry: MessageFns<
  PlanItemPosDsoReverseFormula_PosResDsoMapEntry
> = {
  encode(
    message: PlanItemPosDsoReverseFormula_PosResDsoMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDsoReverseFormula_PosResDsoMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosDsoReverseFormula_PosResDsoMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosDsoReverseFormula_PosResDsoMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosDsoReverseFormula_PosResDsoMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosDsoReverseFormula_PosResDsoMapEntry>, I>>(
    base?: I,
  ): PlanItemPosDsoReverseFormula_PosResDsoMapEntry {
    return PlanItemPosDsoReverseFormula_PosResDsoMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosDsoReverseFormula_PosResDsoMapEntry>, I>>(
    object: I,
  ): PlanItemPosDsoReverseFormula_PosResDsoMapEntry {
    const message = createBasePlanItemPosDsoReverseFormula_PosResDsoMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosDsoReverseFormula_PosInputMapEntry(): PlanItemPosDsoReverseFormula_PosInputMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosDsoReverseFormula_PosInputMapEntry: MessageFns<PlanItemPosDsoReverseFormula_PosInputMapEntry> =
  {
    encode(
      message: PlanItemPosDsoReverseFormula_PosInputMapEntry,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.key !== "") {
        writer.uint32(10).string(message.key);
      }
      if (message.value !== undefined) {
        InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosDsoReverseFormula_PosInputMapEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      let end = length === undefined ? reader.len : reader.pos + length;
      const message = createBasePlanItemPosDsoReverseFormula_PosInputMapEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = InputManualMap.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): PlanItemPosDsoReverseFormula_PosInputMapEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : "",
        value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
      };
    },

    toJSON(message: PlanItemPosDsoReverseFormula_PosInputMapEntry): unknown {
      const obj: any = {};
      if (message.key !== "") {
        obj.key = message.key;
      }
      if (message.value !== undefined) {
        obj.value = InputManualMap.toJSON(message.value);
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<PlanItemPosDsoReverseFormula_PosInputMapEntry>, I>>(
      base?: I,
    ): PlanItemPosDsoReverseFormula_PosInputMapEntry {
      return PlanItemPosDsoReverseFormula_PosInputMapEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PlanItemPosDsoReverseFormula_PosInputMapEntry>, I>>(
      object: I,
    ): PlanItemPosDsoReverseFormula_PosInputMapEntry {
      const message = createBasePlanItemPosDsoReverseFormula_PosInputMapEntry();
      message.key = object.key ?? "";
      message.value = (object.value !== undefined && object.value !== null)
        ? InputManualMap.fromPartial(object.value)
        : undefined;
      return message;
    },
  };

function createBaseInputManualMap(): InputManualMap {
  return { manual_number_input: 0 };
}

export const InputManualMap: MessageFns<InputManualMap> = {
  encode(message: InputManualMap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.manual_number_input !== 0) {
      writer.uint32(9).double(message.manual_number_input);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputManualMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputManualMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.manual_number_input = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputManualMap {
    return {
      manual_number_input: isSet(object.manual_number_input) ? globalThis.Number(object.manual_number_input) : 0,
    };
  },

  toJSON(message: InputManualMap): unknown {
    const obj: any = {};
    if (message.manual_number_input !== 0) {
      obj.manual_number_input = message.manual_number_input;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InputManualMap>, I>>(base?: I): InputManualMap {
    return InputManualMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputManualMap>, I>>(object: I): InputManualMap {
    const message = createBaseInputManualMap();
    message.manual_number_input = object.manual_number_input ?? 0;
    return message;
  },
};

function createBasePlanItemPosFormulaBased(): PlanItemPosFormulaBased {
  return {
    pos_input_base_amount: 0,
    formula_based_input_list: [],
    pos_res_plan_map: {},
    sub_pos_map: {},
    status: undefined,
  };
}

export const PlanItemPosFormulaBased: MessageFns<PlanItemPosFormulaBased> = {
  encode(message: PlanItemPosFormulaBased, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pos_input_base_amount !== 0) {
      writer.uint32(17).double(message.pos_input_base_amount);
    }
    for (const v of message.formula_based_input_list) {
      FormulaBasedInput.encode(v!, writer.uint32(26).fork()).join();
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosFormulaBased_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    Object.entries(message.sub_pos_map).forEach(([key, value]) => {
      PlanItemPosFormulaBased_SubPosMapEntry.encode({ key: key as any, value }, writer.uint32(58).fork()).join();
    });
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosFormulaBased {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosFormulaBased();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.pos_input_base_amount = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.formula_based_input_list.push(FormulaBasedInput.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosFormulaBased_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = PlanItemPosFormulaBased_SubPosMapEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.sub_pos_map[entry7.key] = entry7.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosFormulaBased {
    return {
      pos_input_base_amount: isSet(object.pos_input_base_amount) ? globalThis.Number(object.pos_input_base_amount) : 0,
      formula_based_input_list: globalThis.Array.isArray(object?.formula_based_input_list)
        ? object.formula_based_input_list.map((e: any) => FormulaBasedInput.fromJSON(e))
        : [],
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      sub_pos_map: isObject(object.sub_pos_map)
        ? Object.entries(object.sub_pos_map).reduce<{ [key: string]: PlanSubPosItem }>((acc, [key, value]) => {
          acc[key] = PlanSubPosItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
    };
  },

  toJSON(message: PlanItemPosFormulaBased): unknown {
    const obj: any = {};
    if (message.pos_input_base_amount !== 0) {
      obj.pos_input_base_amount = message.pos_input_base_amount;
    }
    if (message.formula_based_input_list?.length) {
      obj.formula_based_input_list = message.formula_based_input_list.map((e) => FormulaBasedInput.toJSON(e));
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.sub_pos_map) {
      const entries = Object.entries(message.sub_pos_map);
      if (entries.length > 0) {
        obj.sub_pos_map = {};
        entries.forEach(([k, v]) => {
          obj.sub_pos_map[k] = PlanSubPosItem.toJSON(v);
        });
      }
    }
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosFormulaBased>, I>>(base?: I): PlanItemPosFormulaBased {
    return PlanItemPosFormulaBased.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosFormulaBased>, I>>(object: I): PlanItemPosFormulaBased {
    const message = createBasePlanItemPosFormulaBased();
    message.pos_input_base_amount = object.pos_input_base_amount ?? 0;
    message.formula_based_input_list = object.formula_based_input_list?.map((e) => FormulaBasedInput.fromPartial(e)) ||
      [];
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.sub_pos_map = Object.entries(object.sub_pos_map ?? {}).reduce<{ [key: string]: PlanSubPosItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = PlanSubPosItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosFormulaBased_PosResPlanMapEntry(): PlanItemPosFormulaBased_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosFormulaBased_PosResPlanMapEntry: MessageFns<PlanItemPosFormulaBased_PosResPlanMapEntry> = {
  encode(message: PlanItemPosFormulaBased_PosResPlanMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosFormulaBased_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosFormulaBased_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosFormulaBased_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosFormulaBased_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosFormulaBased_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosFormulaBased_PosResPlanMapEntry {
    return PlanItemPosFormulaBased_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosFormulaBased_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosFormulaBased_PosResPlanMapEntry {
    const message = createBasePlanItemPosFormulaBased_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosFormulaBased_SubPosMapEntry(): PlanItemPosFormulaBased_SubPosMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosFormulaBased_SubPosMapEntry: MessageFns<PlanItemPosFormulaBased_SubPosMapEntry> = {
  encode(message: PlanItemPosFormulaBased_SubPosMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      PlanSubPosItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosFormulaBased_SubPosMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosFormulaBased_SubPosMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = PlanSubPosItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosFormulaBased_SubPosMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? PlanSubPosItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosFormulaBased_SubPosMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = PlanSubPosItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosFormulaBased_SubPosMapEntry>, I>>(
    base?: I,
  ): PlanItemPosFormulaBased_SubPosMapEntry {
    return PlanItemPosFormulaBased_SubPosMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosFormulaBased_SubPosMapEntry>, I>>(
    object: I,
  ): PlanItemPosFormulaBased_SubPosMapEntry {
    const message = createBasePlanItemPosFormulaBased_SubPosMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? PlanSubPosItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosCapexRes(): PlanItemPosCapexRes {
  return { is_struct_pos: false, pos_res_plan_map: {}, pos_res_capex_pos_map: {} };
}

export const PlanItemPosCapexRes: MessageFns<PlanItemPosCapexRes> = {
  encode(message: PlanItemPosCapexRes, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosCapexRes_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    Object.entries(message.pos_res_capex_pos_map).forEach(([key, value]) => {
      PlanItemPosCapexRes_PosResCapexPosMapEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosCapexRes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosCapexRes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosCapexRes_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = PlanItemPosCapexRes_PosResCapexPosMapEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.pos_res_capex_pos_map[entry6.key] = entry6.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosCapexRes {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_res_capex_pos_map: isObject(object.pos_res_capex_pos_map)
        ? Object.entries(object.pos_res_capex_pos_map).reduce<
          { [key: string]: PlanItemPosCapexRes_StringToFloatMapValue }
        >((acc, [key, value]) => {
          acc[key] = PlanItemPosCapexRes_StringToFloatMapValue.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosCapexRes): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_res_capex_pos_map) {
      const entries = Object.entries(message.pos_res_capex_pos_map);
      if (entries.length > 0) {
        obj.pos_res_capex_pos_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_capex_pos_map[k] = PlanItemPosCapexRes_StringToFloatMapValue.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosCapexRes>, I>>(base?: I): PlanItemPosCapexRes {
    return PlanItemPosCapexRes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosCapexRes>, I>>(object: I): PlanItemPosCapexRes {
    const message = createBasePlanItemPosCapexRes();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_res_capex_pos_map = Object.entries(object.pos_res_capex_pos_map ?? {}).reduce<
      { [key: string]: PlanItemPosCapexRes_StringToFloatMapValue }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = PlanItemPosCapexRes_StringToFloatMapValue.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBasePlanItemPosCapexRes_PosResPlanMapEntry(): PlanItemPosCapexRes_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosCapexRes_PosResPlanMapEntry: MessageFns<PlanItemPosCapexRes_PosResPlanMapEntry> = {
  encode(message: PlanItemPosCapexRes_PosResPlanMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosCapexRes_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosCapexRes_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosCapexRes_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosCapexRes_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosCapexRes_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosCapexRes_PosResPlanMapEntry {
    return PlanItemPosCapexRes_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosCapexRes_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosCapexRes_PosResPlanMapEntry {
    const message = createBasePlanItemPosCapexRes_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosCapexRes_PosResCapexPosMapEntry(): PlanItemPosCapexRes_PosResCapexPosMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosCapexRes_PosResCapexPosMapEntry: MessageFns<PlanItemPosCapexRes_PosResCapexPosMapEntry> = {
  encode(message: PlanItemPosCapexRes_PosResCapexPosMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      PlanItemPosCapexRes_StringToFloatMapValue.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosCapexRes_PosResCapexPosMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosCapexRes_PosResCapexPosMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = PlanItemPosCapexRes_StringToFloatMapValue.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosCapexRes_PosResCapexPosMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? PlanItemPosCapexRes_StringToFloatMapValue.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosCapexRes_PosResCapexPosMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = PlanItemPosCapexRes_StringToFloatMapValue.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosCapexRes_PosResCapexPosMapEntry>, I>>(
    base?: I,
  ): PlanItemPosCapexRes_PosResCapexPosMapEntry {
    return PlanItemPosCapexRes_PosResCapexPosMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosCapexRes_PosResCapexPosMapEntry>, I>>(
    object: I,
  ): PlanItemPosCapexRes_PosResCapexPosMapEntry {
    const message = createBasePlanItemPosCapexRes_PosResCapexPosMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? PlanItemPosCapexRes_StringToFloatMapValue.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosCapexRes_StringToFloatMapValue(): PlanItemPosCapexRes_StringToFloatMapValue {
  return { value: {} };
}

export const PlanItemPosCapexRes_StringToFloatMapValue: MessageFns<PlanItemPosCapexRes_StringToFloatMapValue> = {
  encode(message: PlanItemPosCapexRes_StringToFloatMapValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.value).forEach(([key, value]) => {
      PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry.encode({ key: key as any, value }, writer.uint32(10).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosCapexRes_StringToFloatMapValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosCapexRes_StringToFloatMapValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.value[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosCapexRes_StringToFloatMapValue {
    return {
      value: isObject(object.value)
        ? Object.entries(object.value).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosCapexRes_StringToFloatMapValue): unknown {
    const obj: any = {};
    if (message.value) {
      const entries = Object.entries(message.value);
      if (entries.length > 0) {
        obj.value = {};
        entries.forEach(([k, v]) => {
          obj.value[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosCapexRes_StringToFloatMapValue>, I>>(
    base?: I,
  ): PlanItemPosCapexRes_StringToFloatMapValue {
    return PlanItemPosCapexRes_StringToFloatMapValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosCapexRes_StringToFloatMapValue>, I>>(
    object: I,
  ): PlanItemPosCapexRes_StringToFloatMapValue {
    const message = createBasePlanItemPosCapexRes_StringToFloatMapValue();
    message.value = Object.entries(object.value ?? {}).reduce<{ [key: string]: number }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBasePlanItemPosCapexRes_StringToFloatMapValue_ValueEntry(): PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry: MessageFns<
  PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry
> = {
  encode(
    message: PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosCapexRes_StringToFloatMapValue_ValueEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry>, I>>(
    base?: I,
  ): PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry {
    return PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry>, I>>(
    object: I,
  ): PlanItemPosCapexRes_StringToFloatMapValue_ValueEntry {
    const message = createBasePlanItemPosCapexRes_StringToFloatMapValue_ValueEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg(): PlanItemPosLogicInterestBaringLiabilityLoanCfg {
  return {
    is_struct_pos: false,
    pos_res_plan_map: {},
    pos_input_res_target_plan_item_pos_id: "",
    pos_input_loan_period_type: "",
    pos_input_loan_period_begin_month: 0,
    pos_input_loan_base: undefined,
    pos_input_loan_change_map: {},
    pos_input_loan_interest_rate_map: {},
    pos_input_loan_interest_expense_map: {},
    pos_res_loan_interest_expense_monthly: {},
    pos_res_loan_interest_expense: {},
  };
}

export const PlanItemPosLogicInterestBaringLiabilityLoanCfg: MessageFns<
  PlanItemPosLogicInterestBaringLiabilityLoanCfg
> = {
  encode(
    message: PlanItemPosLogicInterestBaringLiabilityLoanCfg,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry.encode(
        { key: key as any, value },
        writer.uint32(34).fork(),
      ).join();
    });
    if (message.pos_input_res_target_plan_item_pos_id !== "") {
      writer.uint32(50).string(message.pos_input_res_target_plan_item_pos_id);
    }
    if (message.pos_input_loan_period_type !== "") {
      writer.uint32(58).string(message.pos_input_loan_period_type);
    }
    if (message.pos_input_loan_period_begin_month !== 0) {
      writer.uint32(64).int32(message.pos_input_loan_period_begin_month);
    }
    if (message.pos_input_loan_base !== undefined) {
      InputManualMap.encode(message.pos_input_loan_base, writer.uint32(74).fork()).join();
    }
    Object.entries(message.pos_input_loan_change_map).forEach(([key, value]) => {
      PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry.encode(
        { key: key as any, value },
        writer.uint32(82).fork(),
      ).join();
    });
    Object.entries(message.pos_input_loan_interest_rate_map).forEach(([key, value]) => {
      PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry.encode(
        { key: key as any, value },
        writer.uint32(90).fork(),
      ).join();
    });
    Object.entries(message.pos_input_loan_interest_expense_map).forEach(([key, value]) => {
      PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry.encode({
        key: key as any,
        value,
      }, writer.uint32(98).fork()).join();
    });
    Object.entries(message.pos_res_loan_interest_expense_monthly).forEach(([key, value]) => {
      PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry.encode({
        key: key as any,
        value,
      }, writer.uint32(106).fork()).join();
    });
    Object.entries(message.pos_res_loan_interest_expense).forEach(([key, value]) => {
      PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry.encode(
        { key: key as any, value },
        writer.uint32(114).fork(),
      ).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicInterestBaringLiabilityLoanCfg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry.decode(
            reader,
            reader.uint32(),
          );
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.pos_input_res_target_plan_item_pos_id = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.pos_input_loan_period_type = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.pos_input_loan_period_begin_month = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.pos_input_loan_base = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          const entry10 = PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry.decode(
            reader,
            reader.uint32(),
          );
          if (entry10.value !== undefined) {
            message.pos_input_loan_change_map[entry10.key] = entry10.value;
          }
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          const entry11 = PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry.decode(
            reader,
            reader.uint32(),
          );
          if (entry11.value !== undefined) {
            message.pos_input_loan_interest_rate_map[entry11.key] = entry11.value;
          }
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          const entry12 = PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry.decode(
            reader,
            reader.uint32(),
          );
          if (entry12.value !== undefined) {
            message.pos_input_loan_interest_expense_map[entry12.key] = entry12.value;
          }
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          const entry13 = PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry.decode(
            reader,
            reader.uint32(),
          );
          if (entry13.value !== undefined) {
            message.pos_res_loan_interest_expense_monthly[entry13.key] = entry13.value;
          }
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          const entry14 = PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry.decode(
            reader,
            reader.uint32(),
          );
          if (entry14.value !== undefined) {
            message.pos_res_loan_interest_expense[entry14.key] = entry14.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestBaringLiabilityLoanCfg {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_input_res_target_plan_item_pos_id: isSet(object.pos_input_res_target_plan_item_pos_id)
        ? globalThis.String(object.pos_input_res_target_plan_item_pos_id)
        : "",
      pos_input_loan_period_type: isSet(object.pos_input_loan_period_type)
        ? globalThis.String(object.pos_input_loan_period_type)
        : "",
      pos_input_loan_period_begin_month: isSet(object.pos_input_loan_period_begin_month)
        ? globalThis.Number(object.pos_input_loan_period_begin_month)
        : 0,
      pos_input_loan_base: isSet(object.pos_input_loan_base)
        ? InputManualMap.fromJSON(object.pos_input_loan_base)
        : undefined,
      pos_input_loan_change_map: isObject(object.pos_input_loan_change_map)
        ? Object.entries(object.pos_input_loan_change_map).reduce<{ [key: string]: InputManualMap }>(
          (acc, [key, value]) => {
            acc[key] = InputManualMap.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      pos_input_loan_interest_rate_map: isObject(object.pos_input_loan_interest_rate_map)
        ? Object.entries(object.pos_input_loan_interest_rate_map).reduce<{ [key: string]: InputManualMap }>(
          (acc, [key, value]) => {
            acc[key] = InputManualMap.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      pos_input_loan_interest_expense_map: isObject(object.pos_input_loan_interest_expense_map)
        ? Object.entries(object.pos_input_loan_interest_expense_map).reduce<{ [key: string]: InputManualMap }>(
          (acc, [key, value]) => {
            acc[key] = InputManualMap.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      pos_res_loan_interest_expense_monthly: isObject(object.pos_res_loan_interest_expense_monthly)
        ? Object.entries(object.pos_res_loan_interest_expense_monthly).reduce<{ [key: string]: number }>(
          (acc, [key, value]) => {
            acc[key] = Number(value);
            return acc;
          },
          {},
        )
        : {},
      pos_res_loan_interest_expense: isObject(object.pos_res_loan_interest_expense)
        ? Object.entries(object.pos_res_loan_interest_expense).reduce<{ [key: string]: number }>(
          (acc, [key, value]) => {
            acc[key] = Number(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: PlanItemPosLogicInterestBaringLiabilityLoanCfg): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_input_res_target_plan_item_pos_id !== "") {
      obj.pos_input_res_target_plan_item_pos_id = message.pos_input_res_target_plan_item_pos_id;
    }
    if (message.pos_input_loan_period_type !== "") {
      obj.pos_input_loan_period_type = message.pos_input_loan_period_type;
    }
    if (message.pos_input_loan_period_begin_month !== 0) {
      obj.pos_input_loan_period_begin_month = Math.round(message.pos_input_loan_period_begin_month);
    }
    if (message.pos_input_loan_base !== undefined) {
      obj.pos_input_loan_base = InputManualMap.toJSON(message.pos_input_loan_base);
    }
    if (message.pos_input_loan_change_map) {
      const entries = Object.entries(message.pos_input_loan_change_map);
      if (entries.length > 0) {
        obj.pos_input_loan_change_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_loan_change_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_input_loan_interest_rate_map) {
      const entries = Object.entries(message.pos_input_loan_interest_rate_map);
      if (entries.length > 0) {
        obj.pos_input_loan_interest_rate_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_loan_interest_rate_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_input_loan_interest_expense_map) {
      const entries = Object.entries(message.pos_input_loan_interest_expense_map);
      if (entries.length > 0) {
        obj.pos_input_loan_interest_expense_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_loan_interest_expense_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_res_loan_interest_expense_monthly) {
      const entries = Object.entries(message.pos_res_loan_interest_expense_monthly);
      if (entries.length > 0) {
        obj.pos_res_loan_interest_expense_monthly = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_loan_interest_expense_monthly[k] = v;
        });
      }
    }
    if (message.pos_res_loan_interest_expense) {
      const entries = Object.entries(message.pos_res_loan_interest_expense);
      if (entries.length > 0) {
        obj.pos_res_loan_interest_expense = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_loan_interest_expense[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg>, I>>(
    base?: I,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg {
    return PlanItemPosLogicInterestBaringLiabilityLoanCfg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg>, I>>(
    object: I,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg {
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_input_res_target_plan_item_pos_id = object.pos_input_res_target_plan_item_pos_id ?? "";
    message.pos_input_loan_period_type = object.pos_input_loan_period_type ?? "";
    message.pos_input_loan_period_begin_month = object.pos_input_loan_period_begin_month ?? 0;
    message.pos_input_loan_base = (object.pos_input_loan_base !== undefined && object.pos_input_loan_base !== null)
      ? InputManualMap.fromPartial(object.pos_input_loan_base)
      : undefined;
    message.pos_input_loan_change_map = Object.entries(object.pos_input_loan_change_map ?? {}).reduce<
      { [key: string]: InputManualMap }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = InputManualMap.fromPartial(value);
      }
      return acc;
    }, {});
    message.pos_input_loan_interest_rate_map = Object.entries(object.pos_input_loan_interest_rate_map ?? {}).reduce<
      { [key: string]: InputManualMap }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = InputManualMap.fromPartial(value);
      }
      return acc;
    }, {});
    message.pos_input_loan_interest_expense_map = Object.entries(object.pos_input_loan_interest_expense_map ?? {})
      .reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      }, {});
    message.pos_res_loan_interest_expense_monthly = Object.entries(object.pos_res_loan_interest_expense_monthly ?? {})
      .reduce<{ [key: string]: number }>((acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      }, {});
    message.pos_res_loan_interest_expense = Object.entries(object.pos_res_loan_interest_expense ?? {}).reduce<
      { [key: string]: number }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry(): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry: MessageFns<
  PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry {
    return PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry {
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry(): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry: MessageFns<
  PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry
> = {
  encode(
    message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry {
    return PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<
    I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry>, I>,
  >(object: I): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry {
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanChangeMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry(): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry: MessageFns<
  PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry
> = {
  encode(
    message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<
    I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry>, I>,
  >(base?: I): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry {
    return PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry.fromPartial(
      base ?? ({} as any),
    );
  },
  fromPartial<
    I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry>, I>,
  >(object: I): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry {
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestRateMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry(): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry: MessageFns<
  PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry
> = {
  encode(
    message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<
    I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry>, I>,
  >(base?: I): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry {
    return PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry.fromPartial(
      base ?? ({} as any),
    );
  },
  fromPartial<
    I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry>, I>,
  >(object: I): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry {
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosInputLoanInterestExpenseMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry(): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry: MessageFns<
  PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry
> = {
  encode(
    message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<
    I extends Exact<
      DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry>,
      I
    >,
  >(base?: I): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry {
    return PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry.fromPartial(
      base ?? ({} as any),
    );
  },
  fromPartial<
    I extends Exact<
      DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry>,
      I
    >,
  >(object: I): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry {
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseMonthlyEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry(): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry: MessageFns<
  PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry
> = {
  encode(
    message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<
    I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry>, I>,
  >(base?: I): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry {
    return PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry.fromPartial(
      base ?? ({} as any),
    );
  },
  fromPartial<
    I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry>, I>,
  >(object: I): PlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry {
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanCfg_PosResLoanInterestExpenseEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicInterestBaringLiabilityLoanRes(): PlanItemPosLogicInterestBaringLiabilityLoanRes {
  return { is_struct_pos: false, pos_res_plan_map: {} };
}

export const PlanItemPosLogicInterestBaringLiabilityLoanRes: MessageFns<
  PlanItemPosLogicInterestBaringLiabilityLoanRes
> = {
  encode(
    message: PlanItemPosLogicInterestBaringLiabilityLoanRes,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry.encode(
        { key: key as any, value },
        writer.uint32(34).fork(),
      ).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicInterestBaringLiabilityLoanRes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanRes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry.decode(
            reader,
            reader.uint32(),
          );
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestBaringLiabilityLoanRes {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosLogicInterestBaringLiabilityLoanRes): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanRes>, I>>(
    base?: I,
  ): PlanItemPosLogicInterestBaringLiabilityLoanRes {
    return PlanItemPosLogicInterestBaringLiabilityLoanRes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanRes>, I>>(
    object: I,
  ): PlanItemPosLogicInterestBaringLiabilityLoanRes {
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanRes();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry(): PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry: MessageFns<
  PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry {
    return PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry {
    const message = createBasePlanItemPosLogicInterestBaringLiabilityLoanRes_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicInterestOnCash(): PlanItemPosLogicInterestOnCash {
  return { is_struct_pos: false, pos_res_plan_map: {}, pos_input_map: {}, pos_input_bs_cce_fstmt_id: "" };
}

export const PlanItemPosLogicInterestOnCash: MessageFns<PlanItemPosLogicInterestOnCash> = {
  encode(message: PlanItemPosLogicInterestOnCash, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosLogicInterestOnCash_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    Object.entries(message.pos_input_map).forEach(([key, value]) => {
      PlanItemPosLogicInterestOnCash_PosInputMapEntry.encode({ key: key as any, value }, writer.uint32(50).fork())
        .join();
    });
    if (message.pos_input_bs_cce_fstmt_id !== "") {
      writer.uint32(58).string(message.pos_input_bs_cce_fstmt_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicInterestOnCash {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestOnCash();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosLogicInterestOnCash_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = PlanItemPosLogicInterestOnCash_PosInputMapEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.pos_input_map[entry6.key] = entry6.value;
          }
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.pos_input_bs_cce_fstmt_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestOnCash {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_input_map: isObject(object.pos_input_map)
        ? Object.entries(object.pos_input_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      pos_input_bs_cce_fstmt_id: isSet(object.pos_input_bs_cce_fstmt_id)
        ? globalThis.String(object.pos_input_bs_cce_fstmt_id)
        : "",
    };
  },

  toJSON(message: PlanItemPosLogicInterestOnCash): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_input_map) {
      const entries = Object.entries(message.pos_input_map);
      if (entries.length > 0) {
        obj.pos_input_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_input_bs_cce_fstmt_id !== "") {
      obj.pos_input_bs_cce_fstmt_id = message.pos_input_bs_cce_fstmt_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInterestOnCash>, I>>(base?: I): PlanItemPosLogicInterestOnCash {
    return PlanItemPosLogicInterestOnCash.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicInterestOnCash>, I>>(
    object: I,
  ): PlanItemPosLogicInterestOnCash {
    const message = createBasePlanItemPosLogicInterestOnCash();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_input_map = Object.entries(object.pos_input_map ?? {}).reduce<{ [key: string]: InputManualMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.pos_input_bs_cce_fstmt_id = object.pos_input_bs_cce_fstmt_id ?? "";
    return message;
  },
};

function createBasePlanItemPosLogicInterestOnCash_PosResPlanMapEntry(): PlanItemPosLogicInterestOnCash_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicInterestOnCash_PosResPlanMapEntry: MessageFns<
  PlanItemPosLogicInterestOnCash_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosLogicInterestOnCash_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicInterestOnCash_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestOnCash_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestOnCash_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicInterestOnCash_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInterestOnCash_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicInterestOnCash_PosResPlanMapEntry {
    return PlanItemPosLogicInterestOnCash_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicInterestOnCash_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicInterestOnCash_PosResPlanMapEntry {
    const message = createBasePlanItemPosLogicInterestOnCash_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicInterestOnCash_PosInputMapEntry(): PlanItemPosLogicInterestOnCash_PosInputMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicInterestOnCash_PosInputMapEntry: MessageFns<
  PlanItemPosLogicInterestOnCash_PosInputMapEntry
> = {
  encode(
    message: PlanItemPosLogicInterestOnCash_PosInputMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicInterestOnCash_PosInputMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInterestOnCash_PosInputMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInterestOnCash_PosInputMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicInterestOnCash_PosInputMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInterestOnCash_PosInputMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicInterestOnCash_PosInputMapEntry {
    return PlanItemPosLogicInterestOnCash_PosInputMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicInterestOnCash_PosInputMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicInterestOnCash_PosInputMapEntry {
    const message = createBasePlanItemPosLogicInterestOnCash_PosInputMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicTaxRateOnFstmt(): PlanItemPosLogicTaxRateOnFstmt {
  return {
    is_struct_pos: false,
    pos_res_plan_map: {},
    pos_formula_based: undefined,
    pos_input_base: undefined,
    pos_input_period_begin_month: 0,
    pos_input_period_type: "",
    pos_input_tax_base_adj_map: {},
    pos_input_tax_rate_map: {},
    pos_res_tax_base: {},
    pos_res_tax_res_monthly: {},
  };
}

export const PlanItemPosLogicTaxRateOnFstmt: MessageFns<PlanItemPosLogicTaxRateOnFstmt> = {
  encode(message: PlanItemPosLogicTaxRateOnFstmt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    if (message.pos_formula_based !== undefined) {
      PlanItemPosFormulaBased.encode(message.pos_formula_based, writer.uint32(866).fork()).join();
    }
    if (message.pos_input_base !== undefined) {
      InputManualMap.encode(message.pos_input_base, writer.uint32(50).fork()).join();
    }
    if (message.pos_input_period_begin_month !== 0) {
      writer.uint32(56).int32(message.pos_input_period_begin_month);
    }
    if (message.pos_input_period_type !== "") {
      writer.uint32(66).string(message.pos_input_period_type);
    }
    Object.entries(message.pos_input_tax_base_adj_map).forEach(([key, value]) => {
      PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry.encode(
        { key: key as any, value },
        writer.uint32(74).fork(),
      ).join();
    });
    Object.entries(message.pos_input_tax_rate_map).forEach(([key, value]) => {
      PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry.encode(
        { key: key as any, value },
        writer.uint32(82).fork(),
      ).join();
    });
    Object.entries(message.pos_res_tax_base).forEach(([key, value]) => {
      PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry.encode({ key: key as any, value }, writer.uint32(90).fork())
        .join();
    });
    Object.entries(message.pos_res_tax_res_monthly).forEach(([key, value]) => {
      PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry.encode(
        { key: key as any, value },
        writer.uint32(98).fork(),
      ).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicTaxRateOnFstmt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicTaxRateOnFstmt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.pos_formula_based = PlanItemPosFormulaBased.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.pos_input_base = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.pos_input_period_begin_month = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.pos_input_period_type = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          const entry9 = PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry.decode(reader, reader.uint32());
          if (entry9.value !== undefined) {
            message.pos_input_tax_base_adj_map[entry9.key] = entry9.value;
          }
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          const entry10 = PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry.decode(reader, reader.uint32());
          if (entry10.value !== undefined) {
            message.pos_input_tax_rate_map[entry10.key] = entry10.value;
          }
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          const entry11 = PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry.decode(reader, reader.uint32());
          if (entry11.value !== undefined) {
            message.pos_res_tax_base[entry11.key] = entry11.value;
          }
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          const entry12 = PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry.decode(reader, reader.uint32());
          if (entry12.value !== undefined) {
            message.pos_res_tax_res_monthly[entry12.key] = entry12.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicTaxRateOnFstmt {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_formula_based: isSet(object.pos_formula_based)
        ? PlanItemPosFormulaBased.fromJSON(object.pos_formula_based)
        : undefined,
      pos_input_base: isSet(object.pos_input_base) ? InputManualMap.fromJSON(object.pos_input_base) : undefined,
      pos_input_period_begin_month: isSet(object.pos_input_period_begin_month)
        ? globalThis.Number(object.pos_input_period_begin_month)
        : 0,
      pos_input_period_type: isSet(object.pos_input_period_type) ? globalThis.String(object.pos_input_period_type) : "",
      pos_input_tax_base_adj_map: isObject(object.pos_input_tax_base_adj_map)
        ? Object.entries(object.pos_input_tax_base_adj_map).reduce<{ [key: string]: InputManualMap }>(
          (acc, [key, value]) => {
            acc[key] = InputManualMap.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      pos_input_tax_rate_map: isObject(object.pos_input_tax_rate_map)
        ? Object.entries(object.pos_input_tax_rate_map).reduce<{ [key: string]: InputManualMap }>(
          (acc, [key, value]) => {
            acc[key] = InputManualMap.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      pos_res_tax_base: isObject(object.pos_res_tax_base)
        ? Object.entries(object.pos_res_tax_base).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_res_tax_res_monthly: isObject(object.pos_res_tax_res_monthly)
        ? Object.entries(object.pos_res_tax_res_monthly).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosLogicTaxRateOnFstmt): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_formula_based !== undefined) {
      obj.pos_formula_based = PlanItemPosFormulaBased.toJSON(message.pos_formula_based);
    }
    if (message.pos_input_base !== undefined) {
      obj.pos_input_base = InputManualMap.toJSON(message.pos_input_base);
    }
    if (message.pos_input_period_begin_month !== 0) {
      obj.pos_input_period_begin_month = Math.round(message.pos_input_period_begin_month);
    }
    if (message.pos_input_period_type !== "") {
      obj.pos_input_period_type = message.pos_input_period_type;
    }
    if (message.pos_input_tax_base_adj_map) {
      const entries = Object.entries(message.pos_input_tax_base_adj_map);
      if (entries.length > 0) {
        obj.pos_input_tax_base_adj_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_tax_base_adj_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_input_tax_rate_map) {
      const entries = Object.entries(message.pos_input_tax_rate_map);
      if (entries.length > 0) {
        obj.pos_input_tax_rate_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_tax_rate_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_res_tax_base) {
      const entries = Object.entries(message.pos_res_tax_base);
      if (entries.length > 0) {
        obj.pos_res_tax_base = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_tax_base[k] = v;
        });
      }
    }
    if (message.pos_res_tax_res_monthly) {
      const entries = Object.entries(message.pos_res_tax_res_monthly);
      if (entries.length > 0) {
        obj.pos_res_tax_res_monthly = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_tax_res_monthly[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt>, I>>(base?: I): PlanItemPosLogicTaxRateOnFstmt {
    return PlanItemPosLogicTaxRateOnFstmt.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt>, I>>(
    object: I,
  ): PlanItemPosLogicTaxRateOnFstmt {
    const message = createBasePlanItemPosLogicTaxRateOnFstmt();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_formula_based = (object.pos_formula_based !== undefined && object.pos_formula_based !== null)
      ? PlanItemPosFormulaBased.fromPartial(object.pos_formula_based)
      : undefined;
    message.pos_input_base = (object.pos_input_base !== undefined && object.pos_input_base !== null)
      ? InputManualMap.fromPartial(object.pos_input_base)
      : undefined;
    message.pos_input_period_begin_month = object.pos_input_period_begin_month ?? 0;
    message.pos_input_period_type = object.pos_input_period_type ?? "";
    message.pos_input_tax_base_adj_map = Object.entries(object.pos_input_tax_base_adj_map ?? {}).reduce<
      { [key: string]: InputManualMap }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = InputManualMap.fromPartial(value);
      }
      return acc;
    }, {});
    message.pos_input_tax_rate_map = Object.entries(object.pos_input_tax_rate_map ?? {}).reduce<
      { [key: string]: InputManualMap }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = InputManualMap.fromPartial(value);
      }
      return acc;
    }, {});
    message.pos_res_tax_base = Object.entries(object.pos_res_tax_base ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_res_tax_res_monthly = Object.entries(object.pos_res_tax_res_monthly ?? {}).reduce<
      { [key: string]: number }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBasePlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry(): PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry: MessageFns<
  PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry {
    return PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry {
    const message = createBasePlanItemPosLogicTaxRateOnFstmt_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry(): PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry: MessageFns<
  PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry
> = {
  encode(
    message: PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry {
    return PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry {
    const message = createBasePlanItemPosLogicTaxRateOnFstmt_PosInputTaxBaseAdjMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry(): PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry: MessageFns<
  PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry
> = {
  encode(
    message: PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry {
    return PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry {
    const message = createBasePlanItemPosLogicTaxRateOnFstmt_PosInputTaxRateMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry(): PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry: MessageFns<
  PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry
> = {
  encode(
    message: PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry {
    return PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry>, I>>(
    object: I,
  ): PlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry {
    const message = createBasePlanItemPosLogicTaxRateOnFstmt_PosResTaxBaseEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry(): PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry: MessageFns<
  PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry
> = {
  encode(
    message: PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry {
    return PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry>, I>>(
    object: I,
  ): PlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry {
    const message = createBasePlanItemPosLogicTaxRateOnFstmt_PosResTaxResMonthlyEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicInPercOfAcc(): PlanItemPosLogicInPercOfAcc {
  return { is_struct_pos: false, pos_res_plan_map: {}, pos_formula_based: undefined, pos_input_map: {} };
}

export const PlanItemPosLogicInPercOfAcc: MessageFns<PlanItemPosLogicInPercOfAcc> = {
  encode(message: PlanItemPosLogicInPercOfAcc, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    if (message.pos_formula_based !== undefined) {
      PlanItemPosFormulaBased.encode(message.pos_formula_based, writer.uint32(866).fork()).join();
    }
    Object.entries(message.pos_input_map).forEach(([key, value]) => {
      PlanItemPosLogicInPercOfAcc_PosInputMapEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicInPercOfAcc {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInPercOfAcc();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.pos_formula_based = PlanItemPosFormulaBased.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = PlanItemPosLogicInPercOfAcc_PosInputMapEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.pos_input_map[entry6.key] = entry6.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInPercOfAcc {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_formula_based: isSet(object.pos_formula_based)
        ? PlanItemPosFormulaBased.fromJSON(object.pos_formula_based)
        : undefined,
      pos_input_map: isObject(object.pos_input_map)
        ? Object.entries(object.pos_input_map).reduce<{ [key: string]: InputManualMap }>((acc, [key, value]) => {
          acc[key] = InputManualMap.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosLogicInPercOfAcc): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_formula_based !== undefined) {
      obj.pos_formula_based = PlanItemPosFormulaBased.toJSON(message.pos_formula_based);
    }
    if (message.pos_input_map) {
      const entries = Object.entries(message.pos_input_map);
      if (entries.length > 0) {
        obj.pos_input_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInPercOfAcc>, I>>(base?: I): PlanItemPosLogicInPercOfAcc {
    return PlanItemPosLogicInPercOfAcc.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicInPercOfAcc>, I>>(object: I): PlanItemPosLogicInPercOfAcc {
    const message = createBasePlanItemPosLogicInPercOfAcc();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_formula_based = (object.pos_formula_based !== undefined && object.pos_formula_based !== null)
      ? PlanItemPosFormulaBased.fromPartial(object.pos_formula_based)
      : undefined;
    message.pos_input_map = Object.entries(object.pos_input_map ?? {}).reduce<{ [key: string]: InputManualMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = InputManualMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePlanItemPosLogicInPercOfAcc_PosResPlanMapEntry(): PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry: MessageFns<
  PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInPercOfAcc_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry {
    return PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicInPercOfAcc_PosResPlanMapEntry {
    const message = createBasePlanItemPosLogicInPercOfAcc_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicInPercOfAcc_PosInputMapEntry(): PlanItemPosLogicInPercOfAcc_PosInputMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicInPercOfAcc_PosInputMapEntry: MessageFns<PlanItemPosLogicInPercOfAcc_PosInputMapEntry> = {
  encode(
    message: PlanItemPosLogicInPercOfAcc_PosInputMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicInPercOfAcc_PosInputMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicInPercOfAcc_PosInputMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicInPercOfAcc_PosInputMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicInPercOfAcc_PosInputMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicInPercOfAcc_PosInputMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicInPercOfAcc_PosInputMapEntry {
    return PlanItemPosLogicInPercOfAcc_PosInputMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicInPercOfAcc_PosInputMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicInPercOfAcc_PosInputMapEntry {
    const message = createBasePlanItemPosLogicInPercOfAcc_PosInputMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicFTExAVGaLLInCosts(): PlanItemPosLogicFTExAVGaLLInCosts {
  return {
    is_struct_pos: false,
    pos_res_plan_map: {},
    pos_input_fte_costs_base: undefined,
    pos_input_fte_count_base: undefined,
    pos_input_fte_avg_costs_pm_map: {},
    pos_input_fte_change_map: {},
    pos_res_fte_avg_costs_pm: 0,
    pos_res_fte_count_map: {},
    pos_res_fte_avg_costs_pm_map: {},
    pos_res_fte_change_map: {},
  };
}

export const PlanItemPosLogicFTExAVGaLLInCosts: MessageFns<PlanItemPosLogicFTExAVGaLLInCosts> = {
  encode(message: PlanItemPosLogicFTExAVGaLLInCosts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_struct_pos !== false) {
      writer.uint32(8).bool(message.is_struct_pos);
    }
    Object.entries(message.pos_res_plan_map).forEach(([key, value]) => {
      PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    if (message.pos_input_fte_costs_base !== undefined) {
      InputManualMap.encode(message.pos_input_fte_costs_base, writer.uint32(50).fork()).join();
    }
    if (message.pos_input_fte_count_base !== undefined) {
      InputManualMap.encode(message.pos_input_fte_count_base, writer.uint32(58).fork()).join();
    }
    Object.entries(message.pos_input_fte_avg_costs_pm_map).forEach(([key, value]) => {
      PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry.encode(
        { key: key as any, value },
        writer.uint32(66).fork(),
      ).join();
    });
    Object.entries(message.pos_input_fte_change_map).forEach(([key, value]) => {
      PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry.encode(
        { key: key as any, value },
        writer.uint32(74).fork(),
      ).join();
    });
    if (message.pos_res_fte_avg_costs_pm !== 0) {
      writer.uint32(81).double(message.pos_res_fte_avg_costs_pm);
    }
    Object.entries(message.pos_res_fte_count_map).forEach(([key, value]) => {
      PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry.encode(
        { key: key as any, value },
        writer.uint32(90).fork(),
      ).join();
    });
    Object.entries(message.pos_res_fte_avg_costs_pm_map).forEach(([key, value]) => {
      PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry.encode(
        { key: key as any, value },
        writer.uint32(98).fork(),
      ).join();
    });
    Object.entries(message.pos_res_fte_change_map).forEach(([key, value]) => {
      PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry.encode(
        { key: key as any, value },
        writer.uint32(106).fork(),
      ).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicFTExAVGaLLInCosts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.is_struct_pos = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pos_res_plan_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.pos_input_fte_costs_base = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.pos_input_fte_count_base = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry.decode(
            reader,
            reader.uint32(),
          );
          if (entry8.value !== undefined) {
            message.pos_input_fte_avg_costs_pm_map[entry8.key] = entry8.value;
          }
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          const entry9 = PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry.decode(reader, reader.uint32());
          if (entry9.value !== undefined) {
            message.pos_input_fte_change_map[entry9.key] = entry9.value;
          }
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.pos_res_fte_avg_costs_pm = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          const entry11 = PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry.decode(reader, reader.uint32());
          if (entry11.value !== undefined) {
            message.pos_res_fte_count_map[entry11.key] = entry11.value;
          }
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          const entry12 = PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry.decode(reader, reader.uint32());
          if (entry12.value !== undefined) {
            message.pos_res_fte_avg_costs_pm_map[entry12.key] = entry12.value;
          }
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          const entry13 = PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry.decode(reader, reader.uint32());
          if (entry13.value !== undefined) {
            message.pos_res_fte_change_map[entry13.key] = entry13.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicFTExAVGaLLInCosts {
    return {
      is_struct_pos: isSet(object.is_struct_pos) ? globalThis.Boolean(object.is_struct_pos) : false,
      pos_res_plan_map: isObject(object.pos_res_plan_map)
        ? Object.entries(object.pos_res_plan_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_input_fte_costs_base: isSet(object.pos_input_fte_costs_base)
        ? InputManualMap.fromJSON(object.pos_input_fte_costs_base)
        : undefined,
      pos_input_fte_count_base: isSet(object.pos_input_fte_count_base)
        ? InputManualMap.fromJSON(object.pos_input_fte_count_base)
        : undefined,
      pos_input_fte_avg_costs_pm_map: isObject(object.pos_input_fte_avg_costs_pm_map)
        ? Object.entries(object.pos_input_fte_avg_costs_pm_map).reduce<{ [key: string]: InputManualMap }>(
          (acc, [key, value]) => {
            acc[key] = InputManualMap.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      pos_input_fte_change_map: isObject(object.pos_input_fte_change_map)
        ? Object.entries(object.pos_input_fte_change_map).reduce<{ [key: string]: InputManualMap }>(
          (acc, [key, value]) => {
            acc[key] = InputManualMap.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      pos_res_fte_avg_costs_pm: isSet(object.pos_res_fte_avg_costs_pm)
        ? globalThis.Number(object.pos_res_fte_avg_costs_pm)
        : 0,
      pos_res_fte_count_map: isObject(object.pos_res_fte_count_map)
        ? Object.entries(object.pos_res_fte_count_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_res_fte_avg_costs_pm_map: isObject(object.pos_res_fte_avg_costs_pm_map)
        ? Object.entries(object.pos_res_fte_avg_costs_pm_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      pos_res_fte_change_map: isObject(object.pos_res_fte_change_map)
        ? Object.entries(object.pos_res_fte_change_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: PlanItemPosLogicFTExAVGaLLInCosts): unknown {
    const obj: any = {};
    if (message.is_struct_pos !== false) {
      obj.is_struct_pos = message.is_struct_pos;
    }
    if (message.pos_res_plan_map) {
      const entries = Object.entries(message.pos_res_plan_map);
      if (entries.length > 0) {
        obj.pos_res_plan_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_plan_map[k] = v;
        });
      }
    }
    if (message.pos_input_fte_costs_base !== undefined) {
      obj.pos_input_fte_costs_base = InputManualMap.toJSON(message.pos_input_fte_costs_base);
    }
    if (message.pos_input_fte_count_base !== undefined) {
      obj.pos_input_fte_count_base = InputManualMap.toJSON(message.pos_input_fte_count_base);
    }
    if (message.pos_input_fte_avg_costs_pm_map) {
      const entries = Object.entries(message.pos_input_fte_avg_costs_pm_map);
      if (entries.length > 0) {
        obj.pos_input_fte_avg_costs_pm_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_fte_avg_costs_pm_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_input_fte_change_map) {
      const entries = Object.entries(message.pos_input_fte_change_map);
      if (entries.length > 0) {
        obj.pos_input_fte_change_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_input_fte_change_map[k] = InputManualMap.toJSON(v);
        });
      }
    }
    if (message.pos_res_fte_avg_costs_pm !== 0) {
      obj.pos_res_fte_avg_costs_pm = message.pos_res_fte_avg_costs_pm;
    }
    if (message.pos_res_fte_count_map) {
      const entries = Object.entries(message.pos_res_fte_count_map);
      if (entries.length > 0) {
        obj.pos_res_fte_count_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_fte_count_map[k] = v;
        });
      }
    }
    if (message.pos_res_fte_avg_costs_pm_map) {
      const entries = Object.entries(message.pos_res_fte_avg_costs_pm_map);
      if (entries.length > 0) {
        obj.pos_res_fte_avg_costs_pm_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_fte_avg_costs_pm_map[k] = v;
        });
      }
    }
    if (message.pos_res_fte_change_map) {
      const entries = Object.entries(message.pos_res_fte_change_map);
      if (entries.length > 0) {
        obj.pos_res_fte_change_map = {};
        entries.forEach(([k, v]) => {
          obj.pos_res_fte_change_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts>, I>>(
    base?: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts {
    return PlanItemPosLogicFTExAVGaLLInCosts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts>, I>>(
    object: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts {
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts();
    message.is_struct_pos = object.is_struct_pos ?? false;
    message.pos_res_plan_map = Object.entries(object.pos_res_plan_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    message.pos_input_fte_costs_base =
      (object.pos_input_fte_costs_base !== undefined && object.pos_input_fte_costs_base !== null)
        ? InputManualMap.fromPartial(object.pos_input_fte_costs_base)
        : undefined;
    message.pos_input_fte_count_base =
      (object.pos_input_fte_count_base !== undefined && object.pos_input_fte_count_base !== null)
        ? InputManualMap.fromPartial(object.pos_input_fte_count_base)
        : undefined;
    message.pos_input_fte_avg_costs_pm_map = Object.entries(object.pos_input_fte_avg_costs_pm_map ?? {}).reduce<
      { [key: string]: InputManualMap }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = InputManualMap.fromPartial(value);
      }
      return acc;
    }, {});
    message.pos_input_fte_change_map = Object.entries(object.pos_input_fte_change_map ?? {}).reduce<
      { [key: string]: InputManualMap }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = InputManualMap.fromPartial(value);
      }
      return acc;
    }, {});
    message.pos_res_fte_avg_costs_pm = object.pos_res_fte_avg_costs_pm ?? 0;
    message.pos_res_fte_count_map = Object.entries(object.pos_res_fte_count_map ?? {}).reduce<
      { [key: string]: number }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value);
      }
      return acc;
    }, {});
    message.pos_res_fte_avg_costs_pm_map = Object.entries(object.pos_res_fte_avg_costs_pm_map ?? {}).reduce<
      { [key: string]: number }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value);
      }
      return acc;
    }, {});
    message.pos_res_fte_change_map = Object.entries(object.pos_res_fte_change_map ?? {}).reduce<
      { [key: string]: number }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry(): PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry: MessageFns<
  PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry
> = {
  encode(
    message: PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry {
    return PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry {
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResPlanMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry(): PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry: MessageFns<
  PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry
> = {
  encode(
    message: PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry {
    return PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry {
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosInputFteAvgCostsPmMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry(): PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry {
  return { key: "", value: undefined };
}

export const PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry: MessageFns<
  PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry
> = {
  encode(
    message: PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InputManualMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = InputManualMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? InputManualMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = InputManualMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry {
    return PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry {
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosInputFteChangeMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? InputManualMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry(): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry: MessageFns<
  PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry
> = {
  encode(
    message: PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry {
    return PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry {
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResFteCountMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry(): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry: MessageFns<
  PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry
> = {
  encode(
    message: PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry {
    return PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry {
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResFteAvgCostsPmMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry(): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry {
  return { key: "", value: 0 };
}

export const PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry: MessageFns<
  PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry
> = {
  encode(
    message: PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry>, I>>(
    base?: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry {
    return PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry>, I>>(
    object: I,
  ): PlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry {
    const message = createBasePlanItemPosLogicFTExAVGaLLInCosts_PosResFteChangeMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseFormulaBasedInput(): FormulaBasedInput {
  return {
    math_op: undefined,
    plan_ref_fstmt: undefined,
    plan_ref_level_2_position: undefined,
    plan_ref_self_position: undefined,
    plan_ref_position: undefined,
    plan_ref_sub_position: undefined,
  };
}

export const FormulaBasedInput: MessageFns<FormulaBasedInput> = {
  encode(message: FormulaBasedInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.math_op !== undefined) {
      writer.uint32(10).string(message.math_op);
    }
    if (message.plan_ref_fstmt !== undefined) {
      FstmtRef.encode(message.plan_ref_fstmt, writer.uint32(18).fork()).join();
    }
    if (message.plan_ref_level_2_position !== undefined) {
      FormulaBasedInput_PlanRefLevel2Position.encode(message.plan_ref_level_2_position, writer.uint32(26).fork())
        .join();
    }
    if (message.plan_ref_self_position !== undefined) {
      FormulaBasedInput_PlanRefSelfPosition.encode(message.plan_ref_self_position, writer.uint32(34).fork()).join();
    }
    if (message.plan_ref_position !== undefined) {
      FormulaBasedInput_PlanRefPosition.encode(message.plan_ref_position, writer.uint32(42).fork()).join();
    }
    if (message.plan_ref_sub_position !== undefined) {
      FormulaBasedInput_PlanRefSubPosition.encode(message.plan_ref_sub_position, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FormulaBasedInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFormulaBasedInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.math_op = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.plan_ref_fstmt = FstmtRef.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.plan_ref_level_2_position = FormulaBasedInput_PlanRefLevel2Position.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.plan_ref_self_position = FormulaBasedInput_PlanRefSelfPosition.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.plan_ref_position = FormulaBasedInput_PlanRefPosition.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.plan_ref_sub_position = FormulaBasedInput_PlanRefSubPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FormulaBasedInput {
    return {
      math_op: isSet(object.math_op) ? globalThis.String(object.math_op) : undefined,
      plan_ref_fstmt: isSet(object.plan_ref_fstmt) ? FstmtRef.fromJSON(object.plan_ref_fstmt) : undefined,
      plan_ref_level_2_position: isSet(object.plan_ref_level_2_position)
        ? FormulaBasedInput_PlanRefLevel2Position.fromJSON(object.plan_ref_level_2_position)
        : undefined,
      plan_ref_self_position: isSet(object.plan_ref_self_position)
        ? FormulaBasedInput_PlanRefSelfPosition.fromJSON(object.plan_ref_self_position)
        : undefined,
      plan_ref_position: isSet(object.plan_ref_position)
        ? FormulaBasedInput_PlanRefPosition.fromJSON(object.plan_ref_position)
        : undefined,
      plan_ref_sub_position: isSet(object.plan_ref_sub_position)
        ? FormulaBasedInput_PlanRefSubPosition.fromJSON(object.plan_ref_sub_position)
        : undefined,
    };
  },

  toJSON(message: FormulaBasedInput): unknown {
    const obj: any = {};
    if (message.math_op !== undefined) {
      obj.math_op = message.math_op;
    }
    if (message.plan_ref_fstmt !== undefined) {
      obj.plan_ref_fstmt = FstmtRef.toJSON(message.plan_ref_fstmt);
    }
    if (message.plan_ref_level_2_position !== undefined) {
      obj.plan_ref_level_2_position = FormulaBasedInput_PlanRefLevel2Position.toJSON(message.plan_ref_level_2_position);
    }
    if (message.plan_ref_self_position !== undefined) {
      obj.plan_ref_self_position = FormulaBasedInput_PlanRefSelfPosition.toJSON(message.plan_ref_self_position);
    }
    if (message.plan_ref_position !== undefined) {
      obj.plan_ref_position = FormulaBasedInput_PlanRefPosition.toJSON(message.plan_ref_position);
    }
    if (message.plan_ref_sub_position !== undefined) {
      obj.plan_ref_sub_position = FormulaBasedInput_PlanRefSubPosition.toJSON(message.plan_ref_sub_position);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FormulaBasedInput>, I>>(base?: I): FormulaBasedInput {
    return FormulaBasedInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FormulaBasedInput>, I>>(object: I): FormulaBasedInput {
    const message = createBaseFormulaBasedInput();
    message.math_op = object.math_op ?? undefined;
    message.plan_ref_fstmt = (object.plan_ref_fstmt !== undefined && object.plan_ref_fstmt !== null)
      ? FstmtRef.fromPartial(object.plan_ref_fstmt)
      : undefined;
    message.plan_ref_level_2_position =
      (object.plan_ref_level_2_position !== undefined && object.plan_ref_level_2_position !== null)
        ? FormulaBasedInput_PlanRefLevel2Position.fromPartial(object.plan_ref_level_2_position)
        : undefined;
    message.plan_ref_self_position =
      (object.plan_ref_self_position !== undefined && object.plan_ref_self_position !== null)
        ? FormulaBasedInput_PlanRefSelfPosition.fromPartial(object.plan_ref_self_position)
        : undefined;
    message.plan_ref_position = (object.plan_ref_position !== undefined && object.plan_ref_position !== null)
      ? FormulaBasedInput_PlanRefPosition.fromPartial(object.plan_ref_position)
      : undefined;
    message.plan_ref_sub_position =
      (object.plan_ref_sub_position !== undefined && object.plan_ref_sub_position !== null)
        ? FormulaBasedInput_PlanRefSubPosition.fromPartial(object.plan_ref_sub_position)
        : undefined;
    return message;
  },
};

function createBaseFormulaBasedInput_PlanRefLevel2Position(): FormulaBasedInput_PlanRefLevel2Position {
  return {
    fstmt_type: 0,
    ref_id_level: "",
    ref_id_plan_position: "",
    offset_in_months: 0,
    status: undefined,
    fpna_period: undefined,
  };
}

export const FormulaBasedInput_PlanRefLevel2Position: MessageFns<FormulaBasedInput_PlanRefLevel2Position> = {
  encode(message: FormulaBasedInput_PlanRefLevel2Position, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fstmt_type !== 0) {
      writer.uint32(8).int32(message.fstmt_type);
    }
    if (message.ref_id_level !== "") {
      writer.uint32(18).string(message.ref_id_level);
    }
    if (message.ref_id_plan_position !== "") {
      writer.uint32(26).string(message.ref_id_plan_position);
    }
    if (message.offset_in_months !== 0) {
      writer.uint32(32).int32(message.offset_in_months);
    }
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(42).fork()).join();
    }
    if (message.fpna_period !== undefined) {
      StcsFpnaPeriod.encode(message.fpna_period, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FormulaBasedInput_PlanRefLevel2Position {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFormulaBasedInput_PlanRefLevel2Position();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fstmt_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_level = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_plan_position = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.offset_in_months = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fpna_period = StcsFpnaPeriod.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FormulaBasedInput_PlanRefLevel2Position {
    return {
      fstmt_type: isSet(object.fstmt_type) ? stcsFstmtEnumFromJSON(object.fstmt_type) : 0,
      ref_id_level: isSet(object.ref_id_level) ? globalThis.String(object.ref_id_level) : "",
      ref_id_plan_position: isSet(object.ref_id_plan_position) ? globalThis.String(object.ref_id_plan_position) : "",
      offset_in_months: isSet(object.offset_in_months) ? globalThis.Number(object.offset_in_months) : 0,
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
      fpna_period: isSet(object.fpna_period) ? StcsFpnaPeriod.fromJSON(object.fpna_period) : undefined,
    };
  },

  toJSON(message: FormulaBasedInput_PlanRefLevel2Position): unknown {
    const obj: any = {};
    if (message.fstmt_type !== 0) {
      obj.fstmt_type = stcsFstmtEnumToJSON(message.fstmt_type);
    }
    if (message.ref_id_level !== "") {
      obj.ref_id_level = message.ref_id_level;
    }
    if (message.ref_id_plan_position !== "") {
      obj.ref_id_plan_position = message.ref_id_plan_position;
    }
    if (message.offset_in_months !== 0) {
      obj.offset_in_months = Math.round(message.offset_in_months);
    }
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    if (message.fpna_period !== undefined) {
      obj.fpna_period = StcsFpnaPeriod.toJSON(message.fpna_period);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FormulaBasedInput_PlanRefLevel2Position>, I>>(
    base?: I,
  ): FormulaBasedInput_PlanRefLevel2Position {
    return FormulaBasedInput_PlanRefLevel2Position.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FormulaBasedInput_PlanRefLevel2Position>, I>>(
    object: I,
  ): FormulaBasedInput_PlanRefLevel2Position {
    const message = createBaseFormulaBasedInput_PlanRefLevel2Position();
    message.fstmt_type = object.fstmt_type ?? 0;
    message.ref_id_level = object.ref_id_level ?? "";
    message.ref_id_plan_position = object.ref_id_plan_position ?? "";
    message.offset_in_months = object.offset_in_months ?? 0;
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    message.fpna_period = (object.fpna_period !== undefined && object.fpna_period !== null)
      ? StcsFpnaPeriod.fromPartial(object.fpna_period)
      : undefined;
    return message;
  },
};

function createBaseFormulaBasedInput_PlanRefPosition(): FormulaBasedInput_PlanRefPosition {
  return { fstmt_type: 0, ref_id_plan_position: "", offset_in_months: 0, status: undefined, fpna_period: undefined };
}

export const FormulaBasedInput_PlanRefPosition: MessageFns<FormulaBasedInput_PlanRefPosition> = {
  encode(message: FormulaBasedInput_PlanRefPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fstmt_type !== 0) {
      writer.uint32(8).int32(message.fstmt_type);
    }
    if (message.ref_id_plan_position !== "") {
      writer.uint32(18).string(message.ref_id_plan_position);
    }
    if (message.offset_in_months !== 0) {
      writer.uint32(24).int32(message.offset_in_months);
    }
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(42).fork()).join();
    }
    if (message.fpna_period !== undefined) {
      StcsFpnaPeriod.encode(message.fpna_period, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FormulaBasedInput_PlanRefPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFormulaBasedInput_PlanRefPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fstmt_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_plan_position = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.offset_in_months = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fpna_period = StcsFpnaPeriod.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FormulaBasedInput_PlanRefPosition {
    return {
      fstmt_type: isSet(object.fstmt_type) ? stcsFstmtEnumFromJSON(object.fstmt_type) : 0,
      ref_id_plan_position: isSet(object.ref_id_plan_position) ? globalThis.String(object.ref_id_plan_position) : "",
      offset_in_months: isSet(object.offset_in_months) ? globalThis.Number(object.offset_in_months) : 0,
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
      fpna_period: isSet(object.fpna_period) ? StcsFpnaPeriod.fromJSON(object.fpna_period) : undefined,
    };
  },

  toJSON(message: FormulaBasedInput_PlanRefPosition): unknown {
    const obj: any = {};
    if (message.fstmt_type !== 0) {
      obj.fstmt_type = stcsFstmtEnumToJSON(message.fstmt_type);
    }
    if (message.ref_id_plan_position !== "") {
      obj.ref_id_plan_position = message.ref_id_plan_position;
    }
    if (message.offset_in_months !== 0) {
      obj.offset_in_months = Math.round(message.offset_in_months);
    }
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    if (message.fpna_period !== undefined) {
      obj.fpna_period = StcsFpnaPeriod.toJSON(message.fpna_period);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FormulaBasedInput_PlanRefPosition>, I>>(
    base?: I,
  ): FormulaBasedInput_PlanRefPosition {
    return FormulaBasedInput_PlanRefPosition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FormulaBasedInput_PlanRefPosition>, I>>(
    object: I,
  ): FormulaBasedInput_PlanRefPosition {
    const message = createBaseFormulaBasedInput_PlanRefPosition();
    message.fstmt_type = object.fstmt_type ?? 0;
    message.ref_id_plan_position = object.ref_id_plan_position ?? "";
    message.offset_in_months = object.offset_in_months ?? 0;
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    message.fpna_period = (object.fpna_period !== undefined && object.fpna_period !== null)
      ? StcsFpnaPeriod.fromPartial(object.fpna_period)
      : undefined;
    return message;
  },
};

function createBaseFormulaBasedInput_PlanRefSubPosition(): FormulaBasedInput_PlanRefSubPosition {
  return {
    fstmt_type: 0,
    ref_id_plan_sub_position: "",
    offset_in_months: 0,
    status: undefined,
    fpna_period: undefined,
  };
}

export const FormulaBasedInput_PlanRefSubPosition: MessageFns<FormulaBasedInput_PlanRefSubPosition> = {
  encode(message: FormulaBasedInput_PlanRefSubPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fstmt_type !== 0) {
      writer.uint32(8).int32(message.fstmt_type);
    }
    if (message.ref_id_plan_sub_position !== "") {
      writer.uint32(18).string(message.ref_id_plan_sub_position);
    }
    if (message.offset_in_months !== 0) {
      writer.uint32(24).int32(message.offset_in_months);
    }
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(42).fork()).join();
    }
    if (message.fpna_period !== undefined) {
      StcsFpnaPeriod.encode(message.fpna_period, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FormulaBasedInput_PlanRefSubPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFormulaBasedInput_PlanRefSubPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fstmt_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_plan_sub_position = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.offset_in_months = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fpna_period = StcsFpnaPeriod.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FormulaBasedInput_PlanRefSubPosition {
    return {
      fstmt_type: isSet(object.fstmt_type) ? stcsFstmtEnumFromJSON(object.fstmt_type) : 0,
      ref_id_plan_sub_position: isSet(object.ref_id_plan_sub_position)
        ? globalThis.String(object.ref_id_plan_sub_position)
        : "",
      offset_in_months: isSet(object.offset_in_months) ? globalThis.Number(object.offset_in_months) : 0,
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
      fpna_period: isSet(object.fpna_period) ? StcsFpnaPeriod.fromJSON(object.fpna_period) : undefined,
    };
  },

  toJSON(message: FormulaBasedInput_PlanRefSubPosition): unknown {
    const obj: any = {};
    if (message.fstmt_type !== 0) {
      obj.fstmt_type = stcsFstmtEnumToJSON(message.fstmt_type);
    }
    if (message.ref_id_plan_sub_position !== "") {
      obj.ref_id_plan_sub_position = message.ref_id_plan_sub_position;
    }
    if (message.offset_in_months !== 0) {
      obj.offset_in_months = Math.round(message.offset_in_months);
    }
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    if (message.fpna_period !== undefined) {
      obj.fpna_period = StcsFpnaPeriod.toJSON(message.fpna_period);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FormulaBasedInput_PlanRefSubPosition>, I>>(
    base?: I,
  ): FormulaBasedInput_PlanRefSubPosition {
    return FormulaBasedInput_PlanRefSubPosition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FormulaBasedInput_PlanRefSubPosition>, I>>(
    object: I,
  ): FormulaBasedInput_PlanRefSubPosition {
    const message = createBaseFormulaBasedInput_PlanRefSubPosition();
    message.fstmt_type = object.fstmt_type ?? 0;
    message.ref_id_plan_sub_position = object.ref_id_plan_sub_position ?? "";
    message.offset_in_months = object.offset_in_months ?? 0;
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    message.fpna_period = (object.fpna_period !== undefined && object.fpna_period !== null)
      ? StcsFpnaPeriod.fromPartial(object.fpna_period)
      : undefined;
    return message;
  },
};

function createBaseFormulaBasedInput_PlanRefSelfPosition(): FormulaBasedInput_PlanRefSelfPosition {
  return { offset_in_months: 0, status: undefined, fpna_period: undefined };
}

export const FormulaBasedInput_PlanRefSelfPosition: MessageFns<FormulaBasedInput_PlanRefSelfPosition> = {
  encode(message: FormulaBasedInput_PlanRefSelfPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.offset_in_months !== 0) {
      writer.uint32(24).int32(message.offset_in_months);
    }
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(42).fork()).join();
    }
    if (message.fpna_period !== undefined) {
      StcsFpnaPeriod.encode(message.fpna_period, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FormulaBasedInput_PlanRefSelfPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFormulaBasedInput_PlanRefSelfPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.offset_in_months = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fpna_period = StcsFpnaPeriod.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FormulaBasedInput_PlanRefSelfPosition {
    return {
      offset_in_months: isSet(object.offset_in_months) ? globalThis.Number(object.offset_in_months) : 0,
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
      fpna_period: isSet(object.fpna_period) ? StcsFpnaPeriod.fromJSON(object.fpna_period) : undefined,
    };
  },

  toJSON(message: FormulaBasedInput_PlanRefSelfPosition): unknown {
    const obj: any = {};
    if (message.offset_in_months !== 0) {
      obj.offset_in_months = Math.round(message.offset_in_months);
    }
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    if (message.fpna_period !== undefined) {
      obj.fpna_period = StcsFpnaPeriod.toJSON(message.fpna_period);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FormulaBasedInput_PlanRefSelfPosition>, I>>(
    base?: I,
  ): FormulaBasedInput_PlanRefSelfPosition {
    return FormulaBasedInput_PlanRefSelfPosition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FormulaBasedInput_PlanRefSelfPosition>, I>>(
    object: I,
  ): FormulaBasedInput_PlanRefSelfPosition {
    const message = createBaseFormulaBasedInput_PlanRefSelfPosition();
    message.offset_in_months = object.offset_in_months ?? 0;
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    message.fpna_period = (object.fpna_period !== undefined && object.fpna_period !== null)
      ? StcsFpnaPeriod.fromPartial(object.fpna_period)
      : undefined;
    return message;
  },
};

function createBaseFstmtRef(): FstmtRef {
  return {
    fstmt_type: 0,
    ref_id_level: "",
    offset_in_months: 0,
    fpna_type: 0,
    fpna_period: undefined,
    status: undefined,
  };
}

export const FstmtRef: MessageFns<FstmtRef> = {
  encode(message: FstmtRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fstmt_type !== 0) {
      writer.uint32(8).int32(message.fstmt_type);
    }
    if (message.ref_id_level !== "") {
      writer.uint32(18).string(message.ref_id_level);
    }
    if (message.offset_in_months !== 0) {
      writer.uint32(24).int32(message.offset_in_months);
    }
    if (message.fpna_type !== 0) {
      writer.uint32(32).int32(message.fpna_type);
    }
    if (message.fpna_period !== undefined) {
      StcsFpnaPeriod.encode(message.fpna_period, writer.uint32(42).fork()).join();
    }
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FstmtRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFstmtRef();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fstmt_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_level = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.offset_in_months = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.fpna_type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_period = StcsFpnaPeriod.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FstmtRef {
    return {
      fstmt_type: isSet(object.fstmt_type) ? stcsFstmtEnumFromJSON(object.fstmt_type) : 0,
      ref_id_level: isSet(object.ref_id_level) ? globalThis.String(object.ref_id_level) : "",
      offset_in_months: isSet(object.offset_in_months) ? globalThis.Number(object.offset_in_months) : 0,
      fpna_type: isSet(object.fpna_type) ? stcsFpnaTypeEnumFromJSON(object.fpna_type) : 0,
      fpna_period: isSet(object.fpna_period) ? StcsFpnaPeriod.fromJSON(object.fpna_period) : undefined,
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
    };
  },

  toJSON(message: FstmtRef): unknown {
    const obj: any = {};
    if (message.fstmt_type !== 0) {
      obj.fstmt_type = stcsFstmtEnumToJSON(message.fstmt_type);
    }
    if (message.ref_id_level !== "") {
      obj.ref_id_level = message.ref_id_level;
    }
    if (message.offset_in_months !== 0) {
      obj.offset_in_months = Math.round(message.offset_in_months);
    }
    if (message.fpna_type !== 0) {
      obj.fpna_type = stcsFpnaTypeEnumToJSON(message.fpna_type);
    }
    if (message.fpna_period !== undefined) {
      obj.fpna_period = StcsFpnaPeriod.toJSON(message.fpna_period);
    }
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FstmtRef>, I>>(base?: I): FstmtRef {
    return FstmtRef.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FstmtRef>, I>>(object: I): FstmtRef {
    const message = createBaseFstmtRef();
    message.fstmt_type = object.fstmt_type ?? 0;
    message.ref_id_level = object.ref_id_level ?? "";
    message.offset_in_months = object.offset_in_months ?? 0;
    message.fpna_type = object.fpna_type ?? 0;
    message.fpna_period = (object.fpna_period !== undefined && object.fpna_period !== null)
      ? StcsFpnaPeriod.fromPartial(object.fpna_period)
      : undefined;
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    return message;
  },
};

function createBaseFstmtRefAgg(): FstmtRefAgg {
  return {
    fstmt_type: 0,
    ref_id_level: "",
    offset_in_months: 0,
    fpna_type: 0,
    fpna_period: undefined,
    status: undefined,
  };
}

export const FstmtRefAgg: MessageFns<FstmtRefAgg> = {
  encode(message: FstmtRefAgg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fstmt_type !== 0) {
      writer.uint32(8).int32(message.fstmt_type);
    }
    if (message.ref_id_level !== "") {
      writer.uint32(18).string(message.ref_id_level);
    }
    if (message.offset_in_months !== 0) {
      writer.uint32(24).int32(message.offset_in_months);
    }
    if (message.fpna_type !== 0) {
      writer.uint32(32).int32(message.fpna_type);
    }
    if (message.fpna_period !== undefined) {
      StcsFpnaPeriod.encode(message.fpna_period, writer.uint32(42).fork()).join();
    }
    if (message.status !== undefined) {
      StcsCalcItemStatus.encode(message.status, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FstmtRefAgg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFstmtRefAgg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fstmt_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_level = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.offset_in_months = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.fpna_type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_period = StcsFpnaPeriod.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.status = StcsCalcItemStatus.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FstmtRefAgg {
    return {
      fstmt_type: isSet(object.fstmt_type) ? stcsFstmtEnumFromJSON(object.fstmt_type) : 0,
      ref_id_level: isSet(object.ref_id_level) ? globalThis.String(object.ref_id_level) : "",
      offset_in_months: isSet(object.offset_in_months) ? globalThis.Number(object.offset_in_months) : 0,
      fpna_type: isSet(object.fpna_type) ? stcsFpnaTypeEnumFromJSON(object.fpna_type) : 0,
      fpna_period: isSet(object.fpna_period) ? StcsFpnaPeriod.fromJSON(object.fpna_period) : undefined,
      status: isSet(object.status) ? StcsCalcItemStatus.fromJSON(object.status) : undefined,
    };
  },

  toJSON(message: FstmtRefAgg): unknown {
    const obj: any = {};
    if (message.fstmt_type !== 0) {
      obj.fstmt_type = stcsFstmtEnumToJSON(message.fstmt_type);
    }
    if (message.ref_id_level !== "") {
      obj.ref_id_level = message.ref_id_level;
    }
    if (message.offset_in_months !== 0) {
      obj.offset_in_months = Math.round(message.offset_in_months);
    }
    if (message.fpna_type !== 0) {
      obj.fpna_type = stcsFpnaTypeEnumToJSON(message.fpna_type);
    }
    if (message.fpna_period !== undefined) {
      obj.fpna_period = StcsFpnaPeriod.toJSON(message.fpna_period);
    }
    if (message.status !== undefined) {
      obj.status = StcsCalcItemStatus.toJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FstmtRefAgg>, I>>(base?: I): FstmtRefAgg {
    return FstmtRefAgg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FstmtRefAgg>, I>>(object: I): FstmtRefAgg {
    const message = createBaseFstmtRefAgg();
    message.fstmt_type = object.fstmt_type ?? 0;
    message.ref_id_level = object.ref_id_level ?? "";
    message.offset_in_months = object.offset_in_months ?? 0;
    message.fpna_type = object.fpna_type ?? 0;
    message.fpna_period = (object.fpna_period !== undefined && object.fpna_period !== null)
      ? StcsFpnaPeriod.fromPartial(object.fpna_period)
      : undefined;
    message.status = (object.status !== undefined && object.status !== null)
      ? StcsCalcItemStatus.fromPartial(object.status)
      : undefined;
    return message;
  },
};

function createBaseStcsFpnaPeriod(): StcsFpnaPeriod {
  return { in_months: 0, agg_method: 0 };
}

export const StcsFpnaPeriod: MessageFns<StcsFpnaPeriod> = {
  encode(message: StcsFpnaPeriod, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.in_months !== 0) {
      writer.uint32(16).int32(message.in_months);
    }
    if (message.agg_method !== 0) {
      writer.uint32(24).int32(message.agg_method);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsFpnaPeriod {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsFpnaPeriod();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.in_months = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.agg_method = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsFpnaPeriod {
    return {
      in_months: isSet(object.in_months) ? globalThis.Number(object.in_months) : 0,
      agg_method: isSet(object.agg_method) ? stcsFpnaAggregationEnumFromJSON(object.agg_method) : 0,
    };
  },

  toJSON(message: StcsFpnaPeriod): unknown {
    const obj: any = {};
    if (message.in_months !== 0) {
      obj.in_months = Math.round(message.in_months);
    }
    if (message.agg_method !== 0) {
      obj.agg_method = stcsFpnaAggregationEnumToJSON(message.agg_method);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsFpnaPeriod>, I>>(base?: I): StcsFpnaPeriod {
    return StcsFpnaPeriod.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsFpnaPeriod>, I>>(object: I): StcsFpnaPeriod {
    const message = createBaseStcsFpnaPeriod();
    message.in_months = object.in_months ?? 0;
    message.agg_method = object.agg_method ?? 0;
    return message;
  },
};

function createBaseStcsCompPlanCfgList(): StcsCompPlanCfgList {
  return { list: [] };
}

export const StcsCompPlanCfgList: MessageFns<StcsCompPlanCfgList> = {
  encode(message: StcsCompPlanCfgList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.list) {
      StcsCompPlanCfgList_StcsCompPlanCfgListItem.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfgList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfgList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.list.push(StcsCompPlanCfgList_StcsCompPlanCfgListItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfgList {
    return {
      list: globalThis.Array.isArray(object?.list)
        ? object.list.map((e: any) => StcsCompPlanCfgList_StcsCompPlanCfgListItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StcsCompPlanCfgList): unknown {
    const obj: any = {};
    if (message.list?.length) {
      obj.list = message.list.map((e) => StcsCompPlanCfgList_StcsCompPlanCfgListItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfgList>, I>>(base?: I): StcsCompPlanCfgList {
    return StcsCompPlanCfgList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfgList>, I>>(object: I): StcsCompPlanCfgList {
    const message = createBaseStcsCompPlanCfgList();
    message.list = object.list?.map((e) => StcsCompPlanCfgList_StcsCompPlanCfgListItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStcsCompPlanCfgList_StcsCompPlanCfgListItem(): StcsCompPlanCfgList_StcsCompPlanCfgListItem {
  return {
    display_name: "",
    fpna_begin_date_string: "",
    fpna_end_date_string: "",
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
    ref_id_comp_plan_cfg: "",
    ref_id_comp_plan_cfg_template: "",
    is_draft: false,
    version: "",
  };
}

export const StcsCompPlanCfgList_StcsCompPlanCfgListItem: MessageFns<StcsCompPlanCfgList_StcsCompPlanCfgListItem> = {
  encode(
    message: StcsCompPlanCfgList_StcsCompPlanCfgListItem,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.display_name !== "") {
      writer.uint32(10).string(message.display_name);
    }
    if (message.fpna_begin_date_string !== "") {
      writer.uint32(18).string(message.fpna_begin_date_string);
    }
    if (message.fpna_end_date_string !== "") {
      writer.uint32(26).string(message.fpna_end_date_string);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(34).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(42).string(message.obj_updated_iso_utc);
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      writer.uint32(50).string(message.ref_id_comp_plan_cfg);
    }
    if (message.ref_id_comp_plan_cfg_template !== "") {
      writer.uint32(58).string(message.ref_id_comp_plan_cfg_template);
    }
    if (message.is_draft !== false) {
      writer.uint32(72).bool(message.is_draft);
    }
    if (message.version !== "") {
      writer.uint32(90).string(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanCfgList_StcsCompPlanCfgListItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanCfgList_StcsCompPlanCfgListItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fpna_begin_date_string = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fpna_end_date_string = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ref_id_comp_plan_cfg = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ref_id_comp_plan_cfg_template = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.is_draft = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.version = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanCfgList_StcsCompPlanCfgListItem {
    return {
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      fpna_begin_date_string: isSet(object.fpna_begin_date_string)
        ? globalThis.String(object.fpna_begin_date_string)
        : "",
      fpna_end_date_string: isSet(object.fpna_end_date_string) ? globalThis.String(object.fpna_end_date_string) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      ref_id_comp_plan_cfg: isSet(object.ref_id_comp_plan_cfg) ? globalThis.String(object.ref_id_comp_plan_cfg) : "",
      ref_id_comp_plan_cfg_template: isSet(object.ref_id_comp_plan_cfg_template)
        ? globalThis.String(object.ref_id_comp_plan_cfg_template)
        : "",
      is_draft: isSet(object.is_draft) ? globalThis.Boolean(object.is_draft) : false,
      version: isSet(object.version) ? globalThis.String(object.version) : "",
    };
  },

  toJSON(message: StcsCompPlanCfgList_StcsCompPlanCfgListItem): unknown {
    const obj: any = {};
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.fpna_begin_date_string !== "") {
      obj.fpna_begin_date_string = message.fpna_begin_date_string;
    }
    if (message.fpna_end_date_string !== "") {
      obj.fpna_end_date_string = message.fpna_end_date_string;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      obj.ref_id_comp_plan_cfg = message.ref_id_comp_plan_cfg;
    }
    if (message.ref_id_comp_plan_cfg_template !== "") {
      obj.ref_id_comp_plan_cfg_template = message.ref_id_comp_plan_cfg_template;
    }
    if (message.is_draft !== false) {
      obj.is_draft = message.is_draft;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanCfgList_StcsCompPlanCfgListItem>, I>>(
    base?: I,
  ): StcsCompPlanCfgList_StcsCompPlanCfgListItem {
    return StcsCompPlanCfgList_StcsCompPlanCfgListItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanCfgList_StcsCompPlanCfgListItem>, I>>(
    object: I,
  ): StcsCompPlanCfgList_StcsCompPlanCfgListItem {
    const message = createBaseStcsCompPlanCfgList_StcsCompPlanCfgListItem();
    message.display_name = object.display_name ?? "";
    message.fpna_begin_date_string = object.fpna_begin_date_string ?? "";
    message.fpna_end_date_string = object.fpna_end_date_string ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.ref_id_comp_plan_cfg = object.ref_id_comp_plan_cfg ?? "";
    message.ref_id_comp_plan_cfg_template = object.ref_id_comp_plan_cfg_template ?? "";
    message.is_draft = object.is_draft ?? false;
    message.version = object.version ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
